/* eslint-disable */
// ============================================================
// Auto-generated by scripts/generate-help.mjs — do not edit.
// Run `npm run build` or `npm run generate-help` to regenerate.
// ============================================================

export interface MethodParam {
  name: string;
  type: string;
  description: string;
}

export interface MethodHelpDoc {
  typeName: string;
  methodName: string;
  /** Full TypeScript signature without the trailing semicolon */
  signature: string;
  description: string;
  params: MethodParam[];
  returns: string;
}

export const helpMetadata: MethodHelpDoc[] = [
  {
    typeName: "Admin",
    methodName: "generateRfc7523AuthZGrantArtefacts",
    signature: "generateRfc7523AuthZGrantArtefacts( clientId: string, iss: string, jwk?: JwkRsa, sub?: string, scope?: string[], options?: { save: boolean } ): Promise<{ jwk: JwkRsa",
    description: "",
    params: [],
    returns: "",
  },
  {
    typeName: "Agent",
    methodName: "readAgentTypes",
    signature: "readAgentTypes(): Promise<AgentType[]>",
    description: "Read all agent types.",
    params: [],
    returns: "{Promise<AgentType[]>} a promise that resolves to an array of agent type strings",
  },
  {
    typeName: "Agent",
    methodName: "readAgentByTypeAndId",
    signature: "readAgentByTypeAndId( agentType: AgentType, agentId: string ): Promise<AgentSkeleton>",
    description: "Read agent by type and id",
    params: [
      { name: "agentType", type: "string", description: "agent type (IdentityGatewayAgent, J2EEAgent, WebAgent)" },
      { name: "agentId", type: "string", description: "agent id/name" },
    ],
    returns: "{Promise<AgentSkeleton>} a promise that resolves to an agent object",
  },
  {
    typeName: "Agent",
    methodName: "readAgents",
    signature: "readAgents(globalConfig: boolean): Promise<AgentSkeleton[]>",
    description: "Read all agents.",
    params: [
      { name: "globalConfig", type: "boolean", description: "true if global agent is the target of the operation, false otherwise. Default: false." },
    ],
    returns: "{Promise<AgentSkeleton[]>} a promise that resolves to an array of agent objects",
  },
  {
    typeName: "Agent",
    methodName: "readAgent",
    signature: "readAgent(agentId: string, globalConfig: boolean): Promise<AgentSkeleton>",
    description: "Read agent",
    params: [
      { name: "agentId", type: "string", description: "agent id/name" },
      { name: "globalConfig", type: "boolean", description: "true if global agent is the target of the operation, false otherwise. Default: false." },
    ],
    returns: "{Promise<AgentSkeleton>} a promise that resolves to an agent object",
  },
  {
    typeName: "Agent",
    methodName: "deleteAgents",
    signature: "deleteAgents(): Promise<void>",
    description: "Delete all agents",
    params: [],
    returns: "",
  },
  {
    typeName: "Agent",
    methodName: "deleteAgent",
    signature: "deleteAgent(agentId: string): Promise<void>",
    description: "Delete agent",
    params: [
      { name: "agentId", type: "", description: "agent id/name" },
    ],
    returns: "",
  },
  {
    typeName: "Agent",
    methodName: "exportAgents",
    signature: "exportAgents(globalConfig: boolean): Promise<AgentExportInterface>",
    description: "Export all agents. The response can be saved to file as is.",
    params: [
      { name: "globalConfig", type: "boolean", description: "true if global agent is the target of the operation, false otherwise. Default: false." },
    ],
    returns: "{Promise<AgentExportInterface>} Promise resolving to an AgentExportInterface object.",
  },
  {
    typeName: "Agent",
    methodName: "exportAgent",
    signature: "exportAgent( agentId: string, globalConfig: boolean ): Promise<AgentExportInterface>",
    description: "Export agent. The response can be saved to file as is.",
    params: [
      { name: "agentId", type: "", description: "agent id/name" },
      { name: "globalConfig", type: "boolean", description: "true if global agent is the target of the operation, false otherwise. Default: false." },
    ],
    returns: "{Promise<AgentExportInterface>} Promise resolving to an AgentExportInterface object.",
  },
  {
    typeName: "Agent",
    methodName: "importAgents",
    signature: "importAgents( importData: AgentExportInterface, globalConfig: boolean ): Promise<AgentSkeleton[]>",
    description: "Import agents. The import data is usually read from an agent export file.",
    params: [
      { name: "globalConfig", type: "boolean", description: "true if global agent is the target of the operation, false otherwise. Default: false." },
      { name: "importData", type: "AgentExportInterface", description: "agent import data." },
    ],
    returns: "{Promise<AgentSkeleton[]>} The agents that were imported.",
  },
  {
    typeName: "Agent",
    methodName: "importAgent",
    signature: "importAgent( agentId: string, importData: AgentExportInterface, globalConfig: boolean ): Promise<AgentSkeleton>",
    description: "Import agent. The import data is usually read from an agent export file.",
    params: [
      { name: "agentId", type: "string", description: "agent id/name" },
      { name: "importData", type: "AgentExportInterface", description: "agent import data." },
      { name: "globalConfig", type: "boolean", description: "true if global agent is the target of the operation, false otherwise. Default: false." },
    ],
    returns: "{Promise<AgentSkeleton>} Promise resolving to an agent object.",
  },
  {
    typeName: "Agent",
    methodName: "readIdentityGatewayAgents",
    signature: "readIdentityGatewayAgents(): Promise<AgentSkeleton[]>",
    description: "Read identity gateway agents",
    params: [],
    returns: "{Promise<AgentSkeleton[]>} a promise that resolves to an array of IdentityGatewayAgent objects",
  },
  {
    typeName: "Agent",
    methodName: "readIdentityGatewayAgent",
    signature: "readIdentityGatewayAgent(gatewayId: string): Promise<AgentSkeleton>",
    description: "Read identity gateway agent",
    params: [
      { name: "gatewayId", type: "string", description: "gateway id" },
    ],
    returns: "{Promise<AgentSkeleton>} a promise that resolves to an object containing an IdentityGatewayAgent object",
  },
  {
    typeName: "Agent",
    methodName: "createIdentityGatewayAgent",
    signature: "createIdentityGatewayAgent( gatewayId: string, gatewayData: AgentSkeleton ): Promise<AgentSkeleton>",
    description: "Create identity gateway agent",
    params: [
      { name: "gatewayId", type: "string", description: "gateway id" },
      { name: "gatewayData", type: "AgentSkeleton", description: "IdentityGatewayAgent object" },
    ],
    returns: "{Promise<AgentSkeleton>} a promise that resolves to an object containing an IdentityGatewayAgent object",
  },
  {
    typeName: "Agent",
    methodName: "updateIdentityGatewayAgent",
    signature: "updateIdentityGatewayAgent( gatewayId: string, gatewayData: AgentSkeleton ): Promise<AgentSkeleton>",
    description: "Update or create identity gateway agent",
    params: [
      { name: "gatewayId", type: "string", description: "gateway id" },
      { name: "gatewayData", type: "AgentSkeleton", description: "IdentityGatewayAgent object" },
    ],
    returns: "{Promise<AgentSkeleton>} a promise that resolves to an object containing an IdentityGatewayAgent object",
  },
  {
    typeName: "Agent",
    methodName: "deleteIdentityGatewayAgents",
    signature: "deleteIdentityGatewayAgents(): Promise<void>",
    description: "Delete all identity gateway agents",
    params: [],
    returns: "",
  },
  {
    typeName: "Agent",
    methodName: "deleteIdentityGatewayAgent",
    signature: "deleteIdentityGatewayAgent(agentId: string): Promise<void>",
    description: "Delete identity gateway agent",
    params: [
      { name: "agentId", type: "", description: "agent id/name" },
    ],
    returns: "",
  },
  {
    typeName: "Agent",
    methodName: "exportIdentityGatewayAgents",
    signature: "exportIdentityGatewayAgents(): Promise<AgentExportInterface>",
    description: "Export all identity gateway agents. The response can be saved to file as is.",
    params: [],
    returns: "{Promise<AgentExportInterface>} Promise resolving to an AgentExportInterface object.",
  },
  {
    typeName: "Agent",
    methodName: "exportIdentityGatewayAgent",
    signature: "exportIdentityGatewayAgent(agentId: string): Promise<AgentExportInterface>",
    description: "Export identity gateway agent. The response can be saved to file as is.",
    params: [
      { name: "agentId", type: "", description: "agent id/name" },
    ],
    returns: "{Promise<AgentExportInterface>} Promise resolving to an AgentExportInterface object.",
  },
  {
    typeName: "Agent",
    methodName: "importIdentityGatewayAgents",
    signature: "importIdentityGatewayAgents(importData: AgentExportInterface): Promise<void>",
    description: "Import identity gateway agents. The import data is usually read from an agent export file.",
    params: [
      { name: "importData", type: "AgentExportInterface", description: "agent import data." },
    ],
    returns: "",
  },
  {
    typeName: "Agent",
    methodName: "importIdentityGatewayAgent",
    signature: "importIdentityGatewayAgent( agentId: string, importData: AgentExportInterface ): Promise<AgentSkeleton>",
    description: "Import identity gateway agent. The import data is usually read from an agent export file.",
    params: [
      { name: "agentId", type: "string", description: "agent id/name" },
      { name: "importData", type: "AgentExportInterface", description: "agent import data." },
    ],
    returns: "{Promise<AgentSkeleton>} Promise resolving to an agent object.",
  },
  {
    typeName: "Agent",
    methodName: "readJavaAgents",
    signature: "readJavaAgents(): Promise<AgentSkeleton[]>",
    description: "Read java agents",
    params: [],
    returns: "{Promise<AgentSkeleton[]>} a promise that resolves to an array of J2EEAgent objects",
  },
  {
    typeName: "Agent",
    methodName: "readJavaAgent",
    signature: "readJavaAgent(agentId: string): Promise<AgentSkeleton>",
    description: "Read java agent",
    params: [
      { name: "agentId", type: "string", description: "java agent id" },
    ],
    returns: "{Promise<AgentSkeleton>} a promise that resolves to an object containing an J2EEAgent object",
  },
  {
    typeName: "Agent",
    methodName: "createJavaAgent",
    signature: "createJavaAgent( agentId: string, agentData: AgentSkeleton ): Promise<AgentSkeleton>",
    description: "Create java agent",
    params: [
      { name: "agentId", type: "string", description: "java agent id" },
      { name: "agentData", type: "AgentSkeleton", description: "java agent object" },
    ],
    returns: "{Promise<AgentSkeleton>} a promise that resolves to an object containing an java agent object",
  },
  {
    typeName: "Agent",
    methodName: "updateJavaAgent",
    signature: "updateJavaAgent( agentId: string, agentData: AgentSkeleton ): Promise<AgentSkeleton>",
    description: "Update or create java agent",
    params: [
      { name: "agentId", type: "string", description: "java agent id" },
      { name: "agentData", type: "AgentSkeleton", description: "java agent object" },
    ],
    returns: "{Promise<AgentSkeleton>} a promise that resolves to an object containing an java agent object",
  },
  {
    typeName: "Agent",
    methodName: "deleteJavaAgents",
    signature: "deleteJavaAgents(): Promise<void>",
    description: "Delete all java agents",
    params: [],
    returns: "",
  },
  {
    typeName: "Agent",
    methodName: "deleteJavaAgent",
    signature: "deleteJavaAgent(agentId: string): Promise<void>",
    description: "Delete java agent",
    params: [
      { name: "agentId", type: "", description: "agent id/name" },
    ],
    returns: "",
  },
  {
    typeName: "Agent",
    methodName: "exportJavaAgents",
    signature: "exportJavaAgents(): Promise<AgentExportInterface>",
    description: "Export all java agents. The response can be saved to file as is.",
    params: [],
    returns: "{Promise<AgentExportInterface>} Promise resolving to an AgentExportInterface object.",
  },
  {
    typeName: "Agent",
    methodName: "exportJavaAgent",
    signature: "exportJavaAgent(agentId: string): Promise<AgentExportInterface>",
    description: "Export java agent. The response can be saved to file as is.",
    params: [
      { name: "agentId", type: "", description: "agent id/name" },
    ],
    returns: "{Promise<AgentExportInterface>} Promise resolving to an AgentExportInterface object.",
  },
  {
    typeName: "Agent",
    methodName: "importJavaAgents",
    signature: "importJavaAgents(importData: AgentExportInterface): Promise<void>",
    description: "Import java agents. The import data is usually read from an agent export file.",
    params: [
      { name: "importData", type: "AgentExportInterface", description: "agent import data." },
    ],
    returns: "",
  },
  {
    typeName: "Agent",
    methodName: "importJavaAgent",
    signature: "importJavaAgent( agentId: string, importData: AgentExportInterface ): Promise<AgentSkeleton>",
    description: "Import java agent. The import data is usually read from an agent export file.",
    params: [
      { name: "agentId", type: "string", description: "agent id/name" },
      { name: "importData", type: "AgentExportInterface", description: "agent import data." },
    ],
    returns: "{Promise<AgentSkeleton>} Promise resolving to an agent object.",
  },
  {
    typeName: "Agent",
    methodName: "readWebAgents",
    signature: "readWebAgents(): Promise<AgentSkeleton[]>",
    description: "Read web agents",
    params: [],
    returns: "{Promise<AgentSkeleton[]>} a promise that resolves to an array of WebAgent objects",
  },
  {
    typeName: "Agent",
    methodName: "readWebAgent",
    signature: "readWebAgent(agentId: string): Promise<AgentSkeleton>",
    description: "Read web agent",
    params: [
      { name: "agentId", type: "string", description: "web agent id" },
    ],
    returns: "{Promise<AgentSkeleton>} a promise that resolves to an object containing an WebAgent object",
  },
  {
    typeName: "Agent",
    methodName: "createWebAgent",
    signature: "createWebAgent( agentId: string, agentData: AgentSkeleton ): Promise<AgentSkeleton>",
    description: "Create web agent",
    params: [
      { name: "agentId", type: "string", description: "web agent id" },
      { name: "agentData", type: "AgentSkeleton", description: "WebAgent object" },
    ],
    returns: "{Promise<AgentSkeleton>} a promise that resolves to an object containing an WebAgent object",
  },
  {
    typeName: "Agent",
    methodName: "updateWebAgent",
    signature: "updateWebAgent( agentId: string, agentData: AgentSkeleton ): Promise<AgentSkeleton>",
    description: "Update or create web agent",
    params: [
      { name: "agentId", type: "string", description: "web agent id" },
      { name: "agentData", type: "AgentSkeleton", description: "WebAgent object" },
    ],
    returns: "{Promise<AgentSkeleton>} a promise that resolves to an object containing an WebAgent object",
  },
  {
    typeName: "Agent",
    methodName: "deleteWebAgents",
    signature: "deleteWebAgents(): Promise<void>",
    description: "Delete all web agents",
    params: [],
    returns: "",
  },
  {
    typeName: "Agent",
    methodName: "deleteWebAgent",
    signature: "deleteWebAgent(agentId: string): Promise<void>",
    description: "Delete web agent",
    params: [
      { name: "agentId", type: "", description: "agent id/name" },
    ],
    returns: "",
  },
  {
    typeName: "Agent",
    methodName: "exportWebAgents",
    signature: "exportWebAgents(): Promise<AgentExportInterface>",
    description: "Export all web agents. The response can be saved to file as is.",
    params: [],
    returns: "{Promise<AgentExportInterface>} Promise resolving to an AgentExportInterface object.",
  },
  {
    typeName: "Agent",
    methodName: "exportWebAgent",
    signature: "exportWebAgent(agentId: string): Promise<AgentExportInterface>",
    description: "Export web agent. The response can be saved to file as is.",
    params: [
      { name: "agentId", type: "", description: "agent id/name" },
    ],
    returns: "{Promise<AgentExportInterface>} Promise resolving to an AgentExportInterface object.",
  },
  {
    typeName: "Agent",
    methodName: "importWebAgents",
    signature: "importWebAgents(importData: AgentExportInterface): Promise<void>",
    description: "Import web agents. The import data is usually read from an agent export file.",
    params: [
      { name: "importData", type: "AgentExportInterface", description: "agent import data." },
    ],
    returns: "",
  },
  {
    typeName: "Agent",
    methodName: "importWebAgent",
    signature: "importWebAgent( agentId: string, importData: AgentExportInterface ): Promise<AgentSkeleton>",
    description: "Import web agent. The import data is usually read from an agent export file.",
    params: [
      { name: "agentId", type: "string", description: "agent id/name" },
      { name: "importData", type: "AgentExportInterface", description: "agent import data." },
    ],
    returns: "{Promise<AgentSkeleton>} Promise resolving to an agent object.",
  },
  {
    typeName: "Agent",
    methodName: "readAIAgents",
    signature: "readAIAgents(includeAgentIdentity?: boolean): Promise<AgentSkeleton[]>",
    description: "Read AI agents",
    params: [
      { name: "includeAgentIdentity", type: "boolean", description: "whether to include related AI agent identity details" },
    ],
    returns: "{Promise<AgentSkeleton[]>} a promise that resolves to an array of AIAgent objects",
  },
  {
    typeName: "Agent",
    methodName: "readAIAgent",
    signature: "readAIAgent( agentId: string, includeAgentIdentity?: boolean ): Promise<AgentSkeleton>",
    description: "Read AI agent",
    params: [
      { name: "agentId", type: "string", description: "AI agent id" },
      { name: "includeAgentIdentity", type: "boolean", description: "whether to include related AI agent identity details" },
    ],
    returns: "{Promise<AgentSkeleton>} a promise that resolves to an object containing an AIAgent object",
  },
  {
    typeName: "Agent",
    methodName: "createAIAgent",
    signature: "createAIAgent( agentId: string, agentData: AgentSkeleton, includeAgentIdentity?: boolean ): Promise<AgentSkeleton>",
    description: "Create AI agent",
    params: [
      { name: "agentId", type: "string", description: "AI agent id" },
      { name: "agentData", type: "AgentSkeleton", description: "AIAgent object" },
      { name: "includeAgentIdentity", type: "boolean", description: "whether to create related AI agent identity objects" },
    ],
    returns: "{Promise<AgentSkeleton>} a promise that resolves to an object containing an AIAgent object",
  },
  {
    typeName: "Agent",
    methodName: "updateAIAgent",
    signature: "updateAIAgent( agentId: string, agentData: AgentSkeleton, includeAgentIdentity?: boolean ): Promise<AgentSkeleton>",
    description: "Update or create AI agent",
    params: [
      { name: "agentId", type: "string", description: "AI agent id" },
      { name: "agentData", type: "AgentSkeleton", description: "AIAgent object" },
      { name: "includeAgentIdentity", type: "boolean", description: "whether to update related AI agent identity objects" },
    ],
    returns: "{Promise<AgentSkeleton>} a promise that resolves to an object containing an AIAgent object",
  },
  {
    typeName: "Agent",
    methodName: "deleteAIAgents",
    signature: "deleteAIAgents(): Promise<void>",
    description: "Delete all AI agents and their agent identity and privileges",
    params: [],
    returns: "",
  },
  {
    typeName: "Agent",
    methodName: "deleteAIAgent",
    signature: "deleteAIAgent(agentId: string): Promise<void>",
    description: "Delete AI agent and agent identity and privileges",
    params: [
      { name: "agentId", type: "string", description: "agent id/name" },
    ],
    returns: "",
  },
  {
    typeName: "Agent",
    methodName: "exportAIAgents",
    signature: "exportAIAgents(): Promise<AgentExportInterface>",
    description: "Export all AI agents. The response can be saved to file as is.",
    params: [],
    returns: "{Promise<AgentExportInterface>} Promise resolving to an AgentExportInterface object.",
  },
  {
    typeName: "Agent",
    methodName: "exportAIAgent",
    signature: "exportAIAgent( agentId: string, includeAgentIdentity?: boolean ): Promise<AgentExportInterface>",
    description: "Export AI agent. The response can be saved to file as is.",
    params: [
      { name: "agentId", type: "", description: "agent id/name" },
      { name: "includeAgentIdentity", type: "boolean", description: "whether to export related AI agent identity details" },
    ],
    returns: "{Promise<AgentExportInterface>} Promise resolving to an AgentExportInterface object.",
  },
  {
    typeName: "Agent",
    methodName: "importAIAgents",
    signature: "importAIAgents( importData: AgentExportInterface, includeAgentIdentity?: boolean ): Promise<void>",
    description: "Import AI agents. The import data is usually read from an agent export file.",
    params: [
      { name: "importData", type: "AgentExportInterface", description: "agent import data." },
      { name: "includeAgentIdentity", type: "boolean", description: "whether to import related AI agent identity objects" },
    ],
    returns: "",
  },
  {
    typeName: "Agent",
    methodName: "importAIAgent",
    signature: "importAIAgent( agentId: string, importData: AgentExportInterface, includeAgentIdentity?: boolean ): Promise<AgentSkeleton>",
    description: "Import AI agent. The import data is usually read from an agent export file.",
    params: [
      { name: "agentId", type: "string", description: "agent id/name" },
      { name: "importData", type: "AgentExportInterface", description: "agent import data." },
      { name: "includeAgentIdentity", type: "boolean", description: "whether to import related AI agent identity objects" },
    ],
    returns: "{Promise<AgentSkeleton>} Promise resolving to an agent object.",
  },
  {
    typeName: "Agent",
    methodName: "readAgentGroup",
    signature: "readAgentGroup(groupId: string): Promise<AgentGroupSkeleton>",
    description: "Read agent group by id",
    params: [
      { name: "groupId", type: "string", description: "Group id" },
    ],
    returns: "{Promise<AgentGroupSkeleton>} a promise that resolves to a agent group object",
  },
  {
    typeName: "Agent",
    methodName: "readAgentGroups",
    signature: "readAgentGroups(): Promise<AgentGroupSkeleton[]>",
    description: "Read all agent groups.",
    params: [],
    returns: "{Promise<AgentGroupSkeleton[]>} a promise that resolves to an array of agent group objects",
  },
  {
    typeName: "Agent",
    methodName: "exportAgentGroup",
    signature: "exportAgentGroup(groupId: string): Promise<AgentGroupExportInterface>",
    description: "Export a single agent group by id. The response can be saved to file as is.",
    params: [
      { name: "groupId", type: "string", description: "Group id" },
    ],
    returns: "{Promise<AgentGroupExportInterface>} Promise resolving to a AgentGroupExportInterface object.",
  },
  {
    typeName: "Agent",
    methodName: "exportAgentGroups",
    signature: "exportAgentGroups(): Promise<AgentGroupExportInterface>",
    description: "Export all agent groups. The response can be saved to file as is.",
    params: [],
    returns: "{Promise<AgentGroupExportInterface>} Promise resolving to a AgentGroupExportInterface object.",
  },
  {
    typeName: "Agent",
    methodName: "importAgentGroups",
    signature: "importAgentGroups( importData: AgentGroupExportInterface ): Promise<AgentGroupSkeleton[]>",
    description: "Import agents groups. The import data is usually read from an agent group export file.",
    params: [
      { name: "importData", type: "AgentExportInterface", description: "agent import data." },
    ],
    returns: "{Promise<AgentGroupSkeleton[]>} The agent groups that were imported.",
  },
  {
    typeName: "Agent",
    methodName: "importAgentGroup",
    signature: "importAgentGroup( agentGroupId: string, importData: AgentGroupExportInterface ): Promise<AgentGroupSkeleton>",
    description: "Import agent group. The import data is usually read from an agent group export file.",
    params: [
      { name: "agentGroupId", type: "string", description: "agent group id/name" },
      { name: "importData", type: "AgentGroupExportInterface", description: "agent group import data." },
    ],
    returns: "{Promise<AgentGroupSkeleton>} Promise resolving to an agent group object.",
  },
  {
    typeName: "Agent",
    methodName: "createAgentExportTemplate",
    signature: "createAgentExportTemplate(): AgentExportInterface",
    description: "Create an empty agent export template",
    params: [],
    returns: "{AgentExportInterface} an empty agent export template",
  },
  {
    typeName: "Agent",
    methodName: "createAgentGroupExportTemplate",
    signature: "createAgentGroupExportTemplate(): AgentGroupExportInterface",
    description: "Create an empty agent group export template",
    params: [],
    returns: "{AgentGroupExportInterface} an empty agent export template",
  },
  {
    typeName: "AmConfig",
    methodName: "createConfigEntityExportTemplate",
    signature: "createConfigEntityExportTemplate( realms?: string[] ): Promise<ConfigEntityExportInterface>",
    description: "Create an empty config entity export template",
    params: [],
    returns: "{Promise<ConfigEntityExportInterface>} an empty config entity export template",
  },
  {
    typeName: "AmConfig",
    methodName: "exportAmConfigEntities",
    signature: "exportAmConfigEntities( includeReadOnly: boolean, onlyRealm: boolean, onlyGlobal: boolean, resultCallback?: ResultCallback<AmConfigEntityInterface> ): Promise<ConfigEntityExportInterface>",
    description: "Export all other AM config entities",
    params: [
      { name: "includeReadOnly", type: "boolean", description: "Include read only config in the export" },
      { name: "onlyRealm", type: "boolean", description: "Export config only from the active realm. If onlyGlobal is also active, then it will also export the global config." },
      { name: "onlyGlobal", type: "boolean", description: "Export global config only. If onlyRealm is also active, then it will also export the active realm config." },
      { name: "resultCallback", type: "ResultCallback", description: "Optional callback to process individual results" },
    ],
    returns: "{Promise<ConfigEntityExportInterface>} promise resolving to a ConfigEntityExportInterface object",
  },
  {
    typeName: "AmConfig",
    methodName: "importAmConfigEntities",
    signature: "importAmConfigEntities( importData: ConfigEntityExportInterface, resultCallback?: ResultCallback<AmConfigEntityInterface> ): Promise<ConfigSkeleton | null>",
    description: "Import all other AM config entities",
    params: [
      { name: "importData", type: "ConfigEntityExportInterface", description: "The config import data" },
      { name: "resultCallback", type: "ResultCallback", description: "Optional callback to process individual results" },
    ],
    returns: "{Promise<ConfigSkeleton | null>} a promise that resolves to a config object containing global and realm config entities, or null if no import was performed",
  },
  {
    typeName: "ApiFactory",
    methodName: "generateAmApi",
    signature: "generateAmApi( resource: ResourceConfig, requestOverride?: AxiosRequestConfig ): AxiosInstance",
    description: "Generates an AM Axios API instance",
    params: [
      { name: "resource", type: "ResourceConfig", description: "Takes an object takes a resource object. example:" },
      { name: "requestOverride", type: "AxiosRequestConfig", description: "Takes an object of AXIOS parameters that can be used to either" },
    ],
    returns: "{AxiosInstance} Returns a reaady to use Axios instance",
  },
  {
    typeName: "ApiFactory",
    methodName: "generateOauth2Api",
    signature: "generateOauth2Api( resource: ResourceConfig, requestOverride?: AxiosRequestConfig, authenticate?: boolean ): AxiosInstance",
    description: "Generates an OAuth2 Axios API instance",
    params: [
      { name: "resource", type: "ResourceConfig", description: "Takes a resource object. example:" },
      { name: "requestOverride", type: "AxiosRequestConfig", description: "Takes an object of AXIOS parameters that can be used to either" },
    ],
    returns: "{AxiosInstance} Returns a reaady to use Axios instance",
  },
  {
    typeName: "ApiFactory",
    methodName: "generateIdmApi",
    signature: "generateIdmApi(requestOverride?: AxiosRequestConfig): AxiosInstance",
    description: "Generates an IDM Axios API instance",
    params: [
      { name: "requestOverride", type: "AxiosRequestConfig", description: "Takes an object of AXIOS parameters that can be used to either add" },
    ],
    returns: "{AxiosInstance} Returns a reaady to use Axios instance",
  },
  {
    typeName: "ApiFactory",
    methodName: "generateLogKeysApi",
    signature: "generateLogKeysApi(requestOverride?: AxiosRequestConfig): AxiosInstance",
    description: "Generates a LogKeys API Axios instance",
    params: [
      { name: "requestOverride", type: "AxiosRequestConfig", description: "Takes an object of AXIOS parameters that can be used to either add" },
    ],
    returns: "{AxiosInstance} Returns a reaady to use Axios instance",
  },
  {
    typeName: "ApiFactory",
    methodName: "generateLogApi",
    signature: "generateLogApi(requestOverride?: AxiosRequestConfig): AxiosInstance",
    description: "Generates a Log API Axios instance",
    params: [
      { name: "requestOverride", type: "AxiosRequestConfig", description: "Takes an object of AXIOS parameters that can be used to either add" },
    ],
    returns: "{AxiosInstance} Returns a reaady to use Axios instance",
  },
  {
    typeName: "ApiFactory",
    methodName: "generateEnvApi",
    signature: "generateEnvApi( resource: ResourceConfig, requestOverride?: AxiosRequestConfig ): AxiosInstance",
    description: "Generates an Axios instance for the Identity Cloud Environment API",
    params: [
      { name: "resource", type: "ResourceConfig", description: "Resource config object." },
      { name: "requestOverride", type: "AxiosRequestConfig", description: "Takes an object of AXIOS parameters that can be used to either add" },
    ],
    returns: "{AxiosInstance} Returns a reaady to use Axios instance",
  },
  {
    typeName: "ApiFactory",
    methodName: "generateGovernanceApi",
    signature: "generateGovernanceApi( resource: ResourceConfig, requestOverride?: AxiosRequestConfig ): AxiosInstance",
    description: "Generates an Axios instance for the Identity Cloud Governance API",
    params: [
      { name: "resource", type: "ResourceConfig", description: "Resource config object." },
      { name: "requestOverride", type: "AxiosRequestConfig", description: "Takes an object of AXIOS parameters that can be used to either add" },
    ],
    returns: "{AxiosInstance} Returns a reaady to use Axios instance",
  },
  {
    typeName: "ApiFactory",
    methodName: "generateReleaseApi",
    signature: "generateReleaseApi( baseUrl: string, requestOverride?: AxiosRequestConfig ): AxiosInstance",
    description: "Generates a release (Github or Npm) Axios API instance",
    params: [
      { name: "baseUrl", type: "string", description: "Base URL for the request" },
      { name: "requestOverride", type: "AxiosRequestConfig", description: "Takes an object of AXIOS parameters that can be used to either add" },
    ],
    returns: "{AxiosInstance} Returns a reaady to use Axios instance",
  },
  {
    typeName: "Application",
    methodName: "createApplicationExportTemplate",
    signature: "createApplicationExportTemplate(): ApplicationExportInterface",
    description: "Create an empty application export template",
    params: [],
    returns: "{ApplicationExportInterface} an empty application export template",
  },
  {
    typeName: "Application",
    methodName: "getRealmManagedApplication",
    signature: "getRealmManagedApplication(): string",
    description: "Get application managed object type",
    params: [],
    returns: "{String} application managed object type in this realm",
  },
  {
    typeName: "Application",
    methodName: "createApplication",
    signature: "createApplication( applicationId: string, applicationData: ApplicationGlossarySkeleton ): Promise<ApplicationGlossarySkeleton>",
    description: "Create application",
    params: [
      { name: "applicationId", type: "string", description: "application id/name" },
      { name: "applicationData", type: "ApplicationGlossarySkeleton", description: "application data" },
    ],
    returns: "{Promise<ApplicationGlossarySkeleton>} a promise that resolves to an application object",
  },
  {
    typeName: "Application",
    methodName: "readApplication",
    signature: "readApplication(applicationId: string): Promise<ApplicationSkeleton>",
    description: "Read application",
    params: [
      { name: "applicationId", type: "string", description: "application uuid" },
    ],
    returns: "{Promise<ApplicationSkeleton>} a promise that resolves to an application object",
  },
  {
    typeName: "Application",
    methodName: "readApplicationByName",
    signature: "readApplicationByName(applicationName: string): Promise<ApplicationSkeleton>",
    description: "Read application by name",
    params: [
      { name: "applicationName", type: "string", description: "application name" },
    ],
    returns: "{Promise<ApplicationSkeleton>} a promise that resolves to an application object",
  },
  {
    typeName: "Application",
    methodName: "readApplications",
    signature: "readApplications(): Promise<ApplicationSkeleton[]>",
    description: "Read all applications. Results are sorted aphabetically.",
    params: [],
    returns: "{Promise<ApplicationSkeleton[]>} a promise that resolves to an array of application objects",
  },
  {
    typeName: "Application",
    methodName: "updateApplication",
    signature: "updateApplication( applicationId: string, applicationData: ApplicationSkeleton ): Promise<ApplicationSkeleton>",
    description: "Update application",
    params: [
      { name: "applicationId", type: "string", description: "application uuid" },
      { name: "applicationData", type: "ApplicationSkeleton", description: "application data" },
    ],
    returns: "{Promise<ApplicationSkeleton>} a promise that resolves to an application object",
  },
  {
    typeName: "Application",
    methodName: "deleteApplication",
    signature: "deleteApplication( applicationId: string, deep?: boolean ): Promise<ApplicationGlossarySkeleton>",
    description: "Delete application",
    params: [
      { name: "applicationId", type: "string", description: "application uuid" },
      { name: "deep", type: "boolean", description: "deep delete (remove dependencies)" },
    ],
    returns: "{Promise<ApplicationGlossarySkeleton>} a promise that resolves to an application object",
  },
  {
    typeName: "Application",
    methodName: "deleteApplicationByName",
    signature: "deleteApplicationByName( applicationName: string, deep?: boolean ): Promise<ApplicationGlossarySkeleton>",
    description: "Delete application by name",
    params: [
      { name: "applicationName", type: "string", description: "application name" },
      { name: "deep", type: "boolean", description: "deep delete (remove dependencies)" },
    ],
    returns: "{Promise<ApplicationGlossarySkeleton>} a promise that resolves to an application object",
  },
  {
    typeName: "Application",
    methodName: "deleteApplications",
    signature: "deleteApplications(deep?: boolean): Promise<ApplicationGlossarySkeleton[]>",
    description: "Delete all applications",
    params: [
      { name: "deep", type: "boolean", description: "deep delete (remove dependencies)" },
    ],
    returns: "{Promise<ApplicationGlossarySkeleton[]>} a promise that resolves to an array of application objects",
  },
  {
    typeName: "Application",
    methodName: "queryApplications",
    signature: "queryApplications( filter: string, fields?: string[] ): Promise<ApplicationSkeleton[]>",
    description: "Query applications",
    params: [
      { name: "filter", type: "", description: "CREST search filter" },
      { name: "fields", type: "", description: "array of fields to return" },
    ],
    returns: "",
  },
  {
    typeName: "Application",
    methodName: "exportApplication",
    signature: "exportApplication( applicationId: string, options: ApplicationExportOptions ): Promise<ApplicationExportInterface>",
    description: "Export application. The response can be saved to file as is.",
    params: [
      { name: "applicationId", type: "string", description: "application uuid" },
      { name: "options", type: "ApplicationExportOptions", description: "export options" },
    ],
    returns: "{Promise<ApplicationExportInterface>} Promise resolving to an ApplicationExportInterface object.",
  },
  {
    typeName: "Application",
    methodName: "exportApplicationByName",
    signature: "exportApplicationByName( applicationName: string, options: ApplicationExportOptions ): Promise<ApplicationExportInterface>",
    description: "Export application by name. The response can be saved to file as is.",
    params: [
      { name: "applicationName", type: "string", description: "application name" },
      { name: "options", type: "ApplicationExportOptions", description: "export options" },
    ],
    returns: "{Promise<ApplicationExportInterface>} Promise resolving to an ApplicationExportInterface object.",
  },
  {
    typeName: "Application",
    methodName: "exportApplications",
    signature: "exportApplications( options?: ApplicationExportOptions ): Promise<ApplicationExportInterface>",
    description: "Export all applications. The response can be saved to file as is.",
    params: [],
    returns: "{Promise<ApplicationExportInterface>} Promise resolving to an ApplicationExportInterface object.",
  },
  {
    typeName: "Application",
    methodName: "importApplication",
    signature: "importApplication( applicationId: string, importData: ApplicationExportInterface, options: ApplicationImportOptions ): Promise<ApplicationGlossarySkeleton>",
    description: "Import application. The import data is usually read from an application export file.",
    params: [
      { name: "applicationId", type: "string", description: "application uuid" },
      { name: "importData", type: "ApplicationExportInterface", description: "application import data." },
    ],
    returns: "{Promise<ApplicationGlossarySkeleton>} Promise resolving to an application object.",
  },
  {
    typeName: "Application",
    methodName: "importApplicationByName",
    signature: "importApplicationByName( applicationName: string, importData: ApplicationExportInterface, options: ApplicationImportOptions ): Promise<ApplicationGlossarySkeleton>",
    description: "Import application by name. The import data is usually read from an application export file.",
    params: [
      { name: "applicationName", type: "string", description: "application name" },
      { name: "importData", type: "ApplicationExportInterface", description: "application import data." },
    ],
    returns: "{Promise<ApplicationGlossarySkeleton>} Promise resolving to an application object.",
  },
  {
    typeName: "Application",
    methodName: "importFirstApplication",
    signature: "importFirstApplication( importData: ApplicationExportInterface, options: ApplicationImportOptions ): Promise<ApplicationGlossarySkeleton[]>",
    description: "Import first application. The import data is usually read from an application export file.",
    params: [
      { name: "importData", type: "ApplicationExportInterface", description: "application import data." },
    ],
    returns: "",
  },
  {
    typeName: "Application",
    methodName: "importApplications",
    signature: "importApplications( importData: ApplicationExportInterface, options: ApplicationImportOptions ): Promise<ApplicationGlossarySkeleton[]>",
    description: "Import applications. The import data is usually read from an application export file.",
    params: [
      { name: "importData", type: "ApplicationExportInterface", description: "application import data." },
    ],
    returns: "",
  },
  {
    typeName: "Authenticate",
    methodName: "getTokens",
    signature: "getTokens( forceLoginAsUser?: boolean, autoRefresh?: boolean, types?: string[], callbackHandler?: CallbackHandler ): Promise<Tokens>",
    description: "Get tokens and store them in State",
    params: [
      { name: "forceLoginAsUser", type: "boolean", description: "true to force login as user even if a service account or Amster account is available (default: false)" },
      { name: "autoRefresh", type: "boolean", description: "true to automatically refresh tokens before they expire (default: true)" },
      { name: "types", type: "string[]", description: "Array of supported deployment types. The function will throw an error if an unsupported type is detected (default: ['classic', 'cloud', 'forgeops'])" },
      { name: "callbackHandler", type: "CallbackHandler", description: "function allowing the library to collect responses from the user through callbacks" },
    ],
    returns: "{Promise<Tokens>} object containing the tokens",
  },
  {
    typeName: "AuthenticationSettings",
    methodName: "readAuthenticationSettings",
    signature: "readAuthenticationSettings( globalConfig: boolean ): Promise<AuthenticationSettingsSkeleton>",
    description: "Read authentication settings",
    params: [
      { name: "globalConfig", type: "boolean", description: "true if global authentication settings is the target of the operation, false otherwise. Default: false." },
    ],
    returns: "{Promise<AuthenticationSettingsSkeleton>} a promise that resolves an authentication settings object",
  },
  {
    typeName: "AuthenticationSettings",
    methodName: "updateAuthenticationSettings",
    signature: "updateAuthenticationSettings( settings: AuthenticationSettingsSkeleton, globalConfig: boolean ): Promise<AuthenticationSettingsSkeleton>",
    description: "Update authentication settings",
    params: [
      { name: "settings", type: "AuthenticationSettingsSkeleton", description: "authentication settings data" },
      { name: "globalConfig", type: "boolean", description: "true if global authentication settings are the target of the operation, false otherwise. Default: false." },
    ],
    returns: "{Promise<AuthenticationSettingsSkeleton>} a promise that resolves an authentication settings object",
  },
  {
    typeName: "AuthenticationSettings",
    methodName: "exportAuthenticationSettings",
    signature: "exportAuthenticationSettings( globalConfig: boolean ): Promise<AuthenticationSettingsExportInterface>",
    description: "Export authentication settings",
    params: [
      { name: "globalConfig", type: "boolean", description: "true if global authentication settings is the target of the operation, false otherwise. Default: false." },
    ],
    returns: "{Promise<AuthenticationSettingsExportInterface>} a promise that resolves to an AuthenticationSettingsExportInterface object",
  },
  {
    typeName: "AuthenticationSettings",
    methodName: "importAuthenticationSettings",
    signature: "importAuthenticationSettings( importData: AuthenticationSettingsExportInterface, globalConfig: boolean ): Promise<AuthenticationSettingsSkeleton>",
    description: "Import authentication settings",
    params: [
      { name: "importData", type: "AuthenticationSettingsExportInterface", description: "import data" },
      { name: "globalConfig", type: "boolean", description: "true if global authentication settings are the target of the operation, false otherwise. Default: false." },
    ],
    returns: "",
  },
  {
    typeName: "CirclesOfTrust",
    methodName: "createCirclesOfTrustExportTemplate",
    signature: "createCirclesOfTrustExportTemplate(): CirclesOfTrustExportInterface",
    description: "Create an empty agent export template",
    params: [],
    returns: "{CirclesOfTrustExportInterface} an empty agent export template",
  },
  {
    typeName: "CirclesOfTrust",
    methodName: "readCirclesOfTrust",
    signature: "readCirclesOfTrust( entityProviders?: string[] ): Promise<CircleOfTrustSkeleton[]>",
    description: "Read all circles of trust",
    params: [
      { name: "entityProviders", type: "string[]", description: "filter by entity providers" },
    ],
    returns: "",
  },
  {
    typeName: "CirclesOfTrust",
    methodName: "readCircleOfTrust",
    signature: "readCircleOfTrust(cotId: string): Promise<CircleOfTrustSkeleton>",
    description: "Read circle of trust",
    params: [
      { name: "cotId", type: "string", description: "circle of trust id/name" },
    ],
    returns: "",
  },
  {
    typeName: "CirclesOfTrust",
    methodName: "createCircleOfTrust",
    signature: "createCircleOfTrust( cotId?: string, cotData?: CircleOfTrustSkeleton ): Promise<CircleOfTrustSkeleton>",
    description: "Create circle of trust",
    params: [
      { name: "cotId", type: "string", description: "circle of trust id/name" },
      { name: "cotData", type: "CircleOfTrustSkeleton", description: "circle of trust data" },
    ],
    returns: "",
  },
  {
    typeName: "CirclesOfTrust",
    methodName: "updateCircleOfTrust",
    signature: "updateCircleOfTrust( cotId: string, cotData: CircleOfTrustSkeleton ): Promise<CircleOfTrustSkeleton>",
    description: "Update circle of trust",
    params: [
      { name: "cotId", type: "string", description: "circle of trust id/name" },
      { name: "cotData", type: "", description: "circle of trust data" },
    ],
    returns: "",
  },
  {
    typeName: "CirclesOfTrust",
    methodName: "deleteCircleOfTrust",
    signature: "deleteCircleOfTrust(cotId: string): Promise<CircleOfTrustSkeleton>",
    description: "Delete circle of trust",
    params: [
      { name: "cotId", type: "string", description: "circle of trust id/name" },
    ],
    returns: "",
  },
  {
    typeName: "CirclesOfTrust",
    methodName: "deleteCirclesOfTrust",
    signature: "deleteCirclesOfTrust( entityProviders?: string[] ): Promise<CircleOfTrustSkeleton[]>",
    description: "Delete circles of trust",
    params: [
      { name: "entityProviders", type: "string[]", description: "filter by entity providers" },
    ],
    returns: "",
  },
  {
    typeName: "CirclesOfTrust",
    methodName: "exportCircleOfTrust",
    signature: "exportCircleOfTrust(cotId: string): Promise<CirclesOfTrustExportInterface>",
    description: "Export circle of trust",
    params: [
      { name: "cotId", type: "string", description: "circle of trust id/name" },
    ],
    returns: "",
  },
  {
    typeName: "CirclesOfTrust",
    methodName: "exportCirclesOfTrust",
    signature: "exportCirclesOfTrust( entityProviders?: string[] ): Promise<CirclesOfTrustExportInterface>",
    description: "Export all circles of trust",
    params: [
      { name: "entityProviders", type: "string[]", description: "filter by entity providers" },
    ],
    returns: "",
  },
  {
    typeName: "CirclesOfTrust",
    methodName: "importCircleOfTrust",
    signature: "importCircleOfTrust( cotId: string, importData: CirclesOfTrustExportInterface ): Promise<CircleOfTrustSkeleton>",
    description: "Import a circle of trust by id/name from file",
    params: [
      { name: "cotId", type: "string", description: "Circle of trust id/name" },
      { name: "importData", type: "CirclesOfTrustExportInterface", description: "Import data" },
    ],
    returns: "{Promise<CircleOfTrustSkeleton[]>} a promise resolving to the circle of trust object that was created or updated. Note: If the circle of trust already exists and does not need updating, null is returned.",
  },
  {
    typeName: "CirclesOfTrust",
    methodName: "importFirstCircleOfTrust",
    signature: "importFirstCircleOfTrust( importData: CirclesOfTrustExportInterface ): Promise<CircleOfTrustSkeleton>",
    description: "Import first circle of trust",
    params: [
      { name: "importData", type: "CirclesOfTrustExportInterface", description: "Import data" },
    ],
    returns: "{Promise<CircleOfTrustSkeleton[]>} a promise resolving to the circle of trust object that was created or updated. Note: If the circle of trust already exists and does not need updating, null is returned.",
  },
  {
    typeName: "CirclesOfTrust",
    methodName: "importCirclesOfTrust",
    signature: "importCirclesOfTrust( importData: CirclesOfTrustExportInterface, entityProviders?: string[] ): Promise<CircleOfTrustSkeleton[]>",
    description: "Import all circles of trust",
    params: [
      { name: "entityProviders", type: "string[]", description: "filter by entity providers" },
      { name: "importData", type: "CirclesOfTrustExportInterface", description: "Import data" },
    ],
    returns: "{Promise<CircleOfTrustSkeleton[]>} a promise resolving to an array of circle of trust objects that were created or updated. Note: If a circle of trust already exists and does not need updating, it is omitted from the response array.",
  },
  {
    typeName: "Config",
    methodName: "exportFullConfiguration",
    signature: "exportFullConfiguration( options: FullExportOptions, resultCallback: ResultCallback<any> ): Promise<FullExportInterface>",
    description: "Export full configuration",
    params: [
      { name: "options", type: "FullExportOptions", description: "export options" },
      { name: "resultCallback", type: "ResultCallback", description: "Optional callback to process individual results" },
    ],
    returns: "{Promise<FullExportInterface>} a promise resolving to a full export object",
  },
  {
    typeName: "Config",
    methodName: "importFullConfiguration",
    signature: "importFullConfiguration( importData: FullExportInterface, options: FullImportOptions, resultCallback: ResultCallback<any> ): Promise<(object | any[])[]>",
    description: "Import full configuration",
    params: [
      { name: "importData", type: "FullExportInterface", description: "import data" },
      { name: "options", type: "FullImportOptions", description: "import options" },
      { name: "resultCallback", type: "ResultCallback", description: "Optional callback to process individual results" },
    ],
    returns: "",
  },
  {
    typeName: "ConnectionProfile",
    methodName: "getConnectionProfilesPath",
    signature: "getConnectionProfilesPath(): string",
    description: "Get connection profiles file name",
    params: [],
    returns: "{string} connection profiles file name",
  },
  {
    typeName: "ConnectionProfile",
    methodName: "findConnectionProfiles",
    signature: "findConnectionProfiles( connectionProfiles: ConnectionsFileInterface, host: string ): SecureConnectionProfileInterface[]",
    description: "Find connection profiles",
    params: [
      { name: "connectionProfiles", type: "ConnectionsFileInterface", description: "connection profile object" },
      { name: "host", type: "string", description: "host url, unique substring, or alias" },
    ],
    returns: "{SecureConnectionProfileInterface[]} Array of connection profiles",
  },
  {
    typeName: "ConnectionProfile",
    methodName: "initConnectionProfiles",
    signature: "initConnectionProfiles(): Promise<void>",
    description: "Initialize connection profiles This method is called from app.ts and runs before any of the message handlers are registered. Therefore none of the Console message functions will produce any output.",
    params: [],
    returns: "",
  },
  {
    typeName: "ConnectionProfile",
    methodName: "getConnectionProfileByHost",
    signature: "getConnectionProfileByHost(host: string): Promise<ConnectionProfileInterface>",
    description: "Get connection profile by host",
    params: [
      { name: "host", type: "String", description: "host tenant, host url, unique substring, or alias" },
    ],
    returns: "{Object} connection profile or null",
  },
  {
    typeName: "ConnectionProfile",
    methodName: "getConnectionProfile",
    signature: "getConnectionProfile(): Promise<ConnectionProfileInterface>",
    description: "Get connection profile",
    params: [],
    returns: "{Object} connection profile or null",
  },
  {
    typeName: "ConnectionProfile",
    methodName: "loadConnectionProfileByHost",
    signature: "loadConnectionProfileByHost(host: string): Promise<boolean>",
    description: "Load a connection profile into library state",
    params: [
      { name: "host", type: "string", description: "AM host URL, unique substring, or alias" },
    ],
    returns: "{Promise<boolean>} A promise resolving to true if successful",
  },
  {
    typeName: "ConnectionProfile",
    methodName: "loadConnectionProfile",
    signature: "loadConnectionProfile(): Promise<boolean>",
    description: "Load a connection profile into library state",
    params: [],
    returns: "{Promise<boolean>} A promise resolving to true if successful",
  },
  {
    typeName: "ConnectionProfile",
    methodName: "saveConnectionProfile",
    signature: "saveConnectionProfile(host: string): Promise<boolean>",
    description: "Save connection profile",
    params: [
      { name: "host", type: "string", description: "host url for new profiles, unique substring or alias for existing profiles" },
    ],
    returns: "{Promise<boolean>} true if the operation succeeded, false otherwise",
  },
  {
    typeName: "ConnectionProfile",
    methodName: "setConnectionProfileAlias",
    signature: "setConnectionProfileAlias(host: string, alias: string): void",
    description: "Set an alias for an existing connection profile",
    params: [
      { name: "host", type: "string", description: "host url, unique substring, or alias of existing connection profile" },
      { name: "alias", type: "string", description: "alias to be assigned to connection profile" },
    ],
    returns: "",
  },
  {
    typeName: "ConnectionProfile",
    methodName: "deleteConnectionProfileAlias",
    signature: "deleteConnectionProfileAlias(host: string): void",
    description: "Set an alias for an existing connection profile",
    params: [
      { name: "host", type: "string", description: "host url, unique substring, or alias of existing connection profile" },
    ],
    returns: "",
  },
  {
    typeName: "ConnectionProfile",
    methodName: "deleteConnectionProfile",
    signature: "deleteConnectionProfile(host: string): void",
    description: "Delete connection profile",
    params: [
      { name: "host", type: "string", description: "host tenant, host url, unique substring, or alias" },
    ],
    returns: "",
  },
  {
    typeName: "ConnectionProfile",
    methodName: "addNewServiceAccount",
    signature: "addNewServiceAccount(): Promise<IdObjectSkeletonInterface>",
    description: "Create a new service account using auto-generated parameters",
    params: [],
    returns: "{Promise<IdObjectSkeletonInterface>} A promise resolving to a service account object",
  },
  {
    typeName: "Connector",
    methodName: "createConnectorExportTemplate",
    signature: "createConnectorExportTemplate(): ConnectorExportInterface",
    description: "Create an empty connector export template",
    params: [],
    returns: "{ConnectorExportInterface} an empty connector export template",
  },
  {
    typeName: "Connector",
    methodName: "readConnectors",
    signature: "readConnectors(): Promise<ConnectorSkeleton[]>",
    description: "Get all connectors",
    params: [],
    returns: "{Promise<ConnectorSkeleton[]>} a promise that resolves to an array of connector objects",
  },
  {
    typeName: "Connector",
    methodName: "readConnector",
    signature: "readConnector(connectorId: string): Promise<ConnectorSkeleton>",
    description: "Get connector",
    params: [
      { name: "connectorId", type: "string", description: "id/name of the connector without the type prefix" },
    ],
    returns: "{Promise<ConnectorSkeleton>} a promise that resolves an connector object",
  },
  {
    typeName: "Connector",
    methodName: "createConnector",
    signature: "createConnector( connectorId: string, connectorData: ConnectorSkeleton ): Promise<ConnectorSkeleton>",
    description: "Create connector",
    params: [
      { name: "connectorId", type: "string", description: "id/name of the connector without the type prefix" },
      { name: "connectorData", type: "ConnectorSkeleton", description: "connector object" },
    ],
    returns: "{Promise<ConnectorSkeleton>} a promise that resolves to an connector object",
  },
  {
    typeName: "Connector",
    methodName: "updateConnector",
    signature: "updateConnector( connectorId: string, connectorData: ConnectorSkeleton ): Promise<ConnectorSkeleton>",
    description: "Update or create connector",
    params: [
      { name: "connectorId", type: "string", description: "id/name of the connector without the type prefix" },
      { name: "connectorData", type: "ConnectorSkeleton", description: "connector object" },
    ],
    returns: "{Promise<ConnectorSkeleton>} a promise that resolves to an connector object",
  },
  {
    typeName: "Connector",
    methodName: "deleteConnectors",
    signature: "deleteConnectors(deep?: boolean): Promise<ConnectorSkeleton[]>",
    description: "Delete all connectors",
    params: [
      { name: "deep", type: "boolean", description: "deep delete (remove dependencies)" },
    ],
    returns: "{Promise<ConnectorSkeleton[]>} a promise that resolves to an array of connector objects",
  },
  {
    typeName: "Connector",
    methodName: "deleteConnector",
    signature: "deleteConnector( connectorId: string, deep?: boolean ): Promise<ConnectorSkeleton>",
    description: "Delete connector",
    params: [
      { name: "connectorId", type: "string", description: "id/name of the connector without the type prefix" },
      { name: "deep", type: "boolean", description: "deep delete (remove dependencies)" },
    ],
    returns: "{Promise<ConnectorSkeleton>} a promise that resolves an connector object",
  },
  {
    typeName: "Connector",
    methodName: "exportConnector",
    signature: "exportConnector( connectorId: string, options?: ConnectorExportOptions ): Promise<ConnectorExportInterface>",
    description: "Export connector",
    params: [
      { name: "connectorId", type: "string", description: "id/name of the connector without the type prefix" },
      { name: "options", type: "ConnectorExportOptions", description: "export options" },
    ],
    returns: "{Promise<ConnectorExportInterface>} a promise that resolves to a ConnectorExportInterface object",
  },
  {
    typeName: "Connector",
    methodName: "exportConnectors",
    signature: "exportConnectors(): Promise<ConnectorExportInterface>",
    description: "Export all connectors",
    params: [],
    returns: "{Promise<ConnectorExportInterface>} a promise that resolves to a ConnectorExportInterface object",
  },
  {
    typeName: "Connector",
    methodName: "importConnector",
    signature: "importConnector( connectorId: string, importData: ConnectorExportInterface, options?: ConnectorImportOptions ): Promise<ConnectorSkeleton>",
    description: "Import connector",
    params: [
      { name: "connectorId", type: "string", description: "id/name of the connector without the type prefix" },
      { name: "importData", type: "ConnectorExportInterface", description: "import data" },
      { name: "options", type: "ConnectorImportOptions", description: "import options" },
    ],
    returns: "{Promise<ConnectorSkeleton>} a promise resolving to a ConnectorSkeleton object",
  },
  {
    typeName: "Connector",
    methodName: "importFirstConnector",
    signature: "importFirstConnector( importData: ConnectorExportInterface, options?: ConnectorImportOptions ): Promise<ConnectorSkeleton>",
    description: "Import first connector",
    params: [
      { name: "importData", type: "ConnectorExportInterface", description: "import data" },
      { name: "options", type: "ConnectorImportOptions", description: "import options" },
    ],
    returns: "{Promise<ConnectorSkeleton>} a promise resolving to a ConnectorSkeleton object",
  },
  {
    typeName: "Connector",
    methodName: "importConnectors",
    signature: "importConnectors( importData: ConnectorExportInterface, options?: ConnectorImportOptions ): Promise<ConnectorSkeleton[]>",
    description: "Import all connectors",
    params: [
      { name: "importData", type: "ConnectorExportInterface", description: "import data" },
      { name: "options", type: "ConnectorImportOptions", description: "import options" },
    ],
    returns: "{Promise<ConnectorSkeleton[]>} a promise resolving to an array of ConnectorSkeleton objects",
  },
  {
    typeName: "EmailTemplate",
    methodName: "createEmailTemplateExportTemplate",
    signature: "createEmailTemplateExportTemplate(): EmailTemplateExportInterface",
    description: "Create an empty email template export template",
    params: [],
    returns: "{EmailTemplateExportInterface} an empty email template export template",
  },
  {
    typeName: "EmailTemplate",
    methodName: "readEmailTemplates",
    signature: "readEmailTemplates( includeDefault?: boolean ): Promise<EmailTemplateSkeleton[]>",
    description: "Get all email templates",
    params: [
      { name: "includeDefault", type: "boolean", description: "Include default email templates if true, false to exclude them. Default: false" },
    ],
    returns: "{Promise<EmailTemplateSkeleton[]>} a promise that resolves to an array of email template objects",
  },
  {
    typeName: "EmailTemplate",
    methodName: "readEmailTemplate",
    signature: "readEmailTemplate(templateId: string): Promise<EmailTemplateSkeleton>",
    description: "Get email template",
    params: [
      { name: "templateId", type: "string", description: "id/name of the email template without the type prefix" },
    ],
    returns: "{Promise<EmailTemplateSkeleton>} a promise that resolves an email template object",
  },
  {
    typeName: "EmailTemplate",
    methodName: "exportEmailTemplates",
    signature: "exportEmailTemplates( includeDefault?: boolean ): Promise<EmailTemplateExportInterface>",
    description: "Export all email templates. The response can be saved to file as is.",
    params: [
      { name: "includeDefault", type: "boolean", description: "Include default email templates if true, false to exclude them. Default: false" },
    ],
    returns: "{Promise<EmailTemplateExportInterface>} Promise resolving to a EmailTemplateExportInterface object.",
  },
  {
    typeName: "EmailTemplate",
    methodName: "createEmailTemplate",
    signature: "createEmailTemplate( templateId: string, templateData: EmailTemplateSkeleton ): Promise<EmailTemplateSkeleton>",
    description: "Create email template",
    params: [
      { name: "templateId", type: "string", description: "id/name of the email template without the type prefix" },
      { name: "templateData", type: "EmailTemplateSkeleton", description: "email template object" },
    ],
    returns: "{Promise<EmailTemplateSkeleton>} a promise that resolves to an email template object",
  },
  {
    typeName: "EmailTemplate",
    methodName: "updateEmailTemplate",
    signature: "updateEmailTemplate( templateId: string, templateData: EmailTemplateSkeleton ): Promise<EmailTemplateSkeleton>",
    description: "Update or create email template",
    params: [
      { name: "templateId", type: "string", description: "id/name of the email template without the type prefix" },
      { name: "templateData", type: "EmailTemplateSkeleton", description: "email template object" },
    ],
    returns: "{Promise<EmailTemplateSkeleton>} a promise that resolves to an email template object",
  },
  {
    typeName: "EmailTemplate",
    methodName: "importEmailTemplates",
    signature: "importEmailTemplates( importData: EmailTemplateExportInterface ): Promise<EmailTemplateSkeleton[]>",
    description: "Import all email templates",
    params: [
      { name: "importData", type: "EmailTemplateExportInterface", description: "import data" },
    ],
    returns: "{Promise<IdObjectSkeletonInterface[]>} a promise resolving to an array of email template objects",
  },
  {
    typeName: "EmailTemplate",
    methodName: "deleteEmailTemplates",
    signature: "deleteEmailTemplates(): Promise<EmailTemplateSkeleton[]>",
    description: "Delete all email templates",
    params: [],
    returns: "{Promise<EmailTemplateSkeleton[]>} a promise that resolves to an array of email template objects",
  },
  {
    typeName: "EmailTemplate",
    methodName: "deleteEmailTemplate",
    signature: "deleteEmailTemplate(templateId: string): Promise<EmailTemplateSkeleton>",
    description: "Delete email template",
    params: [
      { name: "templateId", type: "string", description: "id/name of the email template without the type prefix 'emailTemplate/'" },
    ],
    returns: "{Promise<EmailTemplateSkeleton>} a promise that resolves an email template object",
  },
  {
    typeName: "IdmConfig",
    methodName: "readConfigEntityTypes",
    signature: "readConfigEntityTypes(): Promise<string[]>",
    description: "Read available config entity types",
    params: [],
    returns: "{string[]} promise resolving to an array of config entity types",
  },
  {
    typeName: "IdmConfig",
    methodName: "readConfigEntityStubs",
    signature: "readConfigEntityStubs(): Promise<IdmConfigStub[]>",
    description: "Read all config entity stubs. For full entities use {@link IdmConfig.readConfigEntities | readConfigEntities}.",
    params: [],
    returns: "{IdmConfigStub[]} promise resolving to an array of config entity stubs",
  },
  {
    typeName: "IdmConfig",
    methodName: "readConfigEntities",
    signature: "readConfigEntities(): Promise<IdObjectSkeletonInterface[]>",
    description: "Read all config entities",
    params: [],
    returns: "{IdObjectSkeletonInterface[]} promise reolving to an array of config entities",
  },
  {
    typeName: "IdmConfig",
    methodName: "readConfigEntitiesByType",
    signature: "readConfigEntitiesByType( type: string, includeDefault?: boolean ): Promise<IdObjectSkeletonInterface[]>",
    description: "Read all config entities of a type",
    params: [
      { name: "type", type: "string", description: "config entity type" },
      { name: "includeDefault", type: "boolean", description: "Include default email templates if true, false to exclude them. Default: false" },
    ],
    returns: "{IdObjectSkeletonInterface[]} promise resolving to an array of config entities of a type",
  },
  {
    typeName: "IdmConfig",
    methodName: "readConfigEntity",
    signature: "readConfigEntity(entityId: string): Promise<IdObjectSkeletonInterface>",
    description: "Read config entity",
    params: [
      { name: "entityId", type: "string", description: "config entity id/name" },
    ],
    returns: "{IdObjectSkeletonInterface} promise resolving to a config entity",
  },
  {
    typeName: "IdmConfig",
    methodName: "exportConfigEntity",
    signature: "exportConfigEntity( entityId: string, options?: ConfigEntityExportOptions ): Promise<ConfigEntityExportInterface>",
    description: "Export a single IDM config entity",
    params: [
      { name: "entityId", type: "string", description: "config entity id" },
      { name: "options", type: "ConfigEntityExportOptions", description: "export options" },
    ],
    returns: "{ConfigEntityExportInterface} promise resolving to a ConfigEntityExportInterface object",
  },
  {
    typeName: "IdmConfig",
    methodName: "exportConfigEntities",
    signature: "exportConfigEntities( options?: ConfigEntityExportOptions, resultCallback?: ResultCallback<IdObjectSkeletonInterface> ): Promise<ConfigEntityExportInterface>",
    description: "Export all IDM config entities",
    params: [
      { name: "options", type: "ConfigEntityExportOptions", description: "export options" },
      { name: "resultCallback", type: "ResultCallback", description: "Optional callback to process individual results" },
    ],
    returns: "{ConfigEntityExportInterface} promise resolving to a ConfigEntityExportInterface object",
  },
  {
    typeName: "IdmConfig",
    methodName: "createConfigEntity",
    signature: "createConfigEntity( entityId: string, entityData: IdObjectSkeletonInterface, wait?: boolean ): Promise<IdObjectSkeletonInterface>",
    description: "Create config entity",
    params: [
      { name: "entityId", type: "string", description: "config entity id/name" },
      { name: "entityData", type: "IdObjectSkeletonInterface", description: "config entity data" },
      { name: "wait", type: "boolean", description: "delay the response until an OSGi service event confirms the change has been consumed by the corresponding service or the request times out." },
    ],
    returns: "{IdObjectSkeletonInterface} promise resolving to a config entity",
  },
  {
    typeName: "IdmConfig",
    methodName: "updateConfigEntity",
    signature: "updateConfigEntity( entityId: string, entityData: IdObjectSkeletonInterface, wait?: boolean ): Promise<IdObjectSkeletonInterface>",
    description: "Update or create config entity",
    params: [
      { name: "entityId", type: "string", description: "config entity id/name" },
      { name: "entityData", type: "IdObjectSkeletonInterface", description: "config entity data" },
      { name: "wait", type: "boolean", description: "delay the response until an OSGi service event confirms the change has been consumed by the corresponding service or the request times out." },
    ],
    returns: "{IdObjectSkeletonInterface} promise resolving to a config entity",
  },
  {
    typeName: "IdmConfig",
    methodName: "importConfigEntities",
    signature: "importConfigEntities( importData: ConfigEntityExportInterface, entityId?: string, options?: ConfigEntityImportOptions, resultCallback?: ResultCallback<IdObjectSkeletonInterface> ): Promise<IdObjectSkeletonInterface[]>",
    description: "Import idm config entities.",
    params: [
      { name: "importData", type: "ConfigEntityExportInterface", description: "idm config entity import data." },
      { name: "entityId", type: "string", description: "Optional entity id that, when provided, will only import the entity of that id from the importData" },
      { name: "options", type: "ConfigEntityImportOptions", description: "import options" },
      { name: "resultCallback", type: "ResultCallback", description: "Optional callback to process individual results" },
    ],
    returns: "{Promise<IdObjectSkeletonInterface[]>} a promise resolving to an array of config entity objects",
  },
  {
    typeName: "IdmConfig",
    methodName: "deleteConfigEntities",
    signature: "deleteConfigEntities( resultCallback?: ResultCallback<IdObjectSkeletonInterface> ): Promise<IdObjectSkeletonInterface[]>",
    description: "Delete all config entities",
    params: [
      { name: "resultCallback", type: "ResultCallback", description: "Optional callback to process individual results" },
    ],
    returns: "{IdObjectSkeletonInterface[]} promise reolving to an array of config entities",
  },
  {
    typeName: "IdmConfig",
    methodName: "deleteConfigEntitiesByType",
    signature: "deleteConfigEntitiesByType( type: string, resultCallback?: ResultCallback<IdObjectSkeletonInterface> ): Promise<IdObjectSkeletonInterface[]>",
    description: "Delete all config entities of a type",
    params: [
      { name: "type", type: "string", description: "config entity type" },
      { name: "resultCallback", type: "ResultCallback", description: "Optional callback to process individual results" },
    ],
    returns: "{IdObjectSkeletonInterface[]} promise resolving to an array of config entities of a type",
  },
  {
    typeName: "IdmConfig",
    methodName: "deleteConfigEntity",
    signature: "deleteConfigEntity(entityId: string): Promise<IdObjectSkeletonInterface>",
    description: "Delete config entity",
    params: [
      { name: "entityId", type: "string", description: "config entity id/name" },
    ],
    returns: "{IdObjectSkeletonInterface} promise resolving to a config entity",
  },
  {
    typeName: "IdmConfig",
    methodName: "readSubConfigEntity",
    signature: "readSubConfigEntity( entityId: string, name: string, options?: ConfigEntityExportOptions ): Promise<NoIdObjectSkeletonInterface>",
    description: "Read a idm sub config entity.",
    params: [
      { name: "entityId", type: "string", description: "entity id for the parent config entity of the sub config entity that is being read" },
      { name: "name", type: "string", description: "name of the sub config entity that is being read" },
      { name: "options", type: "ConfigEntityExportOptions", description: "export options" },
    ],
    returns: "{Promise<IdObjectSkeletonInterface>} a promise resolving to a sub config entity object",
  },
  {
    typeName: "IdmConfig",
    methodName: "importSubConfigEntity",
    signature: "importSubConfigEntity( entityId: string, updatedSubConfigEntity: IdObjectSkeletonInterface, options?: ConfigEntityImportOptions ): Promise<IdObjectSkeletonInterface[]>",
    description: "Import a idm sub config entity.",
    params: [
      { name: "entityId", type: "string", description: "entity id for parent config entity of the sub config that is being updated" },
      { name: "updatedSubConfigEntity", type: "NoIdObjectSkeletonInterface", description: "the updated sub config entity" },
      { name: "options", type: "ConfigEntityImportOptions", description: "import options" },
    ],
    returns: "{Promise<IdObjectSkeletonInterface[]>} a promise resolving to an array of config entity objects",
  },
  {
    typeName: "IdmCrypto",
    methodName: "isEncrypted",
    signature: "isEncrypted(value: any): boolean",
    description: "Test if a value is encrypted",
    params: [
      { name: "value", type: "any", description: "value to test" },
    ],
    returns: "{boolean} true if the value is encrypted, false otherwise",
  },
  {
    typeName: "IdmCrypto",
    methodName: "encrypt",
    signature: "encrypt(value: any): Promise<any>",
    description: "Encrypt a value",
    params: [
      { name: "value", type: "any", description: "value to encrypt" },
    ],
    returns: "{Promise<any>} a promise resolving to the encrypted value",
  },
  {
    typeName: "IdmCrypto",
    methodName: "encryptMap",
    signature: "encryptMap(map: { [key: string]: any }): Promise<{ [key: string]: any }>",
    description: "Encrypt a map of values",
    params: [
      { name: "{{", type: "", description: "[key: string]: any }} map map of values to encrypt" },
    ],
    returns: "{Promise<{ [key: string]: any } >} a promise resolving to a map of encrypted values",
  },
  {
    typeName: "IdmCrypto",
    methodName: "decrypt",
    signature: "decrypt(script: string): Promise<any>",
    description: "Decrypt a value",
    params: [],
    returns: "{Promise<SystemStatusInterface[]>} a promise resolving to the decrypted value",
  },
  {
    typeName: "IdmCrypto",
    methodName: "decryptMap",
    signature: "decryptMap(map: { [key: string]: any }): Promise<{ [key: string]: any }>",
    description: "Decrypt a map of values",
    params: [
      { name: "{{", type: "", description: "[key: string]: any }} map map of values to decrypt" },
    ],
    returns: "{Promise<{ [key: string]: any } >} a promise resolving to a map of decrypted values",
  },
  {
    typeName: "IdmScript",
    methodName: "compileScript",
    signature: "compileScript(script: string): Promise<string | object>",
    description: "Compile a JS script",
    params: [],
    returns: "{Promise<string | object>} a promise resolving to 'true' or an error message",
  },
  {
    typeName: "IdmScript",
    methodName: "evaluateScript",
    signature: "evaluateScript( script: string, globals?: { [key: string]: any } ): Promise<any>",
    description: "Run a JS script",
    params: [],
    returns: "{Promise<SystemStatusInterface[]>} a promise resolving to the script result",
  },
  {
    typeName: "IdmSystem",
    methodName: "testConnectorServers",
    signature: "testConnectorServers(): Promise<ConnectorServerStatusInterface[]>",
    description: "Test connector servers",
    params: [],
    returns: "{Promise<ConnectorServerStatusInterface[]>} a promise that resolves to an array of ConnectorServerStatusInterface objects",
  },
  {
    typeName: "IdmSystem",
    methodName: "readAvailableSystems",
    signature: "readAvailableSystems(): Promise<SystemStatusInterface[]>",
    description: "Read available systems/connectors status",
    params: [],
    returns: "{Promise<SystemStatusInterface[]>} a promise resolving to an array of system status objects",
  },
  {
    typeName: "IdmSystem",
    methodName: "readSystemStatus",
    signature: "readSystemStatus(systemName: string): Promise<SystemStatusInterface>",
    description: "Read system/connector status",
    params: [],
    returns: "{Promise<SystemStatusInterface>} a promise resolving to a system status object",
  },
  {
    typeName: "IdmSystem",
    methodName: "authenticateSystemObject",
    signature: "authenticateSystemObject( systemName: string, systemObjectType: string, username: string, password: string ): Promise<IdObjectSkeletonInterface>",
    description: "Authenticate a system object using username and password (pass-through authentication)",
    params: [
      { name: "systemName", type: "string", description: "name of system/connector" },
      { name: "systemObjectType", type: "string", description: "type of system object" },
      { name: "username", type: "string", description: "system object username" },
      { name: "password", type: "string", description: "system object password" },
    ],
    returns: "{Promise<IdObjectSkeletonInterface>} a promise resolving to an IdObjectSkeletonInterface object containing only the _id",
  },
  {
    typeName: "IdmSystem",
    methodName: "runSystemScript",
    signature: "runSystemScript(systemName: string, scriptName: string): Promise<any>",
    description: "Run system script",
    params: [
      { name: "systemName", type: "string", description: "name of system/connector" },
      { name: "scriptName", type: "string", description: "name of script" },
    ],
    returns: "{Promise<any>} a promise resolving to a status object",
  },
  {
    typeName: "IdmSystem",
    methodName: "queryAllSystemObjectIds",
    signature: "queryAllSystemObjectIds( systemName: string, systemObjectType: string, pageSize?: number, pageCookie?: string ): Promise<PagedResult<IdObjectSkeletonInterface>>",
    description: "Query all system object ids",
    params: [
      { name: "systemName", type: "string", description: "name of system/connector" },
      { name: "systemObjectType", type: "string", description: "type of system object" },
      { name: "pageSize", type: "number", description: "page size (default value: 1000)" },
      { name: "pageCookie", type: "string", description: "paged results cookie" },
    ],
    returns: "{Promise<PagedResult<IdObjectSkeletonInterface>>} a promise resolving to an array of IdObjectSkeletonInterface objects",
  },
  {
    typeName: "IdmSystem",
    methodName: "querySystemObjects",
    signature: "querySystemObjects( systemName: string, systemObjectType: string, filter: string, fields?: string[], pageSize?: number, pageCookie?: string ): Promise<PagedResult<IdObjectSkeletonInterface>>",
    description: "Query system objects using a search filter",
    params: [
      { name: "systemName", type: "string", description: "name of system/connector" },
      { name: "systemObjectType", type: "string", description: "type of system object" },
      { name: "filter", type: "string", description: "search filter" },
      { name: "fields", type: "string[]", description: "array of fields to return" },
      { name: "pageSize", type: "number", description: "page size (default value: 1000)" },
      { name: "pageCookie", type: "string", description: "paged results cookie" },
    ],
    returns: "{Promise<PagedResult<IdObjectSkeletonInterface>>} a promise resolving to an array of IdObjectSkeletonInterface objects",
  },
  {
    typeName: "IdmSystem",
    methodName: "readSystemObject",
    signature: "readSystemObject( systemName: string, systemObjectType: string, systemObjectId: string, fields?: string[] ): Promise<IdObjectSkeletonInterface>",
    description: "Read system object",
    params: [
      { name: "systemName", type: "string", description: "name of system/connector" },
      { name: "systemObjectType", type: "string", description: "type of system object" },
      { name: "systemObjectId", type: "string", description: "id of system object" },
      { name: "fields", type: "string[]", description: "array of fields to return (default: `['*']`)" },
    ],
    returns: "{Promise<IdObjectSkeletonInterface>} a promise resolving to an IdObjectSkeletonInterface object",
  },
  {
    typeName: "IdmSystem",
    methodName: "createSystemObject",
    signature: "createSystemObject( systemName: string, systemObjectType: string, systemObjectData: IdObjectSkeletonInterface ): Promise<IdObjectSkeletonInterface>",
    description: "Create system object",
    params: [
      { name: "systemName", type: "string", description: "name of system/connector" },
      { name: "systemObjectType", type: "string", description: "type of system object" },
      { name: "systemObjectData", type: "IdObjectSkeletonInterface", description: "system object data" },
    ],
    returns: "{Promise<IdObjectSkeletonInterface>} a promise resolving to an IdObjectSkeletonInterface object",
  },
  {
    typeName: "IdmSystem",
    methodName: "updateSystemObject",
    signature: "updateSystemObject( systemName: string, systemObjectType: string, systemObjectId: string, systemObjectData: IdObjectSkeletonInterface, failIfExists?: boolean ): Promise<IdObjectSkeletonInterface>",
    description: "Update or create system object",
    params: [
      { name: "systemName", type: "string", description: "name of system/connector" },
      { name: "systemObjectType", type: "string", description: "type of system object" },
      { name: "systemObjectId", type: "string", description: "id of system object" },
      { name: "systemObjectData", type: "IdObjectSkeletonInterface", description: "system object data" },
      { name: "failIfExists", type: "boolean", description: "fail if object exists (default value: false)" },
    ],
    returns: "{Promise<IdObjectSkeletonInterface>} a promise resolving to an IdObjectSkeletonInterface object",
  },
  {
    typeName: "IdmSystem",
    methodName: "updateSystemObjectProperties",
    signature: "updateSystemObjectProperties( systemName: string, systemObjectType: string, systemObjectId: string, operations: SystemObjectPatchOperationInterface[] ): Promise<IdObjectSkeletonInterface>",
    description: "Partially update system object through a collection of patch operations.",
    params: [
      { name: "systemName", type: "string", description: "name of system/connector" },
      { name: "systemObjectType", type: "string", description: "type of system object" },
      { name: "systemObjectId", type: "string", description: "id of system object" },
      { name: "operations", type: "SystemObjectPatchOperationInterface[]", description: "collection of patch operations to perform on the object" },
    ],
    returns: "{Promise<IdObjectSkeletonInterface>} a promise resolving to an IdObjectSkeletonInterface object",
  },
  {
    typeName: "IdmSystem",
    methodName: "deleteSystemObject",
    signature: "deleteSystemObject( systemName: string, systemObjectType: string, systemObjectId: string ): Promise<IdObjectSkeletonInterface>",
    description: "Delete system object",
    params: [
      { name: "systemName", type: "string", description: "name of system/connector" },
      { name: "systemObjectType", type: "string", description: "type of system object" },
      { name: "systemObjectId", type: "string", description: "id of system object" },
    ],
    returns: "{Promise<IdObjectSkeletonInterface>} a promise resolving to an IdObjectSkeletonInterface object",
  },
  {
    typeName: "IdmSystem",
    methodName: "readSystemSchema",
    signature: "readSystemSchema( systemName: string ): Promise<Record<string, ObjectTypeSkeleton>>",
    description: "Read system schema",
    params: [
      { name: "systemName", type: "string", description: "name of system/connector" },
    ],
    returns: "{Promise<Record<string, ObjectTypeSkeleton>>} a promise resolving to a map of Record<string, ObjectTypeSkeleton>",
  },
  {
    typeName: "Idp",
    methodName: "readSocialIdentityProviders",
    signature: "readSocialIdentityProviders(): Promise<SocialIdpSkeleton[]>",
    description: "Read all social identity providers",
    params: [],
    returns: "{Promise<SocialIdpSkeleton[]>} a promise that resolves to an array of social identity providers",
  },
  {
    typeName: "Idp",
    methodName: "readSocialIdentityProvider",
    signature: "readSocialIdentityProvider(providerId: string): Promise<SocialIdpSkeleton>",
    description: "Read social identity provider",
    params: [
      { name: "providerId", type: "string", description: "identity provider id/name" },
    ],
    returns: "{Promise<SocialIdpSkeleton>} a promise that resolves a social identity provider object",
  },
  {
    typeName: "Idp",
    methodName: "createSocialIdentityProvider",
    signature: "createSocialIdentityProvider( providerType: string, providerId: string, providerData: SocialIdpSkeleton ): Promise<SocialIdpSkeleton>",
    description: "Create social identity provider",
    params: [
      { name: "providerType", type: "string", description: "identity provider type" },
      { name: "providerId", type: "string", description: "identity provider id/name" },
      { name: "providerData", type: "SocialIdpSkeleton", description: "identity provider data" },
    ],
    returns: "{Promise<SocialIdpSkeleton>} a promise that resolves a social identity provider object",
  },
  {
    typeName: "Idp",
    methodName: "updateSocialIdentityProvider",
    signature: "updateSocialIdentityProvider( providerType: string, providerId: string, providerData: SocialIdpSkeleton ): Promise<SocialIdpSkeleton>",
    description: "Update or create social identity provider",
    params: [
      { name: "providerType", type: "string", description: "identity provider type" },
      { name: "providerId", type: "string", description: "identity provider id/name" },
      { name: "providerData", type: "SocialIdpSkeleton", description: "identity provider data" },
    ],
    returns: "{Promise<SocialIdpSkeleton>} a promise that resolves a social identity provider object",
  },
  {
    typeName: "Idp",
    methodName: "deleteSocialIdentityProviders",
    signature: "deleteSocialIdentityProviders(): Promise<SocialIdpSkeleton[]>",
    description: "Delete all social identity providers",
    params: [],
    returns: "{Promise<SocialIdpSkeleton[]>} a promise that resolves to an array of social identity provider objects",
  },
  {
    typeName: "Idp",
    methodName: "deleteSocialIdentityProvider",
    signature: "deleteSocialIdentityProvider(providerId: string): Promise<SocialIdpSkeleton>",
    description: "Delete social identity provider",
    params: [
      { name: "providerId", type: "string", description: "social identity provider id/name" },
    ],
    returns: "{Promise<SocialIdpSkeleton>} a promise that resolves a social identity provider object",
  },
  {
    typeName: "Idp",
    methodName: "exportSocialIdentityProvider",
    signature: "exportSocialIdentityProvider( providerId: string ): Promise<SocialProviderExportInterface>",
    description: "Export social identity provider",
    params: [
      { name: "providerId", type: "string", description: "provider id/name" },
    ],
    returns: "{Promise<SocialProviderExportInterface>} a promise that resolves to a SocialProviderExportInterface object",
  },
  {
    typeName: "Idp",
    methodName: "exportSocialIdentityProviders",
    signature: "exportSocialIdentityProviders( options?: SocialIdentityProviderExportOptions ): Promise<SocialProviderExportInterface>",
    description: "Export all social identity providers",
    params: [
      { name: "options", type: "SocialIdentityProviderExportOptions", description: "export options" },
    ],
    returns: "{Promise<SocialProviderExportInterface>} a promise that resolves to a SocialProviderExportInterface object",
  },
  {
    typeName: "Idp",
    methodName: "importSocialIdentityProvider",
    signature: "importSocialIdentityProvider( providerId: string, importData: SocialProviderExportInterface, options: SocialIdentityProviderImportOptions ): Promise<SocialIdpSkeleton>",
    description: "Import social identity provider",
    params: [
      { name: "providerId", type: "string", description: "provider id/name" },
      { name: "importData", type: "SocialProviderExportInterface", description: "import data" },
      { name: "options", type: "SocialIdentityProviderImportOptions", description: "import options" },
    ],
    returns: "{Promise<SocialIdpSkeleton>} a promise resolving to a social identity provider object",
  },
  {
    typeName: "Idp",
    methodName: "importFirstSocialIdentityProvider",
    signature: "importFirstSocialIdentityProvider( importData: SocialProviderExportInterface, options: SocialIdentityProviderImportOptions ): Promise<SocialIdpSkeleton>",
    description: "Import first social identity provider",
    params: [
      { name: "importData", type: "SocialProviderExportInterface", description: "import data" },
      { name: "options", type: "SocialIdentityProviderImportOptions", description: "import options" },
    ],
    returns: "{Promise<SocialIdpSkeleton>} a promise resolving to a social identity provider object",
  },
  {
    typeName: "Idp",
    methodName: "importSocialIdentityProviders",
    signature: "importSocialIdentityProviders( importData: SocialProviderExportInterface, options: SocialIdentityProviderImportOptions ): Promise<SocialIdpSkeleton[]>",
    description: "Import all social identity providers",
    params: [
      { name: "importData", type: "SocialProviderExportInterface", description: "import data" },
      { name: "options", type: "SocialIdentityProviderImportOptions", description: "import options" },
    ],
    returns: "{Promise<SocialIdpSkeleton[]>} a promise resolving to an array of social identity provider objects",
  },
  {
    typeName: "Info",
    methodName: "getInfo",
    signature: "getInfo(): Promise<PlatformInfo>",
    description: "Get info about the platform instance",
    params: [],
    returns: "{Promise<PlatformInfo>} a promise that resolves to a json blob with information about the instance and tokens",
  },
  {
    typeName: "InternalRole",
    methodName: "createInternalRoleExportTemplate",
    signature: "createInternalRoleExportTemplate(): InternalRoleExportInterface",
    description: "Create an empty internal role export template",
    params: [],
    returns: "{InternalRoleExportInterface} an empty internal role export template",
  },
  {
    typeName: "InternalRole",
    methodName: "createInternalRole",
    signature: "createInternalRole( roleData: InternalRoleSkeleton ): Promise<InternalRoleSkeleton>",
    description: "Create internal role",
    params: [
      { name: "roleData", type: "InternalRoleSkeleton", description: "internal role data" },
    ],
    returns: "{Promise<InternalRoleSkeleton>} a promise that resolves to an internal role object",
  },
  {
    typeName: "InternalRole",
    methodName: "readInternalRole",
    signature: "readInternalRole(roleId: string): Promise<InternalRoleSkeleton>",
    description: "Read internal role",
    params: [
      { name: "roleId", type: "string", description: "internal role uuid" },
    ],
    returns: "{Promise<InternalRoleSkeleton>} a promise that resolves to an internal role object",
  },
  {
    typeName: "InternalRole",
    methodName: "readInternalRoleByName",
    signature: "readInternalRoleByName(roleName: string): Promise<InternalRoleSkeleton>",
    description: "Read internal role by name",
    params: [
      { name: "roleName", type: "string", description: "internal role name" },
    ],
    returns: "{Promise<InternalRoleSkeleton>} a promise that resolves to an internal role object",
  },
  {
    typeName: "InternalRole",
    methodName: "readInternalRoles",
    signature: "readInternalRoles(): Promise<InternalRoleSkeleton[]>",
    description: "Read all internal roles. Results are sorted aphabetically.",
    params: [],
    returns: "{Promise<InternalRoleSkeleton[]>} a promise that resolves to an array of internal role objects",
  },
  {
    typeName: "InternalRole",
    methodName: "updateInternalRole",
    signature: "updateInternalRole( roleId: string, roleData: InternalRoleSkeleton ): Promise<InternalRoleSkeleton>",
    description: "Update internal role",
    params: [
      { name: "roleId", type: "string", description: "internal role uuid" },
      { name: "roleData", type: "InternalRoleSkeleton", description: "internal role data" },
    ],
    returns: "{Promise<InternalRoleSkeleton>} a promise that resolves to an internal role object",
  },
  {
    typeName: "InternalRole",
    methodName: "deleteInternalRole",
    signature: "deleteInternalRole(roleId: string): Promise<InternalRoleSkeleton>",
    description: "Delete internal role",
    params: [
      { name: "roleId", type: "string", description: "internal role uuid" },
    ],
    returns: "{Promise<InternalRoleSkeleton>} a promise that resolves to an internal role object",
  },
  {
    typeName: "InternalRole",
    methodName: "deleteInternalRoleByName",
    signature: "deleteInternalRoleByName(roleName: string): Promise<InternalRoleSkeleton>",
    description: "Delete internal role by name",
    params: [
      { name: "roleName", type: "string", description: "internal role name" },
    ],
    returns: "{Promise<InternalRoleSkeleton>} a promise that resolves to an internal role object",
  },
  {
    typeName: "InternalRole",
    methodName: "deleteInternalRoles",
    signature: "deleteInternalRoles(): Promise<InternalRoleSkeleton[]>",
    description: "Delete all internal roles",
    params: [],
    returns: "{Promise<InternalRoleSkeleton[]>} a promise that resolves to an array of internal role objects",
  },
  {
    typeName: "InternalRole",
    methodName: "queryInternalRoles",
    signature: "queryInternalRoles( filter: string, fields?: string[] ): Promise<InternalRoleSkeleton[]>",
    description: "Query internal roles",
    params: [
      { name: "filter", type: "", description: "CREST search filter" },
      { name: "fields", type: "", description: "array of fields to return" },
    ],
    returns: "",
  },
  {
    typeName: "InternalRole",
    methodName: "exportInternalRole",
    signature: "exportInternalRole(roleId: string): Promise<InternalRoleExportInterface>",
    description: "Export internal role. The response can be saved to file as is.",
    params: [
      { name: "roleId", type: "string", description: "internal role uuid" },
    ],
    returns: "{Promise<InternalRoleExportInterface} Promise resolving to an InternalRoleExportInterface object.",
  },
  {
    typeName: "InternalRole",
    methodName: "exportInternalRoleByName",
    signature: "exportInternalRoleByName( roleName: string ): Promise<InternalRoleExportInterface>",
    description: "Export internal role by name. The response can be saved to file as is.",
    params: [
      { name: "roleName", type: "string", description: "internal role name" },
    ],
    returns: "{Promise<InternalRoleExportInterface} Promise resolving to an InternalRoleExportInterface object.",
  },
  {
    typeName: "InternalRole",
    methodName: "exportInternalRoles",
    signature: "exportInternalRoles(): Promise<InternalRoleExportInterface>",
    description: "Export all internal roles. The response can be saved to file as is.",
    params: [],
    returns: "{Promise<InternalRoleExportInterface>} Promise resolving to an InternalRoleExportInterface object.",
  },
  {
    typeName: "InternalRole",
    methodName: "importInternalRole",
    signature: "importInternalRole( roleId: string, importData: InternalRoleExportInterface ): Promise<InternalRoleSkeleton>",
    description: "Import internal role. The import data is usually read from an internal role export file.",
    params: [
      { name: "roleId", type: "string", description: "internal role uuid" },
      { name: "importData", type: "InternalRoleExportInterface", description: "internal role import data." },
    ],
    returns: "{Promise<InternalRoleSkeleton>} Promise resolving to an internal role object.",
  },
  {
    typeName: "InternalRole",
    methodName: "importInternalRoleByName",
    signature: "importInternalRoleByName( roleName: string, importData: InternalRoleExportInterface ): Promise<InternalRoleSkeleton>",
    description: "Import internal role by name. The import data is usually read from an internal role export file.",
    params: [
      { name: "roleName", type: "string", description: "internal role name" },
      { name: "importData", type: "InternalRoleExportInterface", description: "internal role import data." },
    ],
    returns: "{Promise<InternalRoleSkeleton>} Promise resolving to an internal role object.",
  },
  {
    typeName: "InternalRole",
    methodName: "importFirstInternalRole",
    signature: "importFirstInternalRole( importData: InternalRoleExportInterface ): Promise<InternalRoleSkeleton[]>",
    description: "Import first internal role. The import data is usually read from an internal role export file.",
    params: [
      { name: "importData", type: "InternalRoleExportInterface", description: "internal role import data." },
    ],
    returns: "",
  },
  {
    typeName: "InternalRole",
    methodName: "importInternalRoles",
    signature: "importInternalRoles( importData: InternalRoleExportInterface ): Promise<InternalRoleSkeleton[]>",
    description: "Import internal roles. The import data is usually read from an internal role export file.",
    params: [
      { name: "importData", type: "InternalRoleExportInterface", description: "internal role import data." },
    ],
    returns: "",
  },
  {
    typeName: "Jose",
    methodName: "createJwkRsa",
    signature: "createJwkRsa(): Promise<JwkRsa>",
    description: "",
    params: [],
    returns: "",
  },
  {
    typeName: "Jose",
    methodName: "getJwkRsaPublic",
    signature: "getJwkRsaPublic(jwkJson: JwkRsa): Promise<JwkRsaPublic>",
    description: "",
    params: [],
    returns: "",
  },
  {
    typeName: "Jose",
    methodName: "createJwks",
    signature: "createJwks(...keys: JwkInterface[]): JwksInterface",
    description: "",
    params: [],
    returns: "",
  },
  {
    typeName: "Jose",
    methodName: "createSignedJwtToken",
    signature: "createSignedJwtToken(payload: string | object, jwkJson: JwkRsa): Promise<any>",
    description: "",
    params: [],
    returns: "",
  },
  {
    typeName: "Jose",
    methodName: "verifySignedJwtToken",
    signature: "verifySignedJwtToken(jwt: string, jwkJson: JwkRsaPublic): Promise<any>",
    description: "",
    params: [],
    returns: "",
  },
  {
    typeName: "Journey",
    methodName: "createSingleTreeExportTemplate",
    signature: "createSingleTreeExportTemplate(): SingleTreeExportInterface",
    description: "Create an empty single tree export template",
    params: [],
    returns: "{SingleTreeExportInterface} an empty single tree export template",
  },
  {
    typeName: "Journey",
    methodName: "createMultiTreeExportTemplate",
    signature: "createMultiTreeExportTemplate(): MultiTreeExportInterface",
    description: "Create an empty multi tree export template",
    params: [],
    returns: "{MultiTreeExportInterface} an empty multi tree export template",
  },
  {
    typeName: "Journey",
    methodName: "exportJourney",
    signature: "exportJourney( treeId: string, options?: TreeExportOptions ): Promise<SingleTreeExportInterface>",
    description: "Create export data for a tree/journey with all its nodes and dependencies. The export data can be written to a file as is.",
    params: [
      { name: "treeId", type: "string", description: "tree id/name" },
      { name: "options", type: "TreeExportOptions", description: "export options" },
    ],
    returns: "{Promise<SingleTreeExportInterface>} a promise that resolves to an object containing the tree and all its nodes and dependencies",
  },
  {
    typeName: "Journey",
    methodName: "exportJourneys",
    signature: "exportJourneys( options?: TreeExportOptions, resultCallback?: ResultCallback<SingleTreeExportInterface> ): Promise<MultiTreeExportInterface>",
    description: "Create export data for all trees/journeys with all their nodes and dependencies. The export data can be written to a file as is.",
    params: [
      { name: "options", type: "TreeExportOptions", description: "export options" },
      { name: "resultCallback", type: "ResultCallback", description: "Optional callback to process individual results" },
    ],
    returns: "{Promise<MultiTreeExportInterface>} a promise that resolves to an object containing the trees and all their nodes and dependencies",
  },
  {
    typeName: "Journey",
    methodName: "readJourneys",
    signature: "readJourneys(): Promise<TreeSkeleton[]>",
    description: "Read all journeys without dependencies.",
    params: [],
    returns: "{Promise<TreeSkeleton[]>} a promise that resolves to an array of journey objects",
  },
  {
    typeName: "Journey",
    methodName: "countJourneys",
    signature: "countJourneys(): Promise<number>",
    description: "Count all journeys in the active realm.",
    params: [],
    returns: "{Promise<number>} exact count when supported by the backing API",
  },
  {
    typeName: "Journey",
    methodName: "readJourney",
    signature: "readJourney(journeyId: string): Promise<TreeSkeleton>",
    description: "Read journey without dependencies.",
    params: [
      { name: "journeyId", type: "string", description: "journey id/name" },
    ],
    returns: "{Promise<TreeSkeleton>} a promise that resolves to a journey object",
  },
  {
    typeName: "Journey",
    methodName: "createJourney",
    signature: "createJourney( journeyId: string, journeyData: TreeSkeleton ): Promise<TreeSkeleton>",
    description: "Create journey without dependencies.",
    params: [
      { name: "journeyId", type: "string", description: "journey id/name" },
    ],
    returns: "{Promise<TreeSkeleton>} a promise that resolves to a journey object",
  },
  {
    typeName: "Journey",
    methodName: "updateJourney",
    signature: "updateJourney( journeyId: string, journeyData: TreeSkeleton ): Promise<TreeSkeleton>",
    description: "Update journey without dependencies.",
    params: [
      { name: "journeyId", type: "string", description: "journey id/name" },
    ],
    returns: "{Promise<TreeSkeleton>} a promise that resolves to a journey object",
  },
  {
    typeName: "Journey",
    methodName: "importJourney",
    signature: "importJourney( treeObject: SingleTreeExportInterface, options: TreeImportOptions ): Promise<TreeSkeleton>",
    description: "Import journey",
    params: [
      { name: "treeObject", type: "SingleTreeExportInterface", description: "tree object containing tree and all its dependencies" },
      { name: "options", type: "TreeImportOptions", description: "import options" },
    ],
    returns: "{Promise<TreeSkeleton>} a promise that resolves to a journey object",
  },
  {
    typeName: "Journey",
    methodName: "resolveDependencies",
    signature: "resolveDependencies( installedJorneys: any, journeyMap: any, unresolvedJourneys: any, resolvedJourneys: any, index?: number ): Promise<void>",
    description: "Resolve journey dependencies",
    params: [
      { name: "installedJorneys", type: "string[]", description: "Map of installed journeys" },
      { name: "journeyMap", type: "Record<string, SingleTreeExportInterface>", description: "Map of journeys to resolve dependencies for" },
      { name: "unresolvedJourneys", type: "string[]", description: "Map to hold the names of unresolved journeys and their dependencies" },
      { name: "resolvedJourneys", type: "string[]", description: "Array to hold the names of resolved journeys" },
      { name: "index", type: "int", description: "Depth of recursion" },
    ],
    returns: "",
  },
  {
    typeName: "Journey",
    methodName: "importJourneys",
    signature: "importJourneys( importData: MultiTreeExportInterface, options: TreeImportOptions, resultCallback?: ResultCallback<TreeSkeleton> ): Promise<TreeSkeleton[]>",
    description: "Import journeys",
    params: [
      { name: "importData", type: "MultiTreeExportInterface", description: "map of trees object" },
      { name: "options", type: "TreeImportOptions", description: "import options" },
      { name: "resultCallback", type: "ResultCallback", description: "Optional callback to process individual results" },
    ],
    returns: "",
  },
  {
    typeName: "Journey",
    methodName: "getNodeRef",
    signature: "getNodeRef( nodeObj: NodeSkeleton, singleTreeExport: SingleTreeExportInterface ): NodeRefSkeletonInterface | InnerNodeRefSkeletonInterface",
    description: "Get the node reference obbject for a node object. Node reference objects are used in a tree flow definition and within page nodes to reference nodes. Among other things, node references contain all the non-configuration meta data that exists for readaility, like the x/y coordinates of the node and the display name chosen by the tree designer. The dislay name is the only intuitive link between the graphical representation of the tree and the node configurations that make up the tree.",
    params: [
      { name: "nodeObj", type: "", description: "node object to retrieve the node reference object for" },
      { name: "singleTreeExport", type: "", description: "tree export with or without dependencies" },
    ],
    returns: "{NodeRefSkeletonInterface | InnerNodeRefSkeletonInterface} node reference object",
  },
  {
    typeName: "Journey",
    methodName: "createFileParamTreeExportResolver",
    signature: "createFileParamTreeExportResolver(file: string): TreeExportResolverInterface",
    description: "Factory that creates a tree export resolver used to resolve a tree id to a full export of that tree from a multi-tree export file.",
    params: [
      { name: "file", type: "string", description: "multi-tree export file" },
    ],
    returns: "{TreeExportResolverInterface} tree export resolver",
  },
  {
    typeName: "Journey",
    methodName: "getTreeDescendents",
    signature: "getTreeDescendents( treeExport: SingleTreeExportInterface, resolveTreeExport: TreeExportResolverInterface, resolvedTreeIds?: string[] ): Promise<TreeDependencyMapInterface>",
    description: "Get tree dependencies (all descendent inner trees)",
    params: [
      { name: "treeExport", type: "SingleTreeExportInterface", description: "single tree export" },
      { name: "resolvedTreeIds", type: "string[]", description: "list of tree ids wich have already been resolved" },
      { name: "resolveTreeExport", type: "TreeExportResolverInterface", description: "tree export resolver callback function" },
    ],
    returns: "{Promise<TreeDependencyMapInterface>} a promise that resolves to a tree dependency map",
  },
  {
    typeName: "Journey",
    methodName: "deleteJourney",
    signature: "deleteJourney( journeyId: string, options: { deep: boolean",
    description: "Delete a journey",
    params: [
      { name: "journeyId", type: "string", description: "journey id/name" },
      { name: "options", type: "Object", description: "deep=true also delete all the nodes and inner nodes, verbose=true print verbose info" },
    ],
    returns: "",
  },
  {
    typeName: "ManagedObject",
    methodName: "readManagedObjectSchema",
    signature: "readManagedObjectSchema( type: string, refreshCache?: boolean, options?: ManagedObjectSchemaOptions ): Promise<ManagedObjectSchema>",
    description: "Read managed object schema",
    params: [
      { name: "type", type: "string", description: "managed object type, e.g. alpha_user or user" },
      { name: "refreshCache", type: "boolean", description: "whether to refresh the schema cache for the specified type" },
      { name: "options", type: "ManagedObjectSchemaOptions", description: "options to filter the returned schema" },
    ],
    returns: "{Promise<ManagedObjectSchema>} a promise that resolves to a managed object schema",
  },
  {
    typeName: "ManagedObject",
    methodName: "createManagedObject",
    signature: "createManagedObject( type: string, moData: IdObjectSkeletonInterface, id?: string ): Promise<IdObjectSkeletonInterface>",
    description: "Create managed object",
    params: [
      { name: "type", type: "string", description: "managed object type, e.g. teammember or alpha_user" },
      { name: "moData", type: "IdObjectSkeletonInterface", description: "managed object data" },
      { name: "id", type: "string", description: "managed object _id" },
    ],
    returns: "",
  },
  {
    typeName: "ManagedObject",
    methodName: "readManagedObject",
    signature: "readManagedObject( type: string, id: string, fields?: string[] ): Promise<IdObjectSkeletonInterface>",
    description: "Read managed object",
    params: [
      { name: "type", type: "string", description: "managed object type, e.g. alpha_user or user" },
      { name: "id", type: "string", description: "managed object id" },
      { name: "fields", type: "string[]", description: "array of fields to include" },
    ],
    returns: "{Promise<IdObjectSkeletonInterface>} a promise that resolves to an IdObjectSkeletonInterface",
  },
  {
    typeName: "ManagedObject",
    methodName: "readManagedObjects",
    signature: "readManagedObjects( type: string, fields?: string[] ): Promise<IdObjectSkeletonInterface[]>",
    description: "Read all managed object of the specified type",
    params: [
      { name: "type", type: "string", description: "managed object type, e.g. alpha_user or user" },
      { name: "fields", type: "string[]", description: "array of fields to return" },
    ],
    returns: "{Promise<IdObjectSkeletonInterface[]>} a promise that resolves to an array of IdObjectSkeletonInterfaces",
  },
  {
    typeName: "ManagedObject",
    methodName: "countManagedObjects",
    signature: "countManagedObjects(type: string, filter?: string): Promise<number>",
    description: "Count managed objects of the specified type.",
    params: [
      { name: "type", type: "string", description: "managed object type, e.g. alpha_user or user" },
      { name: "filter", type: "string", description: "CREST search filter" },
    ],
    returns: "{Promise<number>} a promise that resolves to the object count",
  },
  {
    typeName: "ManagedObject",
    methodName: "updateManagedObject",
    signature: "updateManagedObject( type: string, id: string, moData: IdObjectSkeletonInterface ): Promise<IdObjectSkeletonInterface>",
    description: "Update managed object",
    params: [
      { name: "type", type: "string", description: "managed object type, e.g. alpha_user or user" },
      { name: "id", type: "string", description: "managed object id" },
      { name: "moData", type: "IdObjectSkeletonInterface", description: "managed object data" },
    ],
    returns: "{Promise<IdObjectSkeletonInterface>} a promise that resolves to an IdObjectSkeletonInterface",
  },
  {
    typeName: "ManagedObject",
    methodName: "updateManagedObjectProperties",
    signature: "updateManagedObjectProperties( type: string, id: string, operations: PatchOperationInterface[], rev?: string ): Promise<IdObjectSkeletonInterface>",
    description: "Partially update managed object through a collection of patch operations.",
    params: [
      { name: "type", type: "string", description: "managed object type, e.g. alpha_user or user" },
      { name: "id", type: "string", description: "managed object id" },
      { name: "operations", type: "PatchOperationInterface[]", description: "collection of patch operations to perform on the object" },
      { name: "rev", type: "string", description: "managed object revision" },
    ],
    returns: "{Promise<IdObjectSkeletonInterface>} a promise that resolves to an IdObjectSkeletonInterface",
  },
  {
    typeName: "ManagedObject",
    methodName: "updateManagedObjectsProperties",
    signature: "updateManagedObjectsProperties( type: string, filter: string, operations: PatchOperationInterface[], rev?: string, pageSize?: number ): Promise<IdObjectSkeletonInterface[]>",
    description: "Partially update multiple managed object through a collection of patch operations.",
    params: [
      { name: "type", type: "string", description: "managed object type, e.g. alpha_user or user" },
      { name: "filter", type: "string", description: "CREST search filter" },
      { name: "operations", type: "PatchOperationInterface[]", description: "collection of patch operations to perform on the object" },
      { name: "rev", type: "string", description: "managed object revision" },
      { name: "pageSize", type: "number", description: "page size" },
    ],
    returns: "{Promise<IdObjectSkeletonInterface>} a promise that resolves to an IdObjectSkeletonInterface",
  },
  {
    typeName: "ManagedObject",
    methodName: "deleteManagedObject",
    signature: "deleteManagedObject( type: string, id: string ): Promise<IdObjectSkeletonInterface>",
    description: "Delete managed object",
    params: [
      { name: "type", type: "string", description: "managed object type, e.g. alpha_user or user" },
      { name: "id", type: "string", description: "managed object id" },
    ],
    returns: "{Promise<IdObjectSkeletonInterface>} a promise that resolves to an IdObjectSkeletonInterface",
  },
  {
    typeName: "ManagedObject",
    methodName: "deleteManagedObjects",
    signature: "deleteManagedObjects(type: string, filter: string): Promise<number>",
    description: "Delete managed objects by filter",
    params: [
      { name: "type", type: "string", description: "managed object type, e.g. alpha_user or user" },
      { name: "filter", type: "string", description: "filter" },
    ],
    returns: "{Promise<number>} a promise that resolves the number of deleted objects",
  },
  {
    typeName: "ManagedObject",
    methodName: "queryManagedObjects",
    signature: "queryManagedObjects( type: string, filter?: string, fields?: string[], pageSize?: number ): Promise<IdObjectSkeletonInterface[]>",
    description: "Query managed objects",
    params: [
      { name: "type", type: "string", description: "managed object type, e.g. alpha_user or user" },
      { name: "filter", type: "string", description: "CREST search filter" },
      { name: "fields", type: "string[]", description: "array of fields to return" },
    ],
    returns: "{Promise<IdObjectSkeletonInterface[]>} a promise resolving to an array of managed objects",
  },
  {
    typeName: "ManagedObject",
    methodName: "queryRelatedManagedObjects",
    signature: "queryRelatedManagedObjects( type: string, id: string, relationship: string, fields?: string[], pageSize?: number ): Promise<IdObjectSkeletonInterface[]>",
    description: "Query related managed objects",
    params: [
      { name: "type", type: "string", description: "managed object type, e.g. alpha_user or user" },
      { name: "id", type: "string", description: "managed object id" },
      { name: "relationship", type: "string", description: "name of the relationship to query, e.g. \"members\" for team membership relationships" },
      { name: "fields", type: "string[]", description: "array of fields to return" },
    ],
    returns: "{Promise<IdObjectSkeletonInterface[]>} a promise resolving to an array of managed objects",
  },
  {
    typeName: "ManagedObject",
    methodName: "resolveUserName",
    signature: "resolveUserName(type: string, id: string): Promise<string>",
    description: "Resolve a managed object's uuid to a human readable username",
    params: [
      { name: "type", type: "string", description: "managed object type, e.g. teammember or alpha_user" },
      { name: "id", type: "string", description: "managed object _id" },
    ],
    returns: "{Promise<string>} resolved username or uuid if any error occurs during reslution",
  },
  {
    typeName: "ManagedObject",
    methodName: "resolveFullName",
    signature: "resolveFullName(type: string, id: string): Promise<string>",
    description: "Resolve a managed object's uuid to a human readable full name",
    params: [
      { name: "type", type: "string", description: "managed object type, e.g. teammember or alpha_user" },
      { name: "id", type: "string", description: "managed object _id" },
    ],
    returns: "{Promise<string>} resolved full name or uuid if any error occurs during reslution",
  },
  {
    typeName: "ManagedObject",
    methodName: "resolvePerpetratorUuid",
    signature: "resolvePerpetratorUuid(id: string): Promise<string>",
    description: "Resolve a perpetrator's uuid to a human readable string identifying the perpetrator",
    params: [
      { name: "id", type: "string", description: "managed object _id" },
    ],
    returns: "{Promise<string>} resolved perpetrator descriptive string or uuid if any error occurs during reslution",
  },
  {
    typeName: "ManagedObject",
    methodName: "readManagedSystemObjectSchema",
    signature: "readManagedSystemObjectSchema( type: string, refreshCache?: boolean, options?: ManagedObjectSchemaOptions ): Promise<ManagedObjectSchema>",
    description: "Read managed system object schema",
    params: [
      { name: "type", type: "string", description: "managed system object type, e.g. svcacct or teammember" },
      { name: "refreshCache", type: "boolean", description: "whether to refresh the schema cache for the specified type" },
      { name: "options", type: "ManagedObjectSchemaOptions", description: "options to filter the returned schema" },
    ],
    returns: "{Promise<ManagedObjectSchema>} a promise that resolves to a managed system object schema",
  },
  {
    typeName: "ManagedObject",
    methodName: "createManagedSystemObject",
    signature: "createManagedSystemObject( type: string, moData: IdObjectSkeletonInterface, id?: string ): Promise<IdObjectSkeletonInterface>",
    description: "Create managed system object",
    params: [
      { name: "type", type: "string", description: "managed system object type, e.g. teammember or alpha_user" },
      { name: "moData", type: "IdObjectSkeletonInterface", description: "managed system object data" },
      { name: "id", type: "string", description: "managed system object _id" },
    ],
    returns: "",
  },
  {
    typeName: "ManagedObject",
    methodName: "readManagedSystemObject",
    signature: "readManagedSystemObject( type: string, id: string, fields: string[] ): Promise<IdObjectSkeletonInterface>",
    description: "Read managed system object",
    params: [
      { name: "type", type: "string", description: "managed system object type, e.g. alpha_user or user" },
      { name: "id", type: "string", description: "managed system object id" },
      { name: "id", type: "string[]", description: "array of fields to include" },
    ],
    returns: "{Promise<IdObjectSkeletonInterface>} a promise that resolves to an IdObjectSkeletonInterface",
  },
  {
    typeName: "ManagedObject",
    methodName: "readManagedSystemObjects",
    signature: "readManagedSystemObjects( type: string, fields: string[] ): Promise<IdObjectSkeletonInterface[]>",
    description: "Read all managed system object of the specified type",
    params: [
      { name: "type", type: "string", description: "managed system object type, e.g. alpha_user or user" },
      { name: "fields", type: "string[]", description: "array of fields to return" },
    ],
    returns: "{Promise<IdObjectSkeletonInterface[]>} a promise that resolves to an array of IdObjectSkeletonInterfaces",
  },
  {
    typeName: "ManagedObject",
    methodName: "countManagedSystemObjects",
    signature: "countManagedSystemObjects(type: string, filter?: string): Promise<number>",
    description: "Count managed system objects of the specified type.",
    params: [
      { name: "type", type: "string", description: "managed system object type, e.g. teammember or svcacct" },
      { name: "filter", type: "string", description: "CREST search filter" },
    ],
    returns: "{Promise<number>} a promise that resolves to the object count",
  },
  {
    typeName: "ManagedObject",
    methodName: "updateManagedSystemObject",
    signature: "updateManagedSystemObject( type: string, id: string, moData: IdObjectSkeletonInterface ): Promise<IdObjectSkeletonInterface>",
    description: "Update managed system object",
    params: [
      { name: "type", type: "string", description: "managed system object type, e.g. alpha_user or user" },
      { name: "id", type: "string", description: "managed system object id" },
      { name: "moData", type: "IdObjectSkeletonInterface", description: "managed system object data" },
    ],
    returns: "{Promise<IdObjectSkeletonInterface>} a promise that resolves to an IdObjectSkeletonInterface",
  },
  {
    typeName: "ManagedObject",
    methodName: "updateManagedSystemObjectProperties",
    signature: "updateManagedSystemObjectProperties( type: string, id: string, operations: PatchOperationInterface[], rev?: string ): Promise<IdObjectSkeletonInterface>",
    description: "Partially update managed system object through a collection of patch operations.",
    params: [
      { name: "type", type: "string", description: "managed system object type, e.g. alpha_user or user" },
      { name: "id", type: "string", description: "managed system object id" },
      { name: "operations", type: "PatchOperationInterface[]", description: "collection of patch operations to perform on the object" },
      { name: "rev", type: "string", description: "managed system object revision" },
    ],
    returns: "{Promise<IdObjectSkeletonInterface>} a promise that resolves to an IdObjectSkeletonInterface",
  },
  {
    typeName: "ManagedObject",
    methodName: "updateManagedSystemObjectsProperties",
    signature: "updateManagedSystemObjectsProperties( type: string, filter: string, operations: PatchOperationInterface[], rev?: string, pageSize?: number ): Promise<IdObjectSkeletonInterface[]>",
    description: "Partially update multiple managed system object through a collection of patch operations.",
    params: [
      { name: "type", type: "string", description: "managed system object type, e.g. alpha_user or user" },
      { name: "filter", type: "string", description: "CREST search filter" },
      { name: "operations", type: "PatchOperationInterface[]", description: "collection of patch operations to perform on the object" },
      { name: "rev", type: "string", description: "managed system object revision" },
      { name: "pageSize", type: "number", description: "page size" },
    ],
    returns: "{Promise<IdObjectSkeletonInterface>} a promise that resolves to an IdObjectSkeletonInterface",
  },
  {
    typeName: "ManagedObject",
    methodName: "deleteManagedSystemObject",
    signature: "deleteManagedSystemObject( type: string, id: string ): Promise<IdObjectSkeletonInterface>",
    description: "Delete managed system object",
    params: [
      { name: "type", type: "string", description: "managed system object type, e.g. alpha_user or user" },
      { name: "id", type: "string", description: "managed system object id" },
    ],
    returns: "{Promise<IdObjectSkeletonInterface>} a promise that resolves to an IdObjectSkeletonInterface",
  },
  {
    typeName: "ManagedObject",
    methodName: "deleteManagedSystemObjects",
    signature: "deleteManagedSystemObjects(type: string, filter: string): Promise<number>",
    description: "Delete managed system objects by filter",
    params: [
      { name: "type", type: "string", description: "managed system object type, e.g. alpha_user or user" },
      { name: "filter", type: "string", description: "filter" },
    ],
    returns: "{Promise<number>} a promise that resolves the number of deleted objects",
  },
  {
    typeName: "ManagedObject",
    methodName: "queryManagedSystemObjects",
    signature: "queryManagedSystemObjects( type: string, filter?: string, fields?: string[], pageSize?: number ): Promise<IdObjectSkeletonInterface[]>",
    description: "Query managed system objects",
    params: [
      { name: "type", type: "string", description: "managed system object type, e.g. alpha_user or user" },
      { name: "filter", type: "string", description: "CREST search filter" },
      { name: "fields", type: "string[]", description: "array of fields to return" },
    ],
    returns: "{Promise<IdObjectSkeletonInterface[]>} a promise resolving to an array of managed system objects",
  },
  {
    typeName: "ManagedObject",
    methodName: "resolveUserName",
    signature: "resolveUserName(type: string, id: string): Promise<string>",
    description: "Resolve a managed system object's uuid to a human readable username",
    params: [
      { name: "type", type: "string", description: "managed system object type, e.g. teammember or alpha_user" },
      { name: "id", type: "string", description: "managed system object _id" },
    ],
    returns: "{Promise<string>} resolved username or uuid if any error occurs during reslution",
  },
  {
    typeName: "ManagedObject",
    methodName: "resolveFullName",
    signature: "resolveFullName(type: string, id: string): Promise<string>",
    description: "Resolve a managed system object's uuid to a human readable full name",
    params: [
      { name: "type", type: "string", description: "managed system object type, e.g. teammember or alpha_user" },
      { name: "id", type: "string", description: "managed system object _id" },
    ],
    returns: "{Promise<string>} resolved full name or uuid if any error occurs during reslution",
  },
  {
    typeName: "ManagedObject",
    methodName: "resolvePerpetratorUuid",
    signature: "resolvePerpetratorUuid(id: string): Promise<string>",
    description: "Resolve a perpetrator's uuid to a human readable string identifying the perpetrator",
    params: [
      { name: "id", type: "string", description: "managed system object _id" },
    ],
    returns: "{Promise<string>} resolved perpetrator descriptive string or uuid if any error occurs during reslution",
  },
  {
    typeName: "Mapping",
    methodName: "createMappingExportTemplate",
    signature: "createMappingExportTemplate(): MappingExportInterface",
    description: "Create an empty mapping export template",
    params: [],
    returns: "{MappingExportInterface} an empty mapping export template",
  },
  {
    typeName: "Mapping",
    methodName: "readSyncMappings",
    signature: "readSyncMappings(): Promise<MappingSkeleton[]>",
    description: "Read mappings from sync.json (legacy)",
    params: [],
    returns: "{Promise<MappingSkeleton[]>} a promise that resolves to an array of mapping objects",
  },
  {
    typeName: "Mapping",
    methodName: "readMappings",
    signature: "readMappings( connectorId?: string, moType?: string ): Promise<MappingSkeleton[]>",
    description: "Read mappings",
    params: [
      { name: "connectorId", type: "string", description: "limit mappings to connector" },
      { name: "moType", type: "string", description: "limit mappings to managed object type" },
    ],
    returns: "{Promise<MappingSkeleton[]>} a promise that resolves to an array of mapping objects",
  },
  {
    typeName: "Mapping",
    methodName: "readMapping",
    signature: "readMapping(mappingId: string): Promise<MappingSkeleton>",
    description: "Read mapping",
    params: [
      { name: "mappingId", type: "string", description: "id of the mapping (new: 'mapping/\\<name>', legacy: 'sync/\\<name>')" },
    ],
    returns: "{Promise<MappingSkeleton>} a promise that resolves an mapping object",
  },
  {
    typeName: "Mapping",
    methodName: "createMapping",
    signature: "createMapping( mappingId: string, mappingData: MappingSkeleton ): Promise<MappingSkeleton>",
    description: "Create mapping",
    params: [
      { name: "mappingId", type: "string", description: "id of the mapping (new: 'mapping/\\<name>', legacy: 'sync/\\<name>')" },
      { name: "mappingData", type: "MappingSkeleton", description: "mapping object" },
    ],
    returns: "{Promise<MappingSkeleton>} a promise that resolves to an mapping object",
  },
  {
    typeName: "Mapping",
    methodName: "updateMapping",
    signature: "updateMapping( mappingId: string, mappingData: MappingSkeleton ): Promise<MappingSkeleton>",
    description: "Update or create mapping",
    params: [
      { name: "mappingId", type: "string", description: "id of the mapping (new: 'mapping/\\<name>', legacy: 'sync/\\<name>')" },
      { name: "mappingData", type: "MappingSkeleton", description: "mapping object" },
    ],
    returns: "{Promise<MappingSkeleton>} a promise that resolves to an mapping object",
  },
  {
    typeName: "Mapping",
    methodName: "updateSyncMappings",
    signature: "updateSyncMappings(mappings: MappingSkeleton[]): Promise<MappingSkeleton[]>",
    description: "Update or create mappings in sync.json (legacy)",
    params: [
      { name: "mappingData", type: "MappingSkeleton", description: "mapping object" },
    ],
    returns: "{Promise<MappingSkeleton>} a promise that resolves to an mapping object",
  },
  {
    typeName: "Mapping",
    methodName: "deleteMappings",
    signature: "deleteMappings( connectorId?: string, moType?: string ): Promise<MappingSkeleton[]>",
    description: "Delete all mappings",
    params: [
      { name: "connectorId", type: "string", description: "limit mappings to connector" },
      { name: "moType", type: "string", description: "limit mappings to managed object type" },
    ],
    returns: "{Promise<MappingSkeleton[]>} a promise that resolves to an array of mapping objects",
  },
  {
    typeName: "Mapping",
    methodName: "deleteMapping",
    signature: "deleteMapping(mappingId: string): Promise<MappingSkeleton>",
    description: "Delete mapping",
    params: [
      { name: "mappingId", type: "string", description: "id of the mapping (new: 'mapping/\\<name>', legacy: 'sync/\\<name>')" },
    ],
    returns: "{Promise<MappingSkeleton>} a promise that resolves an mapping object",
  },
  {
    typeName: "Mapping",
    methodName: "exportMapping",
    signature: "exportMapping( mappingId: string, options?: MappingExportOptions ): Promise<MappingExportInterface>",
    description: "Export mapping",
    params: [
      { name: "mappingId", type: "string", description: "id of the mapping (new: 'mapping/\\<name>', legacy: 'sync/\\<name>')" },
      { name: "options", type: "MappingExportOptions", description: "export options" },
    ],
    returns: "{Promise<MappingExportInterface>} a promise that resolves to a MappingExportInterface object",
  },
  {
    typeName: "Mapping",
    methodName: "exportMappings",
    signature: "exportMappings( options?: MappingExportOptions ): Promise<MappingExportInterface>",
    description: "Export all mappings",
    params: [
      { name: "options", type: "MappingExportOptions", description: "export options" },
    ],
    returns: "{Promise<MappingExportInterface>} a promise that resolves to a MappingExportInterface object",
  },
  {
    typeName: "Mapping",
    methodName: "importMapping",
    signature: "importMapping( mappingId: string, importData: MappingExportInterface, options?: MappingImportOptions ): Promise<MappingSkeleton>",
    description: "Import mapping",
    params: [
      { name: "mappingId", type: "string", description: "id of the mapping (new: 'mapping/\\<name>', legacy: 'sync/\\<name>')" },
      { name: "importData", type: "MappingExportInterface", description: "import data" },
      { name: "options", type: "MappingImportOptions", description: "import options" },
    ],
    returns: "{Promise<MappingSkeleton>} a promise resolving to a MappingSkeleton object",
  },
  {
    typeName: "Mapping",
    methodName: "importFirstMapping",
    signature: "importFirstMapping( importData: MappingExportInterface, options?: MappingImportOptions ): Promise<MappingSkeleton>",
    description: "Import first mapping",
    params: [
      { name: "importData", type: "MappingExportInterface", description: "import data" },
      { name: "options", type: "MappingImportOptions", description: "import options" },
    ],
    returns: "{Promise<MappingSkeleton>} a promise resolving to a MappingSkeleton object",
  },
  {
    typeName: "Mapping",
    methodName: "importMappings",
    signature: "importMappings( importData: MappingExportInterface, options?: MappingImportOptions ): Promise<MappingSkeleton[]>",
    description: "Import all mappings",
    params: [
      { name: "importData", type: "MappingExportInterface", description: "import data" },
      { name: "options", type: "MappingImportOptions", description: "import options" },
    ],
    returns: "{Promise<MappingSkeleton[]>} a promise resolving to an array of MappingSkeleton objects",
  },
  {
    typeName: "Mapping",
    methodName: "isLegacyMapping",
    signature: "isLegacyMapping(mappingId: string): boolean",
    description: "Helper that returns a boolean indicating whether the mapping is a legacy mapping or not given the id",
    params: [
      { name: "mappingId", type: "string", description: "the mapping id" },
    ],
    returns: "{boolean} true if the mapping is a legacy mapping, false otherwise",
  },
  {
    typeName: "Node",
    methodName: "readNodeTypes",
    signature: "readNodeTypes(): Promise<any>",
    description: "Read all node types",
    params: [],
    returns: "{Promise<any>} a promise that resolves to an array of node type objects",
  },
  {
    typeName: "Node",
    methodName: "readNodeType",
    signature: "readNodeType(nodeType: string, nodeTypeVersion?: string): Promise<any>",
    description: "Read a specific node type",
    params: [
      { name: "nodeType", type: "string", description: "node type" },
      { name: "nodeTypeVersion", type: "string", description: "node type version" },
    ],
    returns: "{Promise<any>} a promise that resolves to a node type object",
  },
  {
    typeName: "Node",
    methodName: "readNodes",
    signature: "readNodes(): Promise<NodeSkeleton[]>",
    description: "Read all nodes",
    params: [],
    returns: "{Promise<NodeSkeleton[]>} a promise that resolves to an object containing an array of node objects",
  },
  {
    typeName: "Node",
    methodName: "readNodesByVersion",
    signature: "readNodesByVersion( nodeVersionFilter?: NodeVersionFilter ): Promise<NodeSkeleton[]>",
    description: "Read all nodes across types and versions with optional version filtering.",
    params: [
      { name: "nodeVersionFilter", type: "NodeVersionFilter", description: "optional node version filter" },
    ],
    returns: "{Promise<NodeSkeleton[]>} matched node instances",
  },
  {
    typeName: "Node",
    methodName: "readNodesByType",
    signature: "readNodesByType( nodeType: string, nodeTypeVersion?: string ): Promise<NodeSkeleton[]>",
    description: "Read all nodes by type",
    params: [
      { name: "nodeType", type: "string", description: "node type" },
      { name: "nodeTypeVersion", type: "string", description: "node type version" },
    ],
    returns: "{Promise<NodeSkeleton[]>} a promise that resolves to an object containing an array of node objects of the requested type",
  },
  {
    typeName: "Node",
    methodName: "readNode",
    signature: "readNode( nodeId: string, nodeType: string, nodeTypeVersion?: string ): Promise<NodeSkeleton>",
    description: "Read node by uuid and type",
    params: [
      { name: "nodeId", type: "string", description: "node uuid" },
      { name: "nodeType", type: "string", description: "node type" },
      { name: "nodeTypeVersion", type: "string", description: "node type version" },
    ],
    returns: "{Promise<NodeSkeleton>} a promise that resolves to a node object",
  },
  {
    typeName: "Node",
    methodName: "exportNodes",
    signature: "exportNodes(): Promise<NodeExportInterface>",
    description: "Export all nodes",
    params: [],
    returns: "{Promise<NodeExportInterface>} a promise that resolves to an array of node objects",
  },
  {
    typeName: "Node",
    methodName: "createNode",
    signature: "createNode(nodeType: string, nodeData: NodeSkeleton): Promise<NodeSkeleton>",
    description: "Create node by type",
    params: [
      { name: "nodeType", type: "string", description: "node type" },
      { name: "nodeData", type: "NodeSkeleton", description: "node object" },
    ],
    returns: "{Promise<NodeSkeleton>} a promise that resolves to an object containing a node object",
  },
  {
    typeName: "Node",
    methodName: "updateNode",
    signature: "updateNode( nodeId: string, nodeType: string, nodeData: NodeSkeleton ): Promise<NodeSkeleton>",
    description: "Update or create node by uuid and type",
    params: [
      { name: "nodeId", type: "string", description: "node uuid" },
      { name: "nodeType", type: "string", description: "node type" },
      { name: "nodeData", type: "NodeSkeleton", description: "node object" },
    ],
    returns: "{Promise<NodeSkeleton>} a promise that resolves to an object containing a node object",
  },
  {
    typeName: "Node",
    methodName: "deleteNode",
    signature: "deleteNode(nodeId: string, nodeType: string): Promise<NodeSkeleton>",
    description: "Delete node by uuid and type",
    params: [
      { name: "nodeId", type: "string", description: "node uuid" },
      { name: "nodeType", type: "string", description: "node type" },
    ],
    returns: "{Promise<NodeSkeleton>} a promise that resolves to an object containing a node object",
  },
  {
    typeName: "Node",
    methodName: "readCustomNode",
    signature: "readCustomNode( nodeId?: string, nodeName?: string ): Promise<CustomNodeSkeleton>",
    description: "Read custom node. Either ID or name must be provided.",
    params: [
      { name: "nodeId", type: "string", description: "ID or service name of custom node. Takes priority over node display name if both are provided." },
      { name: "nodeName", type: "string", description: "Display name of custom node." },
    ],
    returns: "{Promise<CustomNodeSkeleton>} a promise that resolves to a custom node object",
  },
  {
    typeName: "Node",
    methodName: "readCustomNodes",
    signature: "readCustomNodes(): Promise<CustomNodeSkeleton[]>",
    description: "Read all custom nodes",
    params: [],
    returns: "{Promise<CustomNodeSkeleton[]>} a promise that resolves to an array of custom nodes objects",
  },
  {
    typeName: "Node",
    methodName: "exportCustomNode",
    signature: "exportCustomNode( nodeId?: string, nodeName?: string, options?: CustomNodeExportOptions ): Promise<CustomNodeExportInterface>",
    description: "Export custom node. Either ID or name must be provided.",
    params: [
      { name: "nodeId", type: "string", description: "ID or service name of custom node. Takes priority over node display name if both are provided." },
      { name: "nodeName", type: "string", description: "Display name of custom node." },
      { name: "options", type: "CustomNodeExportOptions", description: "Custom node export options" },
    ],
    returns: "{Promise<CustomNodeExportInterface>} a promise that resolves to a custom node export object",
  },
  {
    typeName: "Node",
    methodName: "exportCustomNodes",
    signature: "exportCustomNodes( options?: CustomNodeExportOptions ): Promise<CustomNodeExportInterface>",
    description: "Export all custom nodes",
    params: [
      { name: "options", type: "CustomNodeExportOptions", description: "Custom node export options" },
    ],
    returns: "{Promise<CustomNodeExportInterface>} a promise that resolves to a custom node export object",
  },
  {
    typeName: "Node",
    methodName: "updateCustomNode",
    signature: "updateCustomNode( nodeId: string, nodeData: CustomNodeSkeleton ): Promise<CustomNodeSkeleton>",
    description: "Update custom node by ID",
    params: [
      { name: "nodeId", type: "string", description: "ID or service name of custom node." },
      { name: "nodeData", type: "CustomNodeSkeleton", description: "node object" },
    ],
    returns: "{Promise<CustomNodeSkeleton>} a promise that resolves to a custom node object",
  },
  {
    typeName: "Node",
    methodName: "importCustomNodes",
    signature: "importCustomNodes( nodeId: string, nodeName: string, importData: CustomNodeExportInterface, options?: CustomNodeImportOptions, resultCallback?: ResultCallback<CustomNodeSkeleton> ): Promise<CustomNodeSkeleton[]>",
    description: "Import custom nodes",
    params: [
      { name: "nodeId", type: "string", description: "ID or service name of custom node. If supplied, only the custom node of that id is imported. Takes priority over node display name if both are provided." },
      { name: "nodeName", type: "string", description: "Display name of custom node. If supplied, only the custom node of that name is imported" },
      { name: "importData", type: "CustomNodeExportInterface", description: "Custom node import data" },
      { name: "options", type: "CustomNodeImportOptions", description: "Custom node import options" },
      { name: "resultCallback", type: "ResultCallback<CustomNodeSkeleton>", description: "Optional callback to process individual results" },
    ],
    returns: "{Promise<CustomNodeSkeleton[]>} the imported custom nodes",
  },
  {
    typeName: "Node",
    methodName: "deleteCustomNode",
    signature: "deleteCustomNode( nodeId?: string, nodeName?: string ): Promise<CustomNodeSkeleton>",
    description: "Delete custom node. Either ID or name must be provided.",
    params: [
      { name: "nodeId", type: "string", description: "ID or service name of custom node. Takes priority over node display name if both are provided." },
      { name: "nodeName", type: "string", description: "Display name of custom node." },
    ],
    returns: "{Promise<CustomNodeSkeleton>} promise that resolves to a custom node object",
  },
  {
    typeName: "Node",
    methodName: "deleteCustomNodes",
    signature: "deleteCustomNodes( resultCallback?: ResultCallback<CustomNodeSkeleton> ): Promise<CustomNodeSkeleton[]>",
    description: "Delete custom nodes",
    params: [
      { name: "resultCallback", type: "ResultCallback", description: "Optional callback to process individual results" },
    ],
    returns: "{Promise<CustomNodeSkeleton[]>} promise that resolves to an array of custom node objects",
  },
  {
    typeName: "Node",
    methodName: "findOrphanedNodes",
    signature: "findOrphanedNodes(): Promise<NodeSkeleton[]>",
    description: "Find all node configuration objects that are no longer referenced by any tree",
    params: [],
    returns: "{Promise<NodeSkeleton[]>} a promise that resolves to an array of orphaned nodes",
  },
  {
    typeName: "Node",
    methodName: "removeOrphanedNodes",
    signature: "removeOrphanedNodes(orphanedNodes: NodeSkeleton[]): Promise<NodeSkeleton[]>",
    description: "Remove orphaned nodes",
    params: [
      { name: "orphanedNodes", type: "NodeSkeleton[]", description: "Pass in an array of orphaned node configuration objects to remove" },
    ],
    returns: "{Promise<NodeSkeleton[]>} a promise that resolves to an array nodes that encountered errors deleting",
  },
  {
    typeName: "Node",
    methodName: "getCustomNodeUsage",
    signature: "getCustomNodeUsage(nodeId: string): Promise<CustomNodeUsage>",
    description: "Get custom node usage by ID",
    params: [
      { name: "nodeId", type: "String", description: "ID or service name of the custom node" },
    ],
    returns: "{Promise<CustomNodeUsage>} a promise that resolves to an object containing a custom node usage object",
  },
  {
    typeName: "Node",
    methodName: "isPremiumNode",
    signature: "isPremiumNode(nodeType: string): boolean",
    description: "Analyze if a node type is premium.",
    params: [
      { name: "nodeType", type: "string", description: "Node type" },
    ],
    returns: "{boolean} True if the node type is premium, false otherwise.",
  },
  {
    typeName: "Node",
    methodName: "isCloudOnlyNode",
    signature: "isCloudOnlyNode(nodeType: string): boolean",
    description: "Analyze if a node type is a cloud-only node.",
    params: [
      { name: "nodeType", type: "string", description: "Node type" },
    ],
    returns: "{boolean} True if the node type is cloud-only, false otherwise.",
  },
  {
    typeName: "Node",
    methodName: "isCloudExcludedNode",
    signature: "isCloudExcludedNode(nodeType: string): boolean",
    description: "Analyze if a node type is a cloud-excluded node. Cloud excluded nodes are OOTB nodes in self-hosted AM deployments but have been excluded in cloud.",
    params: [
      { name: "nodeType", type: "string", description: "node type." },
    ],
    returns: "{boolean} True if node type is cloud-excluded, false otherwise.",
  },
  {
    typeName: "Node",
    methodName: "isDeprecatedNode",
    signature: "isDeprecatedNode(nodeType: string): boolean",
    description: "Analyze if a node type has been deprecated",
    params: [
      { name: "nodeType", type: "string", description: "node type." },
    ],
    returns: "{boolean} True if node type is deprecated, false otherwise.",
  },
  {
    typeName: "Node",
    methodName: "isCustomNode",
    signature: "isCustomNode(nodeType: string): boolean",
    description: "Analyze if a node is custom.",
    params: [
      { name: "nodeType", type: "string", description: "Node type" },
    ],
    returns: "{boolean} True if the node type is custom, false otherwise.",
  },
  {
    typeName: "Node",
    methodName: "getNodeClassification",
    signature: "getNodeClassification(nodeType: string): NodeClassificationType[]",
    description: "Get a node's classifications, which can be one or multiple of: - standard: can run on any instance of a ForgeRock platform - cloud: utilize nodes, which are exclusively available in the ForgeRock Identity Cloud - premium: utilizes nodes, which come at a premium - deprecated: nodes that are no longer supported - custom: nodes that are user-defined - excluded: nodes that are excluded from certain environments",
    params: [
      { name: "nodeType", type: "string", description: "Node type" },
    ],
    returns: "{NodeClassificationType[]} an array of one or multiple classifications",
  },
  {
    typeName: "OAuth2Client",
    methodName: "createOAuth2ClientExportTemplate",
    signature: "createOAuth2ClientExportTemplate(): OAuth2ClientExportInterface",
    description: "Create an empty OAuth2 client export template",
    params: [],
    returns: "{OAuth2ClientExportInterface} an empty OAuth2 client export template",
  },
  {
    typeName: "OAuth2Client",
    methodName: "readOAuth2Clients",
    signature: "readOAuth2Clients(): Promise<OAuth2ClientSkeleton[]>",
    description: "Read all OAuth2 clients",
    params: [],
    returns: "{Promise<OAuth2ClientSkeleton[]>} a promise that resolves to an array of oauth2client objects",
  },
  {
    typeName: "OAuth2Client",
    methodName: "readOAuth2Client",
    signature: "readOAuth2Client(clientId: string): Promise<OAuth2ClientSkeleton>",
    description: "Read OAuth2 client",
    params: [
      { name: "clientId", type: "string", description: "client id" },
    ],
    returns: "{Promise<OAuth2ClientSkeleton>} a promise that resolves to an oauth2client object",
  },
  {
    typeName: "OAuth2Client",
    methodName: "createOAuth2Client",
    signature: "createOAuth2Client( clientId: string, clientData: OAuth2ClientSkeleton ): Promise<OAuth2ClientSkeleton>",
    description: "Create OAuth2 client",
    params: [
      { name: "clientId", type: "string", description: "client id" },
      { name: "clientData", type: "any", description: "oauth2client object" },
    ],
    returns: "{Promise<OAuth2ClientSkeleton>} a promise that resolves to an oauth2client object",
  },
  {
    typeName: "OAuth2Client",
    methodName: "updateOAuth2Client",
    signature: "updateOAuth2Client( clientId: string, clientData: OAuth2ClientSkeleton ): Promise<OAuth2ClientSkeleton>",
    description: "Update or create OAuth2 client",
    params: [
      { name: "clientId", type: "string", description: "client id" },
      { name: "clientData", type: "any", description: "oauth2client object" },
    ],
    returns: "{Promise<any>} a promise that resolves to an oauth2client object",
  },
  {
    typeName: "OAuth2Client",
    methodName: "deleteOAuth2Clients",
    signature: "deleteOAuth2Clients(): Promise<OAuth2ClientSkeleton[]>",
    description: "Delete all OAuth2 clients",
    params: [],
    returns: "{Promise<OAuth2ClientSkeleton[]>} a promise that resolves to an array of oauth2client objects",
  },
  {
    typeName: "OAuth2Client",
    methodName: "deleteOAuth2Client",
    signature: "deleteOAuth2Client(clientId: string): Promise<OAuth2ClientSkeleton>",
    description: "Delete OAuth2 client",
    params: [
      { name: "clientId", type: "string", description: "client id" },
    ],
    returns: "{Promise<OAuth2ClientSkeleton>} a promise that resolves to an oauth2client object",
  },
  {
    typeName: "OAuth2Client",
    methodName: "exportOAuth2Clients",
    signature: "exportOAuth2Clients( options?: OAuth2ClientExportOptions ): Promise<OAuth2ClientExportInterface>",
    description: "Export all OAuth2 clients",
    params: [
      { name: "options", type: "OAuth2ClientExportOptions", description: "export options" },
    ],
    returns: "{OAuth2ClientExportInterface} export data",
  },
  {
    typeName: "OAuth2Client",
    methodName: "exportOAuth2Client",
    signature: "exportOAuth2Client( clientId: string, options?: OAuth2ClientExportOptions ): Promise<OAuth2ClientExportInterface>",
    description: "Export OAuth2 client by ID",
    params: [
      { name: "clientId", type: "string", description: "oauth2 client id" },
      { name: "options", type: "OAuth2ClientExportOptions", description: "export options" },
    ],
    returns: "{OAuth2ClientExportInterface} export data",
  },
  {
    typeName: "OAuth2Client",
    methodName: "importOAuth2Client",
    signature: "importOAuth2Client( clientId: string, importData: OAuth2ClientExportInterface, options?: OAuth2ClientImportOptions ): Promise<OAuth2ClientSkeleton>",
    description: "Import OAuth2 Client by ID",
    params: [
      { name: "clientId", type: "string", description: "client id" },
      { name: "importData", type: "OAuth2ClientExportInterface", description: "import data" },
      { name: "options", type: "OAuth2ClientImportOptions", description: "import options" },
    ],
    returns: "{Promise<OAuth2ClientSkeleton>} a promise resolving to an oauth2 client",
  },
  {
    typeName: "OAuth2Client",
    methodName: "importFirstOAuth2Client",
    signature: "importFirstOAuth2Client( importData: OAuth2ClientExportInterface, options?: OAuth2ClientImportOptions ): Promise<OAuth2ClientSkeleton>",
    description: "Import first OAuth2 Client",
    params: [
      { name: "importData", type: "OAuth2ClientExportInterface", description: "import data" },
      { name: "options", type: "OAuth2ClientImportOptions", description: "import options" },
    ],
    returns: "{Promise<OAuth2ClientSkeleton>} a promise resolving to an oauth2 client",
  },
  {
    typeName: "OAuth2Client",
    methodName: "importOAuth2Clients",
    signature: "importOAuth2Clients( importData: OAuth2ClientExportInterface, options?: OAuth2ClientImportOptions ): Promise<OAuth2ClientSkeleton[]>",
    description: "Import OAuth2 Clients",
    params: [
      { name: "importData", type: "OAuth2ClientExportInterface", description: "import data" },
      { name: "options", type: "OAuth2ClientImportOptions", description: "import options" },
    ],
    returns: "{Promise<OAuth2ClientSkeleton[]>} a promise resolving to an array of oauth2 clients",
  },
  {
    typeName: "OAuth2Oidc",
    methodName: "authorize",
    signature: "authorize( amBaseUrl: string, data: string, config: AxiosRequestConfig ): Promise<AxiosResponse<any, any>>",
    description: "",
    params: [],
    returns: "",
  },
  {
    typeName: "OAuth2Oidc",
    methodName: "accessToken",
    signature: "accessToken( amBaseUrl: string, data: any, config: AxiosRequestConfig ): Promise<AccessTokenMetaType>",
    description: "",
    params: [],
    returns: "",
  },
  {
    typeName: "OAuth2Oidc",
    methodName: "accessTokenRfc7523AuthZGrant",
    signature: "accessTokenRfc7523AuthZGrant( clientId: string, jwt: string, scope: string[], config?: AxiosRequestConfig ): Promise<AccessTokenMetaType>",
    description: "",
    params: [],
    returns: "",
  },
  {
    typeName: "OAuth2Oidc",
    methodName: "getTokenInfo",
    signature: "getTokenInfo( amBaseUrl: string, config: AxiosRequestConfig ): Promise<TokenInfoResponseType>",
    description: "",
    params: [],
    returns: "",
  },
  {
    typeName: "OAuth2Oidc",
    methodName: "clientCredentialsGrant",
    signature: "clientCredentialsGrant( amBaseUrl: string, clientId: string, clientSecret: string, scope: string ): Promise<AccessTokenMetaType>",
    description: "",
    params: [],
    returns: "",
  },
  {
    typeName: "OAuth2Provider",
    methodName: "readOAuth2Provider",
    signature: "readOAuth2Provider(): Promise<OAuth2ProviderSkeleton | null>",
    description: "Read oauth2 provider",
    params: [],
    returns: "{Promise<OAuth2ProviderSkeleton>} a promise resolving to an oauth2 provider object",
  },
  {
    typeName: "OAuth2Provider",
    methodName: "createOAuth2Provider",
    signature: "createOAuth2Provider( providerData?: OAuth2ProviderSkeleton ): Promise<OAuth2ProviderSkeleton>",
    description: "Create oauth2 provider",
    params: [
      { name: "providerData", type: "OAuth2ProviderSkeleton", description: "oauth2 provider data" },
    ],
    returns: "{Promise<OAuth2ProviderSkeleton>} a promise resolving to an oauth2 provider object",
  },
  {
    typeName: "OAuth2Provider",
    methodName: "updateOAuth2Provider",
    signature: "updateOAuth2Provider( providerData: OAuth2ProviderSkeleton ): Promise<OAuth2ProviderSkeleton>",
    description: "Update or create oauth2 provider",
    params: [
      { name: "providerData", type: "OAuth2ProviderSkeleton", description: "oauth2 provider data" },
    ],
    returns: "{Promise<OAuth2ProviderSkeleton>} a promise resolving to an oauth2 provider object",
  },
  {
    typeName: "OAuth2Provider",
    methodName: "deleteOAuth2Provider",
    signature: "deleteOAuth2Provider(): Promise<OAuth2ProviderSkeleton>",
    description: "Delete oauth2 provider",
    params: [],
    returns: "{Promise<OAuth2ProviderSkeleton>} a promise resolving to an oauth2 provider object",
  },
  {
    typeName: "OAuth2TrustedJwtIssuer",
    methodName: "createOAuth2TrustedJwtIssuerExportTemplate",
    signature: "createOAuth2TrustedJwtIssuerExportTemplate(): OAuth2TrustedJwtIssuerExportInterface",
    description: "Create an empty OAuth2 trusted jwt issuer export template",
    params: [],
    returns: "{OAuth2TrustedJwtIssuerExportInterface} an empty OAuth2 trusted jwt issuer export template",
  },
  {
    typeName: "OAuth2TrustedJwtIssuer",
    methodName: "readOAuth2TrustedJwtIssuers",
    signature: "readOAuth2TrustedJwtIssuers(): Promise<OAuth2TrustedJwtIssuerSkeleton[]>",
    description: "Read all OAuth2 trusted jwt issuers",
    params: [],
    returns: "{Promise<OAuth2TrustedJwtIssuerSkeleton[]>} a promise that resolves to an array of trusted jwt issuer objects",
  },
  {
    typeName: "OAuth2TrustedJwtIssuer",
    methodName: "readOAuth2TrustedJwtIssuer",
    signature: "readOAuth2TrustedJwtIssuer( issuerId: string ): Promise<OAuth2TrustedJwtIssuerSkeleton>",
    description: "Read OAuth2 trusted jwt issuer",
    params: [
      { name: "issuerId", type: "string", description: "trusted jwt issuer id" },
    ],
    returns: "{Promise<OAuth2TrustedJwtIssuerSkeleton>} a promise that resolves to an trusted jwt issuer object",
  },
  {
    typeName: "OAuth2TrustedJwtIssuer",
    methodName: "createOAuth2TrustedJwtIssuer",
    signature: "createOAuth2TrustedJwtIssuer( issuerId: string, issuerData: OAuth2TrustedJwtIssuerSkeleton ): Promise<OAuth2TrustedJwtIssuerSkeleton>",
    description: "Create OAuth2 trusted jwt issuer",
    params: [
      { name: "issuerId", type: "string", description: "trusted jwt issuer id" },
      { name: "issuerData", type: "any", description: "trusted jwt issuer object" },
    ],
    returns: "{Promise<OAuth2TrustedJwtIssuerSkeleton>} a promise that resolves to an trusted jwt issuer object",
  },
  {
    typeName: "OAuth2TrustedJwtIssuer",
    methodName: "updateOAuth2TrustedJwtIssuer",
    signature: "updateOAuth2TrustedJwtIssuer( issuerId: string, issuerData: OAuth2TrustedJwtIssuerSkeleton ): Promise<OAuth2TrustedJwtIssuerSkeleton>",
    description: "Update or create OAuth2 trusted jwt issuer",
    params: [
      { name: "issuerId", type: "string", description: "trusted jwt issuer id" },
      { name: "issuerData", type: "any", description: "trusted jwt issuer object" },
    ],
    returns: "{Promise<any>} a promise that resolves to an trusted jwt issuer object",
  },
  {
    typeName: "OAuth2TrustedJwtIssuer",
    methodName: "deleteOAuth2TrustedJwtIssuers",
    signature: "deleteOAuth2TrustedJwtIssuers(): Promise<OAuth2TrustedJwtIssuerSkeleton[]>",
    description: "Delete all OAuth2 trusted jwt issuers",
    params: [],
    returns: "{Promise<OAuth2TrustedJwtIssuerSkeleton[]>} a promise that resolves to an array of trusted jwt issuer objects",
  },
  {
    typeName: "OAuth2TrustedJwtIssuer",
    methodName: "deleteOAuth2TrustedJwtIssuer",
    signature: "deleteOAuth2TrustedJwtIssuer( issuerId: string ): Promise<OAuth2TrustedJwtIssuerSkeleton>",
    description: "Delete OAuth2 trusted jwt issuer",
    params: [
      { name: "issuerId", type: "string", description: "trusted jwt issuer id" },
    ],
    returns: "{Promise<OAuth2TrustedJwtIssuerSkeleton>} a promise that resolves to an trusted jwt issuer object",
  },
  {
    typeName: "OAuth2TrustedJwtIssuer",
    methodName: "exportOAuth2TrustedJwtIssuers",
    signature: "exportOAuth2TrustedJwtIssuers( options?: OAuth2TrustedJwtIssuerExportOptions ): Promise<OAuth2TrustedJwtIssuerExportInterface>",
    description: "Export all OAuth2 trusted jwt issuers",
    params: [
      { name: "options", type: "OAuth2TrustedJwtIssuerExportOptions", description: "export options" },
    ],
    returns: "{OAuth2TrustedJwtIssuerExportInterface} export data",
  },
  {
    typeName: "OAuth2TrustedJwtIssuer",
    methodName: "exportOAuth2TrustedJwtIssuer",
    signature: "exportOAuth2TrustedJwtIssuer( issuerId: string, options?: OAuth2TrustedJwtIssuerExportOptions ): Promise<OAuth2TrustedJwtIssuerExportInterface>",
    description: "Export OAuth2 trusted jwt issuer by ID",
    params: [
      { name: "issuerId", type: "string", description: "oauth2 trusted jwt issuer id" },
      { name: "options", type: "OAuth2TrustedJwtIssuerExportOptions", description: "export options" },
    ],
    returns: "{OAuth2TrustedJwtIssuerExportInterface} export data",
  },
  {
    typeName: "OAuth2TrustedJwtIssuer",
    methodName: "importOAuth2TrustedJwtIssuer",
    signature: "importOAuth2TrustedJwtIssuer( issuerId: string, importData: OAuth2TrustedJwtIssuerExportInterface, options?: OAuth2TrustedJwtIssuerImportOptions ): Promise<OAuth2TrustedJwtIssuerSkeleton>",
    description: "Import OAuth2 Client by ID",
    params: [
      { name: "issuerId", type: "string", description: "trusted jwt issuer id" },
      { name: "importData", type: "OAuth2TrustedJwtIssuerExportInterface", description: "import data" },
      { name: "options", type: "OAuth2TrustedJwtIssuerImportOptions", description: "import options" },
    ],
    returns: "{Promise<OAuth2TrustedJwtIssuerSkeleton>} a promise resolving to an oauth2 trusted jwt issuer",
  },
  {
    typeName: "OAuth2TrustedJwtIssuer",
    methodName: "importFirstOAuth2TrustedJwtIssuer",
    signature: "importFirstOAuth2TrustedJwtIssuer( importData: OAuth2TrustedJwtIssuerExportInterface, options?: OAuth2TrustedJwtIssuerImportOptions ): Promise<OAuth2TrustedJwtIssuerSkeleton>",
    description: "Import first OAuth2 Client",
    params: [
      { name: "importData", type: "OAuth2TrustedJwtIssuerExportInterface", description: "import data" },
      { name: "options", type: "OAuth2TrustedJwtIssuerImportOptions", description: "import options" },
    ],
    returns: "{Promise<OAuth2TrustedJwtIssuerSkeleton>} a promise resolving to an oauth2 trusted jwt issuer",
  },
  {
    typeName: "OAuth2TrustedJwtIssuer",
    methodName: "importOAuth2TrustedJwtIssuers",
    signature: "importOAuth2TrustedJwtIssuers( importData: OAuth2TrustedJwtIssuerExportInterface, options?: OAuth2TrustedJwtIssuerImportOptions ): Promise<OAuth2TrustedJwtIssuerSkeleton[]>",
    description: "Import OAuth2 Clients",
    params: [
      { name: "importData", type: "OAuth2TrustedJwtIssuerExportInterface", description: "import data" },
      { name: "options", type: "OAuth2TrustedJwtIssuerImportOptions", description: "import options" },
    ],
    returns: "{Promise<OAuth2TrustedJwtIssuerSkeleton[]>} a promise resolving to an array of oauth2 trusted jwt issuers",
  },
  {
    typeName: "Organization",
    methodName: "getRealmManagedOrganization",
    signature: "getRealmManagedOrganization(): string",
    description: "Get organization managed object type",
    params: [],
    returns: "{string} organization managed object type in this realm",
  },
  {
    typeName: "Organization",
    methodName: "readOrganizations",
    signature: "readOrganizations(): Promise<IdObjectSkeletonInterface[]>",
    description: "Read all organizations",
    params: [],
    returns: "{Promise<IdObjectSkeletonInterface[]>} promise resolving to an array of organization objects",
  },
  {
    typeName: "Policy",
    methodName: "createPolicyExportTemplate",
    signature: "createPolicyExportTemplate(): PolicyExportInterface",
    description: "Create policy export template",
    params: [],
    returns: "",
  },
  {
    typeName: "Policy",
    methodName: "readPolicies",
    signature: "readPolicies(): Promise<PolicySkeleton[]>",
    description: "Read all policies",
    params: [],
    returns: "{Promise<PolicySkeleton>} a promise that resolves to an array of policy set objects",
  },
  {
    typeName: "Policy",
    methodName: "readPoliciesByPolicySet",
    signature: "readPoliciesByPolicySet(policySetId: string): Promise<PolicySkeleton[]>",
    description: "Get policies by policy set",
    params: [
      { name: "policySetId", type: "string", description: "policy set id/name" },
    ],
    returns: "{Promise<PolicySkeleton[]>} a promise resolving to an array of policy objects",
  },
  {
    typeName: "Policy",
    methodName: "readPolicy",
    signature: "readPolicy(policyId: string): Promise<PolicySkeleton>",
    description: "Get policy",
    params: [
      { name: "policyId", type: "string", description: "policy id/name" },
    ],
    returns: "{Promise<PolicySkeleton>} promise resolving to a policy object",
  },
  {
    typeName: "Policy",
    methodName: "createPolicy",
    signature: "createPolicy( policyId: string, policyData: PolicySkeleton ): Promise<PolicySkeleton>",
    description: "Update or create policy",
    params: [
      { name: "policyId", type: "string", description: "policy id/name" },
      { name: "policyData", type: "PolicySkeleton", description: "policy object" },
    ],
    returns: "{Promise<PolicySkeleton>} promise resolving to a policy object",
  },
  {
    typeName: "Policy",
    methodName: "updatePolicy",
    signature: "updatePolicy( policyId: string, policyData: PolicySkeleton ): Promise<PolicySkeleton>",
    description: "Update or create policy",
    params: [
      { name: "policyId", type: "string", description: "policy id/name" },
      { name: "policyData", type: "PolicySkeleton", description: "policy object" },
    ],
    returns: "{Promise<PolicySkeleton>} promise resolving to a policy object",
  },
  {
    typeName: "Policy",
    methodName: "deletePolicy",
    signature: "deletePolicy(policyId: string): Promise<any>",
    description: "Delete policy",
    params: [
      { name: "policyId", type: "string", description: "policy id/name" },
    ],
    returns: "{Promise<PolicySkeleton>} promise resolving to a policy object",
  },
  {
    typeName: "Policy",
    methodName: "exportPolicy",
    signature: "exportPolicy( policyId: string, options?: PolicyExportOptions ): Promise<PolicyExportInterface>",
    description: "Export policy",
    params: [
      { name: "policyId", type: "string", description: "policy id/name" },
    ],
    returns: "{Promise<PolicyExportInterface>} a promise that resolves to a PolicyExportInterface object",
  },
  {
    typeName: "Policy",
    methodName: "exportPolicies",
    signature: "exportPolicies(options?: PolicyExportOptions): Promise<PolicyExportInterface>",
    description: "Export policies",
    params: [
      { name: "options", type: "PolicyExportOptions", description: "export options" },
    ],
    returns: "{Promise<PolicyExportInterface>} a promise that resolves to an PolicyExportInterface object",
  },
  {
    typeName: "Policy",
    methodName: "exportPoliciesByPolicySet",
    signature: "exportPoliciesByPolicySet( policySetName: string, options?: PolicyExportOptions ): Promise<PolicyExportInterface>",
    description: "Export policies by policy set",
    params: [
      { name: "policySetName", type: "string", description: "policy set id/name" },
      { name: "options", type: "PolicyExportOptions", description: "export options" },
    ],
    returns: "{Promise<PolicyExportInterface>} a promise that resolves to an PolicyExportInterface object",
  },
  {
    typeName: "Policy",
    methodName: "importPolicy",
    signature: "importPolicy( policyId: string, importData: PolicyExportInterface, options?: PolicyImportOptions ): Promise<PolicySkeleton>",
    description: "Import policy by id",
    params: [
      { name: "policyId", type: "string", description: "policy id" },
      { name: "importData", type: "PolicyExportInterface", description: "import data" },
      { name: "options", type: "PolicyImportOptions", description: "import options" },
    ],
    returns: "{Promise<PolicySkeleton>} imported policy object",
  },
  {
    typeName: "Policy",
    methodName: "importFirstPolicy",
    signature: "importFirstPolicy( importData: PolicyExportInterface, options?: PolicyImportOptions ): Promise<PolicySkeleton>",
    description: "Import first policy",
    params: [
      { name: "importData", type: "PolicyExportInterface", description: "import data" },
      { name: "options", type: "PolicyImportOptions", description: "import options" },
    ],
    returns: "{Promise<PolicySkeleton>} imported policy object",
  },
  {
    typeName: "Policy",
    methodName: "importPolicies",
    signature: "importPolicies( importData: PolicyExportInterface, options?: PolicyImportOptions ): Promise<PolicySkeleton[]>",
    description: "Import policies",
    params: [
      { name: "importData", type: "PolicyExportInterface", description: "import data" },
      { name: "options", type: "PolicyImportOptions", description: "import options" },
    ],
    returns: "{Promise<PolicySkeleton[]>} array of imported policy objects",
  },
  {
    typeName: "PolicySet",
    methodName: "createPolicySetExportTemplate",
    signature: "createPolicySetExportTemplate(): PolicySetExportInterface",
    description: "Create policy export template",
    params: [],
    returns: "{PolicySetExportInterface} policy export interface",
  },
  {
    typeName: "PolicySet",
    methodName: "readPolicySets",
    signature: "readPolicySets(): Promise<PolicySetSkeleton[]>",
    description: "Read all policy sets",
    params: [],
    returns: "{Promise<PolicySetSkeleton[]>} a promise that resolves to an array of policy set objects",
  },
  {
    typeName: "PolicySet",
    methodName: "readPolicySet",
    signature: "readPolicySet(policySetName: string): Promise<PolicySetSkeleton>",
    description: "Read policy set",
    params: [
      { name: "policySetName", type: "string", description: "policy set name" },
    ],
    returns: "{Promise<PolicySetSkeleton>} a promise that resolves to a policy set object",
  },
  {
    typeName: "PolicySet",
    methodName: "createPolicySet",
    signature: "createPolicySet( policySetData: PolicySetSkeleton, policySetName?: string ): Promise<PolicySetSkeleton>",
    description: "",
    params: [],
    returns: "",
  },
  {
    typeName: "PolicySet",
    methodName: "updatePolicySet",
    signature: "updatePolicySet( policySetData: PolicySetSkeleton, policySetName?: string ): Promise<PolicySetSkeleton>",
    description: "",
    params: [],
    returns: "",
  },
  {
    typeName: "PolicySet",
    methodName: "deletePolicySet",
    signature: "deletePolicySet(policySetName: string): Promise<PolicySetSkeleton>",
    description: "",
    params: [],
    returns: "",
  },
  {
    typeName: "PolicySet",
    methodName: "exportPolicySet",
    signature: "exportPolicySet( policySetName: string, options?: PolicySetExportOptions ): Promise<PolicySetExportInterface>",
    description: "Export policy set",
    params: [
      { name: "policySetName", type: "string", description: "policy set name" },
      { name: "options", type: "PolicySetExportOptions", description: "export options" },
    ],
    returns: "{Promise<PolicySetExportInterface>} a promise that resolves to an PolicySetExportInterface object",
  },
  {
    typeName: "PolicySet",
    methodName: "exportPolicySets",
    signature: "exportPolicySets( options?: PolicySetExportOptions ): Promise<PolicySetExportInterface>",
    description: "Export policy sets",
    params: [
      { name: "options", type: "PolicySetExportOptions", description: "export options" },
    ],
    returns: "{Promise<PolicySetExportInterface>} a promise that resolves to an PolicySetExportInterface object",
  },
  {
    typeName: "PolicySet",
    methodName: "importPolicySet",
    signature: "importPolicySet( policySetName: string, importData: PolicySetExportInterface, options?: PolicySetImportOptions ): Promise<any>",
    description: "Import policy set",
    params: [
      { name: "policySetName", type: "string", description: "policy set name" },
      { name: "importData", type: "PolicySetExportInterface", description: "import data" },
      { name: "options", type: "PolicySetImportOptions", description: "import options" },
    ],
    returns: "",
  },
  {
    typeName: "PolicySet",
    methodName: "importFirstPolicySet",
    signature: "importFirstPolicySet( importData: PolicySetExportInterface, options?: PolicySetImportOptions ): Promise<any>",
    description: "Import first policy set",
    params: [
      { name: "importData", type: "PolicySetExportInterface", description: "import data" },
      { name: "options", type: "PolicySetImportOptions", description: "import options" },
    ],
    returns: "",
  },
  {
    typeName: "PolicySet",
    methodName: "importPolicySets",
    signature: "importPolicySets( importData: PolicySetExportInterface, options?: PolicySetImportOptions ): Promise<any[]>",
    description: "Import policy sets",
    params: [
      { name: "importData", type: "PolicySetExportInterface", description: "import data" },
      { name: "options", type: "PolicySetImportOptions", description: "import options" },
    ],
    returns: "{any[]} The imported policy sets",
  },
  {
    typeName: "RawConfig",
    methodName: "exportRawConfig",
    signature: "exportRawConfig( options: RawExportOptions ): Promise<IdObjectSkeletonInterface>",
    description: "Exports raw configuration",
    params: [
      { name: "options", type: "RawExportOptions", description: "The export options, including the path to the resource" },
    ],
    returns: "{Promise<IdObjectSkeletonInterface>} The raw configuration JSON object at the specified path",
  },
  {
    typeName: "RawConfig",
    methodName: "importRawConfig",
    signature: "importRawConfig( options: RawImportOptions, data: IdObjectSkeletonInterface ): Promise<IdObjectSkeletonInterface>",
    description: "Imports raw configuration",
    params: [
      { name: "options", type: "RawImportOptions", description: "The import options, including the path to the resource" },
      { name: "data", type: "IdObjectSkeletonInterface", description: "the import data that will be pushed" },
    ],
    returns: "{Promise<IdObjectSkeletonInterface>} The raw configuration JSON object at the specified path",
  },
  {
    typeName: "Realm",
    methodName: "readRealms",
    signature: "readRealms(): Promise<RealmSkeleton[]>",
    description: "Read all realms",
    params: [],
    returns: "{Promise<RealmSkeleton[]>} a promise resolving to an array of realm objects",
  },
  {
    typeName: "Realm",
    methodName: "readRealm",
    signature: "readRealm(realmId: string): Promise<RealmSkeleton>",
    description: "Read realm",
    params: [
      { name: "realmId", type: "string", description: "realm id" },
    ],
    returns: "{Promise<RealmSkeleton>} a promise resolving to a realm object",
  },
  {
    typeName: "Realm",
    methodName: "readRealmByName",
    signature: "readRealmByName(realmName: string): Promise<RealmSkeleton>",
    description: "Read realm by name",
    params: [
      { name: "realmName", type: "string", description: "realm name" },
    ],
    returns: "{Promise<RealmSkeleton>} a promise resolving to a realm object",
  },
  {
    typeName: "Realm",
    methodName: "exportRealms",
    signature: "exportRealms(): Promise<RealmExportInterface>",
    description: "Export all realms. The response can be saved to file as is.",
    params: [],
    returns: "{Promise<RealmExportInterface>} Promise resolving to a RealmExportInterface object.",
  },
  {
    typeName: "Realm",
    methodName: "createRealm",
    signature: "createRealm( realmName: string, realmData?: RealmSkeleton ): Promise<RealmSkeleton>",
    description: "Create realm",
    params: [
      { name: "realmName", type: "string", description: "realm name" },
      { name: "realmData", type: "RealmSkeleton", description: "realm data" },
    ],
    returns: "{Promise<RealmSkeleton>} a promise resolving to a realm object",
  },
  {
    typeName: "Realm",
    methodName: "updateRealm",
    signature: "updateRealm( realmId: string, realmData: RealmSkeleton ): Promise<RealmSkeleton>",
    description: "Update realm",
    params: [
      { name: "realmId", type: "string", description: "realm id" },
      { name: "realmData", type: "RealmSkeleton", description: "realm data" },
    ],
    returns: "{Promise<RealmSkeleton>} a promise resolving to a realm object",
  },
  {
    typeName: "Realm",
    methodName: "importRealms",
    signature: "importRealms( importData: RealmExportInterface, realmId?: string, realmName?: string ): Promise<RealmSkeleton[]>",
    description: "Import realms",
    params: [
      { name: "importData", type: "RealmExportInterface", description: "realm import data" },
      { name: "realmId", type: "string", description: "Optional realm id. If supplied, only the realm of that id is imported. Takes priority over realmName if both are provided." },
      { name: "realmName", type: "string", description: "Optional realm name. If supplied, only the realm of that name is imported." },
    ],
    returns: "{Promise<RealmSkeleton[]>} the imported realms",
  },
  {
    typeName: "Realm",
    methodName: "deleteRealm",
    signature: "deleteRealm(realmId: string): Promise<RealmSkeleton>",
    description: "Delete realm",
    params: [
      { name: "realmId", type: "string", description: "realm id" },
    ],
    returns: "{Promise<RealmSkeleton>} a promise resolving to a realm object",
  },
  {
    typeName: "Realm",
    methodName: "deleteRealmByName",
    signature: "deleteRealmByName(realmName: string): Promise<RealmSkeleton>",
    description: "Delete realm by name",
    params: [
      { name: "realmName", type: "string", description: "realm name" },
    ],
    returns: "{Promise<RealmSkeleton>} a promise resolving to a realm object",
  },
  {
    typeName: "Realm",
    methodName: "addCustomDomain",
    signature: "addCustomDomain(realmName: string, domain: string): Promise<RealmSkeleton>",
    description: "Add custom DNS domain name (realm DNS alias)",
    params: [
      { name: "realmName", type: "string", description: "realm name" },
      { name: "domain", type: "string", description: "domain name" },
    ],
    returns: "{Promise<RealmSkeleton>} a promise resolving to a realm object",
  },
  {
    typeName: "Realm",
    methodName: "removeCustomDomain",
    signature: "removeCustomDomain(realmName: string, domain: string): Promise<RealmSkeleton>",
    description: "Remove custom DNS domain name (realm DNS alias)",
    params: [
      { name: "realmName", type: "string", description: "realm name" },
      { name: "domain", type: "string", description: "domain name" },
    ],
    returns: "{Promise<RealmSkeleton>} a promise resolving to a realm object",
  },
  {
    typeName: "Recon",
    methodName: "readRecons",
    signature: "readRecons(): Promise<ReconType[]>",
    description: "Read all reconciliation runs",
    params: [],
    returns: "{Promise<ReconType[]>} a promise resolving to an array of recon objects",
  },
  {
    typeName: "Recon",
    methodName: "readRecon",
    signature: "readRecon(reconId: string): Promise<ReconType>",
    description: "Read recon",
    params: [
      { name: "reconId", type: "string", description: "id of the recon" },
    ],
    returns: "{Promise<ReconType>} a promise resolving to a recon object",
  },
  {
    typeName: "Recon",
    methodName: "startRecon",
    signature: "startRecon(mappingName: string): Promise<ReconStatusType>",
    description: "Start a reconciliation",
    params: [
      { name: "mappingName", type: "string", description: "mapping to reconcile" },
    ],
    returns: "{Promise<ReconStatusType>} a promise resolving to a recon status object",
  },
  {
    typeName: "Recon",
    methodName: "startReconById",
    signature: "startReconById( mappingName: string, objectId: string ): Promise<ReconStatusType>",
    description: "Start a reconciliation by Id",
    params: [
      { name: "mappingName", type: "string", description: "mapping to reconcile" },
      { name: "objectId", type: "string", description: "id of object to reconcile" },
    ],
    returns: "{Promise<ReconStatusType>} a promise resolving to a recon status object",
  },
  {
    typeName: "Recon",
    methodName: "cancelRecon",
    signature: "cancelRecon(reconId: string): Promise<ReconStatusType>",
    description: "Cancel a reconciliation",
    params: [
      { name: "reconId", type: "string", description: "id of the recon to cancel" },
    ],
    returns: "{Promise<ReconStatusType>} a promise resolving to a recon status object",
  },
  {
    typeName: "ResourceType",
    methodName: "readResourceType",
    signature: "readResourceType(resourceTypeUuid: string): Promise<ResourceTypeSkeleton>",
    description: "Read resource type",
    params: [
      { name: "resourceTypeUuid", type: "", description: "resource type uuid" },
    ],
    returns: "{Promise<ResourceTypeSkeleton>} a promise that resolves to a resource type object",
  },
  {
    typeName: "ResourceType",
    methodName: "readResourceTypes",
    signature: "readResourceTypes(): Promise<ResourceTypeSkeleton[]>",
    description: "Read all resource types",
    params: [],
    returns: "{Promise<ResourceTypeSkeleton[]>} a promise that resolves to an array of resource type objects",
  },
  {
    typeName: "ResourceType",
    methodName: "readResourceTypeByName",
    signature: "readResourceTypeByName( resourceTypeName: string ): Promise<ResourceTypeSkeleton>",
    description: "Read resource type by name",
    params: [
      { name: "resourceTypeName", type: "string", description: "resource type name" },
    ],
    returns: "{Promise<ResourceTypeSkeleton>} a promise that resolves to a resource type object",
  },
  {
    typeName: "ResourceType",
    methodName: "createResourceType",
    signature: "createResourceType( resourceTypeData: ResourceTypeSkeleton, resourceTypeUuid?: string ): Promise<ResourceTypeSkeleton>",
    description: "Create resource type",
    params: [
      { name: "resourceTypeData", type: "", description: "resource type data" },
      { name: "resourceTypeUuid", type: "", description: "resource type uuid" },
    ],
    returns: "{Promise<ResourceTypeSkeleton>} a promise that resolves to a resource type object",
  },
  {
    typeName: "ResourceType",
    methodName: "updateResourceType",
    signature: "updateResourceType( resourceTypeUuid: string, resourceTypeData: ResourceTypeSkeleton ): Promise<ResourceTypeSkeleton>",
    description: "Update resource type",
    params: [
      { name: "resourceTypeData", type: "string", description: "resource type data" },
    ],
    returns: "{Promise<ResourceTypeSkeleton>} a promise that resolves to a resource type object",
  },
  {
    typeName: "ResourceType",
    methodName: "deleteResourceType",
    signature: "deleteResourceType(resourceTypeUuid: string): Promise<ResourceTypeSkeleton>",
    description: "Delete resource type",
    params: [
      { name: "resourceTypeUuid", type: "string", description: "resource type uuid" },
    ],
    returns: "{Promise<ResourceTypeSkeleton>} Promise resolvig to a resource type object",
  },
  {
    typeName: "ResourceType",
    methodName: "deleteResourceTypeByName",
    signature: "deleteResourceTypeByName( resourceTypeName: string ): Promise<ResourceTypeSkeleton>",
    description: "Delete resource type by name",
    params: [
      { name: "resourceTypeName", type: "string", description: "resource type name" },
    ],
    returns: "{Promise<ResourceTypeSkeleton>} Promise resolvig to a resource type object",
  },
  {
    typeName: "ResourceType",
    methodName: "exportResourceType",
    signature: "exportResourceType( resourceTypeUuid: string ): Promise<ResourceTypeExportInterface>",
    description: "Export resource type",
    params: [
      { name: "resourceTypeUuid", type: "string", description: "resource type uuid" },
    ],
    returns: "{Promise<ResourceTypeExportInterface>} a promise that resolves to an ResourceTypeExportInterface object",
  },
  {
    typeName: "ResourceType",
    methodName: "exportResourceTypeByName",
    signature: "exportResourceTypeByName( resourceTypeName: string ): Promise<ResourceTypeExportInterface>",
    description: "Export resource type by name",
    params: [
      { name: "resourceTypeName", type: "string", description: "resource type name" },
    ],
    returns: "{Promise<ResourceTypeExportInterface>} a promise that resolves to an ResourceTypeExportInterface object",
  },
  {
    typeName: "ResourceType",
    methodName: "exportResourceTypes",
    signature: "exportResourceTypes(): Promise<ResourceTypeExportInterface>",
    description: "Export resource types",
    params: [],
    returns: "{Promise<ResourceTypeExportInterface>} a promise that resolves to an ResourceTypeExportInterface object",
  },
  {
    typeName: "ResourceType",
    methodName: "importResourceType",
    signature: "importResourceType( resourceTypeUuid: string, importData: ResourceTypeExportInterface ): Promise<any>",
    description: "Import resource type by uuid",
    params: [
      { name: "resourceTypeUuid", type: "string", description: "client uuid" },
      { name: "importData", type: "ResourceTypeExportInterface", description: "import data" },
    ],
    returns: "",
  },
  {
    typeName: "ResourceType",
    methodName: "importResourceTypeByName",
    signature: "importResourceTypeByName( resourceTypeName: string, importData: ResourceTypeExportInterface ): Promise<any>",
    description: "Import resource type by name",
    params: [
      { name: "resourceTypeName", type: "string", description: "client id" },
      { name: "importData", type: "ResourceTypeExportInterface", description: "import data" },
    ],
    returns: "",
  },
  {
    typeName: "ResourceType",
    methodName: "importFirstResourceType",
    signature: "importFirstResourceType( importData: ResourceTypeExportInterface ): Promise<any>",
    description: "Import first resource type",
    params: [
      { name: "importData", type: "ResourceTypeExportInterface", description: "import data" },
    ],
    returns: "",
  },
  {
    typeName: "ResourceType",
    methodName: "importResourceTypes",
    signature: "importResourceTypes(importData: ResourceTypeExportInterface): Promise<any[]>",
    description: "Import resource types",
    params: [
      { name: "importData", type: "ResourceTypeExportInterface", description: "import data" },
    ],
    returns: "",
  },
  {
    typeName: "Saml2",
    methodName: "readSaml2ProviderStubs",
    signature: "readSaml2ProviderStubs(): Promise<Saml2ProviderStub[]>",
    description: "Read all SAML2 entity provider stubs",
    params: [],
    returns: "{Promise<Saml2ProviderStub[]>} a promise that resolves to an array of saml2 entity stubs",
  },
  {
    typeName: "Saml2",
    methodName: "readSaml2ProviderStub",
    signature: "readSaml2ProviderStub(entityId: string): Promise<Saml2ProviderStub>",
    description: "",
    params: [
      { name: "entityId", type: "string", description: "Provider entity id" },
    ],
    returns: "{Promise<Saml2ProviderStub>} Promise resolving to a Saml2ExportInterface object.",
  },
  {
    typeName: "Saml2",
    methodName: "readSaml2Provider",
    signature: "readSaml2Provider(entityId: string): Promise<Saml2ProviderSkeleton>",
    description: "Export a single entity provider. The response can be saved to file as is.",
    params: [
      { name: "entityId", type: "string", description: "Provider entity id" },
    ],
    returns: "{Promise<Saml2ProviderSkeleton>} Promise resolving to a Saml2ExportInterface object.",
  },
  {
    typeName: "Saml2",
    methodName: "createSaml2Provider",
    signature: "createSaml2Provider( location: Saml2ProiderLocation, providerData: Saml2ProviderSkeleton, metaData: string ): Promise<Saml2ProviderSkeleton>",
    description: "Create a SAML2 entity provider",
    params: [
      { name: "location", type: "Saml2ProiderLocation", description: "'hosted' or 'remote'" },
      { name: "providerData", type: "Saml2ProviderSkeleton", description: "Object representing a SAML entity provider" },
      { name: "metaData", type: "string", description: "Base64-encoded metadata XML. Only required for remote providers" },
    ],
    returns: "{Promise<Saml2ProviderSkeleton>} a promise that resolves to a saml2 entity provider object",
  },
  {
    typeName: "Saml2",
    methodName: "updateSaml2Provider",
    signature: "updateSaml2Provider( location: Saml2ProiderLocation, providerData: Saml2ProviderSkeleton, entityId?: string ): Promise<Saml2ProviderSkeleton>",
    description: "Update SAML2 entity provider",
    params: [
      { name: "location", type: "Saml2ProiderLocation", description: "Entity provider location (hosted or remote)" },
      { name: "entityId", type: "string", description: "SAML2 entity id" },
      { name: "providerData", type: "Saml2ProviderSkeleton", description: "Object representing a SAML entity provider" },
    ],
    returns: "{Promise<Saml2ProviderSkeleton>} a promise that resolves to a saml2 entity provider object",
  },
  {
    typeName: "Saml2",
    methodName: "deleteSaml2Provider",
    signature: "deleteSaml2Provider(entityId: string): Promise<Saml2ProviderSkeleton>",
    description: "Delete an entity provider. The response can be saved to file as is.",
    params: [
      { name: "entityId", type: "string", description: "Provider entity id" },
    ],
    returns: "{Promise<Saml2ProviderSkeleton>} Promise resolving to a Saml2ExportInterface object.",
  },
  {
    typeName: "Saml2",
    methodName: "deleteSaml2Providers",
    signature: "deleteSaml2Providers(): Promise<Saml2ProviderSkeleton[]>",
    description: "Delete all entity providers.",
    params: [],
    returns: "{Promise<Saml2ProviderSkeleton[]>} Promise resolving to an array of Saml2ProviderSkeleton objects.",
  },
  {
    typeName: "Saml2",
    methodName: "getSaml2ProviderMetadataUrl",
    signature: "getSaml2ProviderMetadataUrl(entityId: string): string",
    description: "Get a SAML2 entity provider's metadata URL by entity id",
    params: [
      { name: "entityId", type: "string", description: "SAML2 entity id" },
    ],
    returns: "{string} the URL to get the metadata from",
  },
  {
    typeName: "Saml2",
    methodName: "getSaml2ProviderMetadata",
    signature: "getSaml2ProviderMetadata(entityId: string): Promise<any>",
    description: "Get a SAML2 entity provider's metadata by entity id",
    params: [
      { name: "entityId", type: "string", description: "SAML2 entity id" },
    ],
    returns: "{Promise<object>} a promise that resolves to an object containing a SAML2 metadata",
  },
  {
    typeName: "Saml2",
    methodName: "exportSaml2Provider",
    signature: "exportSaml2Provider( entityId: string, options?: Saml2EntitiesExportOptions ): Promise<Saml2ExportInterface>",
    description: "Export a single entity provider. The response can be saved to file as is.",
    params: [
      { name: "entityId", type: "string", description: "Provider entity id" },
      { name: "options", type: "Saml2EntitiesExportOptions", description: "export options" },
    ],
    returns: "{Promise<Saml2ExportInterface>} Promise resolving to a Saml2ExportInterface object.",
  },
  {
    typeName: "Saml2",
    methodName: "exportSaml2Providers",
    signature: "exportSaml2Providers( options?: Saml2EntitiesExportOptions ): Promise<Saml2ExportInterface>",
    description: "Export all entity providers. The response can be saved to file as is.",
    params: [
      { name: "options", type: "Saml2EntitiesExportOptions", description: "export options" },
    ],
    returns: "{Promise<Saml2ExportInterface>} Promise resolving to a Saml2ExportInterface object.",
  },
  {
    typeName: "Saml2",
    methodName: "importSaml2Provider",
    signature: "importSaml2Provider( entityId: string, importData: Saml2ExportInterface, options?: Saml2EntitiesImportOptions ): Promise<Saml2ProviderSkeleton>",
    description: "Import a SAML entity provider",
    params: [
      { name: "entityId", type: "string", description: "Provider entity id" },
      { name: "importData", type: "Saml2ExportInterface", description: "Import data" },
      { name: "options", type: "Saml2EntitiesImportOptions", description: "import options" },
    ],
    returns: "{Promise<Saml2ProviderSkeleton>} a promise resolving to a provider object",
  },
  {
    typeName: "Saml2",
    methodName: "importSaml2Providers",
    signature: "importSaml2Providers( importData: Saml2ExportInterface, options?: Saml2EntitiesImportOptions ): Promise<Saml2ProviderSkeleton[]>",
    description: "Import SAML entity providers",
    params: [
      { name: "importData", type: "Saml2ExportInterface", description: "Import data" },
      { name: "options", type: "Saml2EntitiesImportOptions", description: "import options" },
    ],
    returns: "{Promise<Saml2ProviderSkeleton[]>} a promise resolving to an array of provider objects",
  },
  {
    typeName: "Script",
    methodName: "createScriptExportTemplate",
    signature: "createScriptExportTemplate(): ScriptExportInterface",
    description: "Create an empty script export template",
    params: [],
    returns: "{ScriptExportInterface} an empty script export template",
  },
  {
    typeName: "Script",
    methodName: "readScripts",
    signature: "readScripts(): Promise<ScriptSkeleton[]>",
    description: "Read all scripts",
    params: [],
    returns: "{Promise<ScriptSkeleton[]>} a promise that resolves to an array of script objects",
  },
  {
    typeName: "Script",
    methodName: "getLibraryScriptNames",
    signature: "getLibraryScriptNames(scriptObj: ScriptSkeleton): string[]",
    description: "Get the names of library scripts required by the input script object",
    params: [
      { name: "scriptObj", type: "ScriptSkeleton", description: "the script object" },
    ],
    returns: "an array of required library script names",
  },
  {
    typeName: "Script",
    methodName: "readScript",
    signature: "readScript(scriptId: string): Promise<ScriptSkeleton>",
    description: "Read script",
    params: [
      { name: "scriptId", type: "string", description: "script id" },
    ],
    returns: "{Promise<ScriptSkeleton>} promise that resolves to a script object",
  },
  {
    typeName: "Script",
    methodName: "readScriptByName",
    signature: "readScriptByName(scriptName: string): Promise<ScriptSkeleton>",
    description: "Read script by name",
    params: [
      { name: "scriptName", type: "string", description: "name of the script" },
    ],
    returns: "{Promise<ScriptSkeleton>} promise that resolves to a script object",
  },
  {
    typeName: "Script",
    methodName: "createScript",
    signature: "createScript( scriptId: string, scriptName: string, scriptData: ScriptSkeleton ): Promise<ScriptSkeleton>",
    description: "Create script",
    params: [
      { name: "scriptId", type: "string", description: "script id" },
      { name: "scriptName", type: "string", description: "name of the script" },
      { name: "scriptData", type: "ScriptSkeleton", description: "script object" },
    ],
    returns: "{Promise<ScriptSkeleton>} a status object",
  },
  {
    typeName: "Script",
    methodName: "updateScript",
    signature: "updateScript( scriptId: string, scriptData: ScriptSkeleton ): Promise<ScriptSkeleton>",
    description: "Create or update script",
    params: [
      { name: "scriptId", type: "string", description: "script id" },
      { name: "scriptData", type: "ScriptSkeleton", description: "script object" },
    ],
    returns: "{Promise<ScriptSkeleton>} a status object",
  },
  {
    typeName: "Script",
    methodName: "deleteScript",
    signature: "deleteScript(scriptId: string): Promise<ScriptSkeleton>",
    description: "Delete script",
    params: [
      { name: "scriptId", type: "string", description: "script id" },
    ],
    returns: "{Promise<ScriptSkeleton>} promise that resolves to a script object",
  },
  {
    typeName: "Script",
    methodName: "deleteScriptByName",
    signature: "deleteScriptByName(scriptName: string): Promise<ScriptSkeleton>",
    description: "Delete script by name",
    params: [
      { name: "scriptName", type: "String", description: "script name" },
    ],
    returns: "{Promise<ScriptSkeleton>} a promise that resolves to a script object",
  },
  {
    typeName: "Script",
    methodName: "deleteScripts",
    signature: "deleteScripts( resultCallback?: ResultCallback<ScriptSkeleton> ): Promise<ScriptSkeleton[]>",
    description: "Delete all non-default scripts",
    params: [
      { name: "resultCallback", type: "ResultCallback", description: "Optional callback to process individual results" },
    ],
    returns: "{Promise<ScriptSkeleton[]>} a promise that resolves to an array of script objects",
  },
  {
    typeName: "Script",
    methodName: "exportScripts",
    signature: "exportScripts( options?: ScriptExportOptions, resultCallback?: ResultCallback<ScriptSkeleton> ): Promise<ScriptExportInterface>",
    description: "Export all scripts",
    params: [
      { name: "options", type: "ScriptExportOptions", description: "script export options" },
      { name: "resultCallback", type: "ResultCallback", description: "Optional callback to process individual results" },
    ],
    returns: "{Promise<ScriptExportInterface>} a promise that resolved to a ScriptExportInterface object",
  },
  {
    typeName: "Script",
    methodName: "exportScript",
    signature: "exportScript( scriptId: string, options?: ScriptExportOptions ): Promise<ScriptExportInterface>",
    description: "Export script by id",
    params: [
      { name: "scriptId", type: "string", description: "script uuid" },
      { name: "options", type: "ScriptExportOptions", description: "script export options" },
      { name: "resultCallback", type: "ResultCallback", description: "Optional callback to process individual results" },
    ],
    returns: "{Promise<ScriptExportInterface>} a promise that resolved to a ScriptExportInterface object",
  },
  {
    typeName: "Script",
    methodName: "exportScriptByName",
    signature: "exportScriptByName( scriptName: string, options?: ScriptExportOptions ): Promise<ScriptExportInterface>",
    description: "Export script by name",
    params: [
      { name: "scriptName", type: "string", description: "script name" },
      { name: "options", type: "ScriptExportOptions", description: "script export options" },
    ],
    returns: "{Promise<ScriptExportInterface>} a promise that resolved to a ScriptExportInterface object",
  },
  {
    typeName: "Script",
    methodName: "importScripts",
    signature: "importScripts( scriptId: string, scriptName: string, importData: ScriptExportInterface, options?: ScriptImportOptions, validate?: boolean, resultCallback?: ResultCallback<ScriptSkeleton> ): Promise<ScriptSkeleton[]>",
    description: "Import scripts",
    params: [
      { name: "scriptId", type: "string", description: "Optional id of script. If supplied, only the script of that id is imported. Takes priority over scriptName if both are provided." },
      { name: "scriptName", type: "string", description: "Optional name of script. If supplied, only the script of that name is imported" },
      { name: "importData", type: "ScriptExportInterface", description: "Script import data" },
      { name: "options", type: "ScriptImportOptions", description: "Script import options" },
      { name: "validate", type: "boolean", description: "If true, validates Javascript scripts to ensure no errors exist in them. Default: false" },
      { name: "resultCallback", type: "ResultCallback", description: "Optional callback to process individual results" },
    ],
    returns: "{Promise<ScriptSkeleton[]>} the imported scripts",
  },
  {
    typeName: "ScriptType",
    methodName: "createScriptTypeExportTemplate",
    signature: "createScriptTypeExportTemplate(): ScriptTypeExportInterface",
    description: "Create an empty scriptType export template",
    params: [],
    returns: "{ScriptTypeExportInterface} an empty scriptType export template",
  },
  {
    typeName: "ScriptType",
    methodName: "readScriptType",
    signature: "readScriptType(scriptTypeId: string): Promise<ScriptTypeSkeleton>",
    description: "Read scriptType by id",
    params: [
      { name: "scriptTypeId", type: "string", description: "ScriptType id" },
    ],
    returns: "{Promise<ScriptTypeSkeleton>} a promise that resolves to a scriptType object",
  },
  {
    typeName: "ScriptType",
    methodName: "readScriptTypes",
    signature: "readScriptTypes(): Promise<ScriptTypeSkeleton[]>",
    description: "Read all scriptTypes.",
    params: [],
    returns: "{Promise<ScriptTypeSkeleton[]>} a promise that resolves to an array of scriptType objects",
  },
  {
    typeName: "ScriptType",
    methodName: "exportScriptTypes",
    signature: "exportScriptTypes(): Promise<ScriptTypeExportInterface>",
    description: "Export all scriptTypes. The response can be saved to file as is.",
    params: [],
    returns: "{Promise<ScriptTypeExportInterface>} Promise resolving to a ScriptTypeExportInterface object.",
  },
  {
    typeName: "ScriptType",
    methodName: "updateScriptType",
    signature: "updateScriptType( scriptTypeId: string, scriptTypeData: ScriptTypeSkeleton ): Promise<ScriptTypeSkeleton>",
    description: "Update script type",
    params: [
      { name: "scriptTypeId", type: "string", description: "script type id" },
      { name: "scriptTypeData", type: "ScriptTypeSkeleton", description: "script type data" },
    ],
    returns: "{Promise<ScriptTypeSkeleton>} a promise resolving to a script type object",
  },
  {
    typeName: "ScriptType",
    methodName: "importScriptTypes",
    signature: "importScriptTypes( importData: ScriptTypeExportInterface, scriptTypeId?: string ): Promise<ScriptTypeSkeleton[]>",
    description: "Import script types",
    params: [
      { name: "importData", type: "ScriptTypeExportInterface", description: "script type import data" },
      { name: "scriptTypeId", type: "string", description: "Optional script type id. If supplied, only the script type of that id is imported. Takes priority over scriptTypeUrl if both are provided." },
    ],
    returns: "{Promise<ScriptTypeSkeleton[]>} the imported script types",
  },
  {
    typeName: "SecretStore",
    methodName: "createSecretStoreExportTemplate",
    signature: "createSecretStoreExportTemplate(): SecretStoreExportInterface",
    description: "Create an empty secret store export template",
    params: [],
    returns: "{SecretStoreExportInterface} an empty secret store export template",
  },
  {
    typeName: "SecretStore",
    methodName: "createSecretStoreMapping",
    signature: "createSecretStoreMapping( secretStoreId: string, secretStoreTypeId: string | undefined, secretStoreMappingData: SecretStoreMappingSkeleton, globalConfig: boolean ): Promise<SecretStoreMappingSkeleton>",
    description: "Create secret store mapping. Will throw if type is not defined and multiple secret stores with the same id are found.",
    params: [
      { name: "secretStoreId", type: "string", description: "Secret store id" },
      { name: "secretStoreTypeId", type: "string | undefined", description: "Secret store type id (optional)" },
      { name: "secretStoreMappingData", type: "SecretStoreMappingSkeleton", description: "The secret store mapping data," },
      { name: "globalConfig", type: "boolean", description: "true if the secret store is global, false otherwise. Default: false." },
    ],
    returns: "{Promise<SecretStoreMappingSkeleton>} a promise that resolves to a secret store mapping object of the mapping created",
  },
  {
    typeName: "SecretStore",
    methodName: "readSecretStore",
    signature: "readSecretStore( secretStoreId: string, secretStoreTypeId: string | undefined, globalConfig: boolean ): Promise<SecretStoreSkeleton>",
    description: "Read secret store by id. Will throw if type is not defined and multiple secret stores with the same id are found.",
    params: [
      { name: "secretStoreId", type: "string", description: "Secret store id" },
      { name: "secretStoreTypeId", type: "string | undefined", description: "Secret store type id (optional)" },
      { name: "globalConfig", type: "boolean", description: "true if global secret store is the target of the operation, false otherwise. Default: false." },
    ],
    returns: "{Promise<SecretStoreSkeleton>} a promise that resolves to a secret store object",
  },
  {
    typeName: "SecretStore",
    methodName: "readSecretStoreSchema",
    signature: "readSecretStoreSchema( secretStoreTypeId: string, globalConfig: boolean ): Promise<SecretStoreSchemaSkeleton>",
    description: "Read secret store schema",
    params: [
      { name: "secretStoreTypeId", type: "string", description: "Secret store type id" },
      { name: "globalConfig", type: "boolean", description: "true if the secret store is global, false otherwise. Default: false." },
    ],
    returns: "{Promise<SecretStoreSchemaSkeleton>} a promise that resolves to a secret store schema object",
  },
  {
    typeName: "SecretStore",
    methodName: "readSecretStores",
    signature: "readSecretStores(globalConfig: boolean): Promise<SecretStoreSkeleton[]>",
    description: "Read all secret stores.",
    params: [
      { name: "globalConfig", type: "boolean", description: "true if global secret stores are the target of the operation, false otherwise. Default: false." },
    ],
    returns: "{Promise<SecretStoreSkeleton[]>} a promise that resolves to an array of secret store objects",
  },
  {
    typeName: "SecretStore",
    methodName: "readSecretStoreMapping",
    signature: "readSecretStoreMapping( secretStoreId: string, secretStoreTypeId: string | undefined, secretId: string, globalConfig: boolean ): Promise<SecretStoreMappingSkeleton>",
    description: "Read secret store mapping. Will throw if type is not defined and multiple secret stores with the same id are found.",
    params: [
      { name: "secretStoreId", type: "string", description: "Secret store id" },
      { name: "secretStoreTypeId", type: "string | undefined", description: "Secret store type id (optional)" },
      { name: "secretId", type: "string", description: "Secret store mapping label" },
      { name: "globalConfig", type: "boolean", description: "true if the secret store is global, false otherwise. Default: false." },
    ],
    returns: "{Promise<SecretStoreMappingSkeleton>} a promise that resolves to an array of secret store mapping objects",
  },
  {
    typeName: "SecretStore",
    methodName: "readSecretStoreMappings",
    signature: "readSecretStoreMappings( secretStoreId: string, secretStoreTypeId: string | undefined, globalConfig: boolean ): Promise<SecretStoreMappingSkeleton[]>",
    description: "Read secret store mappings. Will throw if type is not defined and multiple secret stores with the same id are found.",
    params: [
      { name: "secretStoreId", type: "string", description: "Secret store id" },
      { name: "secretStoreTypeId", type: "string | undefined", description: "Secret store type id (optional)" },
      { name: "globalConfig", type: "boolean", description: "true if the secret store is global, false otherwise. Default: false." },
    ],
    returns: "{Promise<SecretStoreMappingSkeleton[]>} a promise that resolves to an array of secret store mapping objects",
  },
  {
    typeName: "SecretStore",
    methodName: "exportSecretStore",
    signature: "exportSecretStore( secretStoreId: string, secretStoreTypeId: string | undefined, globalConfig: boolean ): Promise<SecretStoreExportInterface>",
    description: "Export a single secret store by id. The response can be saved to file as is. Will throw if type is not defined and multiple secret stores with the same id are found.",
    params: [
      { name: "secretStoreId", type: "string", description: "Secret store id" },
      { name: "secretStoreTypeId", type: "string | undefined", description: "Secret store type id (optional)" },
      { name: "globalConfig", type: "boolean", description: "true if global secret store is the target of the operation, false otherwise. Default: false." },
    ],
    returns: "{Promise<SecretStoreExportInterface>} Promise resolving to a SecretStoreExportInterface object.",
  },
  {
    typeName: "SecretStore",
    methodName: "exportSecretStores",
    signature: "exportSecretStores( globalConfig: boolean, resultCallback?: ResultCallback<SecretStoreSkeleton> ): Promise<SecretStoreExportInterface>",
    description: "Export all secret stores. The response can be saved to file as is.",
    params: [
      { name: "globalConfig", type: "boolean", description: "true if global secret stores are the target of the operation, false otherwise. Default: false." },
      { name: "resultCallback", type: "ResultCallback", description: "Optional callback to process individual results" },
    ],
    returns: "{Promise<SecretStoreExportInterface>} Promise resolving to a SecretStoreExportInterface object.",
  },
  {
    typeName: "SecretStore",
    methodName: "updateSecretStore",
    signature: "updateSecretStore( secretStoreData: SecretStoreSkeleton, globalConfig: boolean ): Promise<SecretStoreSkeleton>",
    description: "Update secret store",
    params: [
      { name: "secretStoreData", type: "SecretStoreSkeleton", description: "secret store to import" },
      { name: "globalConfig", type: "boolean", description: "true if the secret store is global, false otherwise. Default: false." },
    ],
    returns: "{Promise<SecretStoreSkeleton>} a promise that resolves to a secret store object",
  },
  {
    typeName: "SecretStore",
    methodName: "updateSecretStoreMapping",
    signature: "updateSecretStoreMapping( secretStoreId: string, secretStoreTypeId: string | undefined, secretStoreMappingData: SecretStoreMappingSkeleton, globalConfig: boolean ): Promise<SecretStoreMappingSkeleton>",
    description: "Update secret store mapping. Will throw if type is not defined and multiple secret stores with the same id are found.",
    params: [
      { name: "secretStoreId", type: "string", description: "Secret store id" },
      { name: "secretStoreTypeId", type: "string | undefined", description: "Secret store type id (optional)" },
      { name: "secretStoreMappingData", type: "SecretStoreMappingSkeleton", description: "secret store mapping to import" },
      { name: "globalConfig", type: "boolean", description: "true if the secret store mapping is global, false otherwise. Default: false." },
    ],
    returns: "{Promise<SecretStoreMappingSkeleton>} a promise that resolves to a secret store mapping object",
  },
  {
    typeName: "SecretStore",
    methodName: "importSecretStores",
    signature: "importSecretStores( importData: SecretStoreExportInterface, globalConfig: boolean, secretStoreId?: string, secretStoreTypeId?: string, resultCallback?: ResultCallback<SecretStoreSkeleton> ): Promise<SecretStoreExportSkeleton[]>",
    description: "Import secret stores and mappings",
    params: [
      { name: "importData", type: "SecretStoreExportInterface", description: "secret store import data" },
      { name: "globalConfig", type: "boolean", description: "true if the secret store mapping is global, false otherwise. Default: false." },
      { name: "secretStoreId", type: "string", description: "optional secret store id. If supplied, only the secret store of that id is imported." },
      { name: "secretStoreTypeId", type: "string", description: "optional secret store type id" },
      { name: "resultCallback", type: "ResultCallback", description: "Optional callback to process individual results" },
    ],
    returns: "{Promise<SecretStoreExportSkeleton[]>} the imported secret stores and mappings",
  },
  {
    typeName: "SecretStore",
    methodName: "deleteSecretStore",
    signature: "deleteSecretStore( secretStoreId: string, secretStoreTypeId: string | undefined, globalConfig: boolean ): Promise<SecretStoreSkeleton>",
    description: "Delete secret store by id",
    params: [
      { name: "secretStoreId", type: "string", description: "Secret store id" },
      { name: "secretStoreTypeId", type: "string | undefined", description: "Secret store type id (optional)" },
      { name: "globalConfig", type: "boolean", description: "true if the secret store mapping is global, false otherwise. Default: false." },
    ],
    returns: "{Promise<SecretStoreSkeleton>} a promise that resolves to a secret store object",
  },
  {
    typeName: "SecretStore",
    methodName: "deleteSecretStores",
    signature: "deleteSecretStores( globalConfig: boolean, resultCallback?: ResultCallback<SecretStoreSkeleton> ): Promise<SecretStoreSkeleton[]>",
    description: "Delete all secret stores",
    params: [
      { name: "globalConfig", type: "boolean", description: "true if the secret store mappings are global, false otherwise. Default: false." },
      { name: "resultCallback", type: "ResultCallback", description: "Optional callback to process individual results" },
    ],
    returns: "{Promise<SecretStoreSkeleton[]>} a promise that resolves to an array of secret store objects",
  },
  {
    typeName: "SecretStore",
    methodName: "deleteSecretStoreMapping",
    signature: "deleteSecretStoreMapping( secretStoreId: string, secretStoreTypeId: string | undefined, secretId: string, globalConfig: boolean ): Promise<SecretStoreMappingSkeleton>",
    description: "Delete secret store mapping",
    params: [
      { name: "secretStoreId", type: "string", description: "Secret store id" },
      { name: "secretStoreTypeId", type: "string | undefined", description: "Secret store type id (optional)" },
      { name: "secretId", type: "string", description: "Secret store mapping label" },
      { name: "globalConfig", type: "boolean", description: "true if the secret store mapping is global, false otherwise. Default: false." },
    ],
    returns: "{Promise<SecretStoreMappingSkeleton>} a promise that resolves to a secret store mapping object",
  },
  {
    typeName: "SecretStore",
    methodName: "deleteSecretStoreMappings",
    signature: "deleteSecretStoreMappings( secretStoreId: string, secretStoreTypeId: string | undefined, globalConfig: boolean, resultCallback?: ResultCallback<SecretStoreMappingSkeleton> ): Promise<SecretStoreMappingSkeleton[]>",
    description: "Delete secret store mappings",
    params: [
      { name: "secretStoreId", type: "string", description: "Secret store id" },
      { name: "secretStoreTypeId", type: "string | undefined", description: "Secret store type id (optional)" },
      { name: "globalConfig", type: "boolean", description: "true if the secret store mapping is global, false otherwise. Default: false." },
      { name: "resultCallback", type: "ResultCallback", description: "Optional callback to process individual results" },
    ],
    returns: "{Promise<SecretStoreMappingSkeleton[]>} a promise that resolves to a secret store mapping object",
  },
  {
    typeName: "SecretStore",
    methodName: "canSecretStoreHaveMappings",
    signature: "canSecretStoreHaveMappings(secretStoreTypeId: string): boolean",
    description: "Function that returns true if the given secret store type can have mappings, false otherwise",
    params: [
      { name: "secretStoreTypeId", type: "", description: "The secret store type" },
    ],
    returns: "true if the given secret store type can have mappings, false otherwise",
  },
  {
    typeName: "Service",
    methodName: "createServiceExportTemplate",
    signature: "createServiceExportTemplate(): ServiceExportInterface",
    description: "",
    params: [],
    returns: "",
  },
  {
    typeName: "Service",
    methodName: "getListOfServices",
    signature: "getListOfServices( globalConfig?: boolean ): Promise<import('../api/ServiceApi').AmServiceSkeleton[]>",
    description: "Get list of services",
    params: [
      { name: "globalConfig", type: "boolean", description: "true if the list of global services is requested, false otherwise. Default: false." },
    ],
    returns: "",
  },
  {
    typeName: "Service",
    methodName: "getFullServices",
    signature: "getFullServices(globalConfig?: boolean): Promise<FullService[]>",
    description: "Get all services including their descendents.",
    params: [
      { name: "globalConfig", type: "boolean", description: "true if the global service is the target of the operation, false otherwise. Default: false." },
    ],
    returns: "Promise resolving to an array of services with their descendants",
  },
  {
    typeName: "Service",
    methodName: "deleteFullService",
    signature: "deleteFullService( serviceId: string, globalConfig?: boolean ): Promise<AmServiceSkeleton>",
    description: "Deletes the specified service",
    params: [
      { name: "serviceId", type: "string", description: "The service to delete" },
      { name: "globalConfig", type: "boolean", description: "true if the global service is the target of the operation, false otherwise. Default: false." },
    ],
    returns: "",
  },
  {
    typeName: "Service",
    methodName: "deleteFullServices",
    signature: "deleteFullServices(globalConfig?: boolean): Promise<AmServiceSkeleton[]>",
    description: "Deletes all services",
    params: [
      { name: "globalConfig", type: "boolean", description: "true if the global service is the target of the operation, false otherwise. Default: false." },
    ],
    returns: "",
  },
  {
    typeName: "Service",
    methodName: "exportService",
    signature: "exportService( serviceId: string, globalConfig?: boolean ): Promise<ServiceExportInterface>",
    description: "Export service. The response can be saved to file as is.",
    params: [
      { name: "serviceId", type: "", description: "service id/name" },
      { name: "globalConfig", type: "boolean", description: "true if the global service is the target of the operation, false otherwise. Default: false." },
    ],
    returns: "{Promise<ServiceExportInterface>} Promise resolving to a ServiceExportInterface object.",
  },
  {
    typeName: "Service",
    methodName: "exportServices",
    signature: "exportServices(globalConfig?: boolean): Promise<ServiceExportInterface>",
    description: "Export all services",
    params: [
      { name: "globalConfig", type: "boolean", description: "true if the global service is the target of the operation, false otherwise. Default: false." },
    ],
    returns: "",
  },
  {
    typeName: "Service",
    methodName: "importService",
    signature: "importService( serviceId: string, importData: ServiceExportInterface, options: ServiceImportOptions ): Promise<AmServiceSkeleton>",
    description: "Imports a single service using a reference to the service and a file to read the data from. Optionally clean (remove) an existing service first",
    params: [
      { name: "serviceId", type: "string", description: "The service id/name to add" },
      { name: "importData", type: "ServiceExportInterface", description: "The service configuration export data to import" },
      { name: "options", type: "ServiceImportOptions", description: "Import options" },
    ],
    returns: "{Promise<AmServiceSkeleton>} A promise resolving to a service object",
  },
  {
    typeName: "Service",
    methodName: "importServices",
    signature: "importServices( importData: ServiceExportInterface, options: ServiceImportOptions ): Promise<AmServiceSkeleton[]>",
    description: "Imports multiple services from the same file. Optionally clean (remove) existing services first",
    params: [
      { name: "importData", type: "ServiceExportInterface", description: "The service configuration export data to import" },
      { name: "options", type: "ServiceImportOptions", description: "Import options" },
    ],
    returns: "{Promise<AmServiceSkeleton[]>} A promise resolving to an array of service objects",
  },
  {
    typeName: "Session",
    methodName: "getSessionInfo",
    signature: "getSessionInfo(tokenId: string): Promise<SessionInfoType>",
    description: "Get session info",
    params: [
      { name: "tokenId", type: "string", description: "session token" },
    ],
    returns: "{Promise<SessionInfoType>} a promise resolving to a session info object",
  },
  {
    typeName: "Theme",
    methodName: "createThemeExportTemplate",
    signature: "createThemeExportTemplate(): ThemeExportInterface",
    description: "Create an empty theme export template",
    params: [],
    returns: "{ThemeExportInterface} an empty theme export template",
  },
  {
    typeName: "Theme",
    methodName: "readThemes",
    signature: "readThemes(): Promise<ThemeSkeleton[]>",
    description: "Read all themes",
    params: [
      { name: "realm", type: "string", description: "realm name" },
    ],
    returns: "{Promise<ThemeSkeleton[]>} a promise that resolves to an array of themes",
  },
  {
    typeName: "Theme",
    methodName: "readTheme",
    signature: "readTheme(themeId: string, realm?: string): Promise<ThemeSkeleton>",
    description: "Read theme by id",
    params: [
      { name: "themeId", type: "string", description: "theme id" },
      { name: "realm", type: "string", description: "realm name" },
    ],
    returns: "{Promise<ThemeSkeleton>} a promise that resolves to a theme object",
  },
  {
    typeName: "Theme",
    methodName: "readThemeByName",
    signature: "readThemeByName(themeName: string, realm?: string): Promise<ThemeSkeleton>",
    description: "Read theme by name",
    params: [
      { name: "themeName", type: "string", description: "theme name" },
      { name: "realm", type: "string", description: "realm name" },
    ],
    returns: "{Promise<ThemeSkeleton>} a promise that resolves to a theme object",
  },
  {
    typeName: "Theme",
    methodName: "exportThemes",
    signature: "exportThemes(): Promise<ThemeExportInterface>",
    description: "Export all themes. The response can be saved to file as is.",
    params: [],
    returns: "{Promise<ThemeExportInterface>} Promise resolving to a ThemeExportInterface object.",
  },
  {
    typeName: "Theme",
    methodName: "createTheme",
    signature: "createTheme( themeData: ThemeSkeleton, themeId?: string, realm?: string ): Promise<ThemeSkeleton>",
    description: "Update theme",
    params: [
      { name: "themeData", type: "ThemeSkeleton", description: "theme object" },
      { name: "themeId", type: "string", description: "theme id" },
      { name: "realm", type: "string", description: "realm name" },
    ],
    returns: "{Promise<ThemeSkeleton>} a promise that resolves to a theme object",
  },
  {
    typeName: "Theme",
    methodName: "updateTheme",
    signature: "updateTheme( themeId: string, themeData: ThemeSkeleton, realm?: string ): Promise<ThemeSkeleton>",
    description: "Update theme",
    params: [
      { name: "themeId", type: "string", description: "theme id" },
      { name: "themeData", type: "ThemeSkeleton", description: "theme object" },
      { name: "realm", type: "string", description: "realm name" },
    ],
    returns: "{Promise<ThemeSkeleton>} a promise that resolves to a theme object",
  },
  {
    typeName: "Theme",
    methodName: "updateThemeByName",
    signature: "updateThemeByName( themeName: string, themeData: ThemeSkeleton, realm?: string ): Promise<ThemeSkeleton>",
    description: "Update theme by name",
    params: [
      { name: "themeName", type: "String", description: "theme name" },
      { name: "themeData", type: "ThemeSkeleton", description: "theme object" },
      { name: "realm", type: "string", description: "realm name" },
    ],
    returns: "{Promise<ThemeSkeleton>} a promise that resolves to a theme object",
  },
  {
    typeName: "Theme",
    methodName: "updateThemes",
    signature: "updateThemes( themeMap: Record<string, ThemeSkeleton> ): Promise<Record<string, ThemeSkeleton>>",
    description: "Update all themes",
    params: [
      { name: "allThemesData", type: "Map<string, ThemeSkeleton>", description: "themes object containing all themes for all realms" },
      { name: "realm", type: "string", description: "realm name" },
    ],
    returns: "{Promise<Map<string, ThemeSkeleton>>} a promise that resolves to a themes object",
  },
  {
    typeName: "Theme",
    methodName: "importThemes",
    signature: "importThemes(importData: ThemeExportInterface): Promise<ThemeSkeleton[]>",
    description: "Import themes",
    params: [
      { name: "importData", type: "ThemeExportInterface", description: "import data" },
    ],
    returns: "{Promise<ThemeSkeleton[]>} a promise resolving to an array of theme objects",
  },
  {
    typeName: "Theme",
    methodName: "deleteTheme",
    signature: "deleteTheme(themeId: string, realm?: string): Promise<ThemeSkeleton>",
    description: "Delete theme by id",
    params: [
      { name: "themeId", type: "string", description: "theme id" },
      { name: "realm", type: "string", description: "realm name" },
    ],
    returns: "{Promise<ThemeSkeleton>} a promise that resolves to a themes object",
  },
  {
    typeName: "Theme",
    methodName: "deleteThemeByName",
    signature: "deleteThemeByName(themeName: string, realm?: string): Promise<ThemeSkeleton>",
    description: "Delete theme by name",
    params: [
      { name: "themeName", type: "string", description: "theme name" },
      { name: "realm", type: "string", description: "realm name" },
    ],
    returns: "{Promise<ThemeSkeleton>} a promise that resolves to a themes object",
  },
  {
    typeName: "Theme",
    methodName: "deleteThemes",
    signature: "deleteThemes(realm?: string): Promise<ThemeSkeleton[]>",
    description: "Delete all themes",
    params: [
      { name: "realm", type: "string", description: "realm name" },
    ],
    returns: "{Promise<ThemeSkeleton[]>} a promise that resolves to an array of themes",
  },
  {
    typeName: "TokenCache",
    methodName: "getTokenCachePath",
    signature: "getTokenCachePath(): string",
    description: "Get connection profiles file name",
    params: [],
    returns: "{string} connection profiles file name",
  },
  {
    typeName: "TokenCache",
    methodName: "initTokenCache",
    signature: "initTokenCache(): void",
    description: "Initialize token cache This method is called from app.ts and runs before any of the message handlers are registered. Therefore none of the Console message functions will produce any output.",
    params: [],
    returns: "",
  },
  {
    typeName: "TokenCache",
    methodName: "hasToken",
    signature: "hasToken(tokenType: tokenType): Promise<boolean>",
    description: "Check if there are suitable tokens in the cache",
    params: [
      { name: "tokenType", type: "tokenType", description: "type of token" },
    ],
    returns: "{Promise<boolean>} true if tokens found in cache, false otherwise",
  },
  {
    typeName: "TokenCache",
    methodName: "hasUserSessionToken",
    signature: "hasUserSessionToken(): Promise<boolean>",
    description: "Check if there are suitable user session tokens in the cache",
    params: [],
    returns: "{Promise<boolean>} true if tokens found in cache, false otherwise",
  },
  {
    typeName: "TokenCache",
    methodName: "hasUserBearerToken",
    signature: "hasUserBearerToken(): Promise<boolean>",
    description: "Check if there are suitable user bearer tokens in the cache",
    params: [],
    returns: "{Promise<boolean>} true if tokens found in cache, false otherwise",
  },
  {
    typeName: "TokenCache",
    methodName: "hasSaBearerToken",
    signature: "hasSaBearerToken(): Promise<boolean>",
    description: "Check if there are suitable service account bearer tokens in the cache",
    params: [],
    returns: "{Promise<boolean>} true if tokens found in cache, false otherwise",
  },
  {
    typeName: "TokenCache",
    methodName: "readToken",
    signature: "readToken( tokenType: tokenType ): Promise<AccessTokenMetaType | UserSessionMetaType>",
    description: "Read token",
    params: [
      { name: "tokenType", type: "tokenType", description: "type of token" },
    ],
    returns: "{Promise<string>} token or null",
  },
  {
    typeName: "TokenCache",
    methodName: "readUserSessionToken",
    signature: "readUserSessionToken(): Promise<UserSessionMetaType>",
    description: "Read user session token",
    params: [],
    returns: "{Promise<string>} token or null",
  },
  {
    typeName: "TokenCache",
    methodName: "readUserBearerToken",
    signature: "readUserBearerToken(): Promise<AccessTokenMetaType>",
    description: "Read user bearer token",
    params: [],
    returns: "{Promise<string>} token or null",
  },
  {
    typeName: "TokenCache",
    methodName: "readSaBearerToken",
    signature: "readSaBearerToken(): Promise<AccessTokenMetaType>",
    description: "Read service account bearer token",
    params: [],
    returns: "{Promise<string>} token or null",
  },
  {
    typeName: "TokenCache",
    methodName: "saveUserSessionToken",
    signature: "saveUserSessionToken(token: UserSessionMetaType): Promise<boolean>",
    description: "Save user session token for current connection",
    params: [],
    returns: "{Promise<boolean>} true if the operation succeeded, false otherwise",
  },
  {
    typeName: "TokenCache",
    methodName: "saveUserBearerToken",
    signature: "saveUserBearerToken(token: AccessTokenMetaType): Promise<boolean>",
    description: "Save user bearer token for current connection",
    params: [],
    returns: "{Promise<boolean>} true if the operation succeeded, false otherwise",
  },
  {
    typeName: "TokenCache",
    methodName: "saveSaBearerToken",
    signature: "saveSaBearerToken(token: AccessTokenMetaType): Promise<boolean>",
    description: "Save service account bearer token for current connection",
    params: [],
    returns: "{Promise<boolean>} true if the operation succeeded, false otherwise",
  },
  {
    typeName: "TokenCache",
    methodName: "saveToken",
    signature: "saveToken( tokenType: tokenType, token: UserSessionMetaType | AccessTokenMetaType ): Promise<boolean>",
    description: "Save token of any type for current connection",
    params: [
      { name: "tokenType", type: "tokenType", description: "type of token" },
      { name: "token", type: "UserSessionMetaType | AccessTokenMetaType", description: "token object" },
    ],
    returns: "{Promise<boolean>} true if the operation succeeded, false otherwise",
  },
  {
    typeName: "TokenCache",
    methodName: "purge",
    signature: "purge(): TokenCacheInterface",
    description: "Purge all expired tokens from cache",
    params: [],
    returns: "{TokenCacheInterface} purged cache",
  },
  {
    typeName: "TokenCache",
    methodName: "flush",
    signature: "flush(): boolean",
    description: "Flush cache",
    params: [],
    returns: "{boolean} true if the operation succeeded, false otherwise",
  },
  {
    typeName: "User",
    methodName: "createUserExportTemplate",
    signature: "createUserExportTemplate(): UserExportInterface",
    description: "Create an empty user export template",
    params: [],
    returns: "{UserExportInterface} an empty user export template",
  },
  {
    typeName: "User",
    methodName: "readUser",
    signature: "readUser(userId: string): Promise<UserSkeleton>",
    description: "Read user by id",
    params: [
      { name: "userId", type: "string", description: "User id" },
    ],
    returns: "{Promise<UserSkeleton>} a promise that resolves to a user object",
  },
  {
    typeName: "User",
    methodName: "readUsers",
    signature: "readUsers(): Promise<UserSkeleton[]>",
    description: "Read all users.",
    params: [],
    returns: "{Promise<UserSkeleton[]>} a promise that resolves to an array of user objects",
  },
  {
    typeName: "User",
    methodName: "countUsers",
    signature: "countUsers(): Promise<number>",
    description: "Count all users in the active realm.",
    params: [],
    returns: "{Promise<number>} exact count when supported by the backing API",
  },
  {
    typeName: "User",
    methodName: "exportUser",
    signature: "exportUser(userId: string): Promise<UserExportInterface>",
    description: "Export a single user by id. The response can be saved to file as is.",
    params: [
      { name: "userId", type: "string", description: "User id" },
    ],
    returns: "{Promise<UserExportInterface>} Promise resolving to a UserExportInterface object.",
  },
  {
    typeName: "User",
    methodName: "exportUsers",
    signature: "exportUsers(): Promise<UserExportInterface>",
    description: "Export all users. The response can be saved to file as is.",
    params: [],
    returns: "{Promise<UserExportInterface>} Promise resolving to a UserExportInterface object.",
  },
  {
    typeName: "User",
    methodName: "createUserGroupExportTemplate",
    signature: "createUserGroupExportTemplate(): UserGroupExportInterface",
    description: "Create an empty user group export template",
    params: [],
    returns: "{UserGroupExportInterface} an empty user group export template",
  },
  {
    typeName: "User",
    methodName: "readUserGroup",
    signature: "readUserGroup(groupId: string): Promise<UserGroupSkeleton>",
    description: "Read user group by id",
    params: [
      { name: "groupId", type: "string", description: "Group id" },
    ],
    returns: "{Promise<UserGroupSkeleton>} a promise that resolves to a user group object",
  },
  {
    typeName: "User",
    methodName: "readUserGroups",
    signature: "readUserGroups(): Promise<UserGroupSkeleton[]>",
    description: "Read all user groups.",
    params: [],
    returns: "{Promise<UserGroupSkeleton[]>} a promise that resolves to an array of user group objects",
  },
  {
    typeName: "User",
    methodName: "exportUserGroup",
    signature: "exportUserGroup(groupId: string): Promise<UserGroupExportInterface>",
    description: "Export a single user group by id. The response can be saved to file as is.",
    params: [
      { name: "groupId", type: "string", description: "Group id" },
    ],
    returns: "{Promise<UserGroupExportInterface>} Promise resolving to a UserGroupExportInterface object.",
  },
  {
    typeName: "User",
    methodName: "exportUserGroups",
    signature: "exportUserGroups(): Promise<UserGroupExportInterface>",
    description: "Export all user groups. The response can be saved to file as is.",
    params: [],
    returns: "{Promise<UserGroupExportInterface>} Promise resolving to a UserGroupExportInterface object.",
  },
  {
    typeName: "User",
    methodName: "importUsers",
    signature: "importUsers( importData: UserExportInterface, userId?: string ): Promise<UserExportSkeleton[]>",
    description: "Import users and their config",
    params: [
      { name: "importData", type: "UserExportInterface", description: "user import data" },
      { name: "userId", type: "string", description: "Optional user id. If supplied, only the user of that id is imported." },
    ],
    returns: "{Promise<UserExportSkeleton[]>} the imported users",
  },
  {
    typeName: "User",
    methodName: "importUserGroups",
    signature: "importUserGroups( importData: UserGroupExportInterface, groupId?: string ): Promise<UserGroupSkeleton[]>",
    description: "Import user groups",
    params: [
      { name: "importData", type: "UserGroupExportInterface", description: "user group import data" },
      { name: "groupId", type: "string", description: "Optional user group id. If supplied, only the group of that id is imported." },
    ],
    returns: "{Promise<UserGroupSkeleton[]>} the imported user groups",
  },
  {
    typeName: "Version",
    methodName: "getVersion",
    signature: "getVersion(): string",
    description: "",
    params: [],
    returns: "",
  },
  {
    typeName: "Version",
    methodName: "getAllVersions",
    signature: "getAllVersions( endpoints: { base: string",
    description: "",
    params: [],
    returns: "",
  },
  {
    typeName: "Server",
    methodName: "createServerExportTemplate",
    signature: "createServerExportTemplate(): ServerExportInterface",
    description: "Create an empty server export template",
    params: [],
    returns: "{ServerExportInterface} an empty server export template",
  },
  {
    typeName: "Server",
    methodName: "readServer",
    signature: "readServer(serverId: string): Promise<ServerSkeleton>",
    description: "Read server by id",
    params: [
      { name: "serverId", type: "string", description: "Server id" },
    ],
    returns: "{Promise<ServerSkeleton>} a promise that resolves to a server object",
  },
  {
    typeName: "Server",
    methodName: "readServerByUrl",
    signature: "readServerByUrl(serverUrl: string): Promise<ServerSkeleton>",
    description: "Read server by url",
    params: [
      { name: "serverUrl", type: "string", description: "Server url" },
    ],
    returns: "{Promise<ServerSkeleton>} a promise that resolves to a server object",
  },
  {
    typeName: "Server",
    methodName: "readServers",
    signature: "readServers(): Promise<ServerSkeleton[]>",
    description: "Read all servers.",
    params: [],
    returns: "{Promise<ServerSkeleton[]>} a promise that resolves to an array of server objects",
  },
  {
    typeName: "Server",
    methodName: "exportServer",
    signature: "exportServer( serverId: string, options: ServerExportOptions ): Promise<ServerExportInterface>",
    description: "Export a single server by id. The response can be saved to file as is.",
    params: [
      { name: "serverId", type: "string", description: "Server id" },
      { name: "options", type: "ServerExportOptions", description: "Server export options" },
    ],
    returns: "{Promise<ServerExportInterface>} Promise resolving to a ServerExportInterface object.",
  },
  {
    typeName: "Server",
    methodName: "exportServerByUrl",
    signature: "exportServerByUrl( serverUrl: string, options: ServerExportOptions ): Promise<ServerExportInterface>",
    description: "Export a single server by url. The response can be saved to file as is.",
    params: [
      { name: "serverUrl", type: "string", description: "Server url" },
      { name: "options", type: "ServerExportOptions", description: "Server export options" },
    ],
    returns: "{Promise<ServerExportInterface>} Promise resolving to a ServerExportInterface object.",
  },
  {
    typeName: "Server",
    methodName: "exportServers",
    signature: "exportServers(options: ServerExportOptions): Promise<ServerExportInterface>",
    description: "Export all servers. The response can be saved to file as is.",
    params: [
      { name: "options", type: "ServerExportOptions", description: "Server export options" },
    ],
    returns: "{Promise<ServerExportInterface>} Promise resolving to a ServerExportInterface object.",
  },
  {
    typeName: "Server",
    methodName: "createServer",
    signature: "createServer(serverData: ServerSkeleton): Promise<ServerSkeleton>",
    description: "Creates a server",
    params: [
      { name: "serverData", type: "ServerSkeleton", description: "server object" },
    ],
    returns: "{Promise<ServerSkeleton>} a promise that resolves to a server object",
  },
  {
    typeName: "Server",
    methodName: "importFirstServer",
    signature: "importFirstServer( importData: ServerExportInterface, options: ServerImportOptions ): Promise<ServerExportInterface>",
    description: "Imports the first server from the importData",
    params: [
      { name: "importData", type: "", description: "server import data" },
      { name: "options", type: "", description: "server import options" },
    ],
    returns: "",
  },
  {
    typeName: "Server",
    methodName: "importServers",
    signature: "importServers( importData: ServerExportInterface, options: ServerImportOptions, serverId?: string, serverUrl?: string ): Promise<ServerExportInterface>",
    description: "Imports servers along with their properties",
    params: [
      { name: "importData", type: "ServerExportInterface", description: "server import data" },
      { name: "options", type: "ServerImportOptions", description: "server import options" },
      { name: "serverId", type: "string", description: "Optional server id. If supplied, only the server (and its properties) of that id is imported. Takes priority over serverUrl if both are provided." },
      { name: "serverUrl", type: "string", description: "Optional server url. If supplied, only the server of that url is imported." },
    ],
    returns: "{Promise<ServerExportInterface>} a promise that resolves to a server export object",
  },
  {
    typeName: "Site",
    methodName: "createSiteExportTemplate",
    signature: "createSiteExportTemplate(): SiteExportInterface",
    description: "Create an empty site export template",
    params: [],
    returns: "{SiteExportInterface} an empty site export template",
  },
  {
    typeName: "Site",
    methodName: "readSite",
    signature: "readSite(siteId: string): Promise<SiteSkeleton>",
    description: "Read site by id",
    params: [
      { name: "siteId", type: "string", description: "Site id" },
    ],
    returns: "{Promise<SiteSkeleton>} a promise that resolves to a site object",
  },
  {
    typeName: "Site",
    methodName: "readSites",
    signature: "readSites(): Promise<SiteSkeleton[]>",
    description: "Read all sites.",
    params: [],
    returns: "{Promise<SiteSkeleton[]>} a promise that resolves to an array of site objects",
  },
  {
    typeName: "Site",
    methodName: "exportSite",
    signature: "exportSite(siteId: string): Promise<SiteExportInterface>",
    description: "Export a single site by id. The response can be saved to file as is.",
    params: [
      { name: "siteId", type: "string", description: "Site id" },
    ],
    returns: "{Promise<SiteExportInterface>} Promise resolving to a SiteExportInterface object.",
  },
  {
    typeName: "Site",
    methodName: "exportSites",
    signature: "exportSites(): Promise<SiteExportInterface>",
    description: "Export all sites. The response can be saved to file as is.",
    params: [],
    returns: "{Promise<SiteExportInterface>} Promise resolving to a SiteExportInterface object.",
  },
  {
    typeName: "Site",
    methodName: "updateSite",
    signature: "updateSite(siteId: string, siteData: SiteSkeleton): Promise<SiteSkeleton>",
    description: "Update site",
    params: [
      { name: "siteId", type: "string", description: "site id" },
      { name: "siteData", type: "SiteSkeleton", description: "site data" },
    ],
    returns: "{Promise<SiteSkeleton>} a promise resolving to a site object",
  },
  {
    typeName: "Site",
    methodName: "importSites",
    signature: "importSites( importData: SiteExportInterface, siteId?: string, siteUrl?: string ): Promise<SiteSkeleton[]>",
    description: "Import sites",
    params: [
      { name: "importData", type: "SiteExportInterface", description: "site import data" },
      { name: "siteId", type: "string", description: "Optional site id. If supplied, only the site of that id is imported. Takes priority over siteUrl if both are provided." },
      { name: "siteUrl", type: "string", description: "Optional site url. If supplied, only the site of that url is imported." },
    ],
    returns: "{Promise<SiteSkeleton[]>} the imported sites",
  },
  {
    typeName: "AdminFederation",
    methodName: "createAdminFederationExportTemplate",
    signature: "createAdminFederationExportTemplate(): AdminFederationExportInterface",
    description: "Create an empty idp export template",
    params: [],
    returns: "{AdminFederationExportInterface} an empty idp export template",
  },
  {
    typeName: "AdminFederation",
    methodName: "readAdminFederationProviders",
    signature: "readAdminFederationProviders(): Promise<SocialIdpSkeleton[]>",
    description: "Read all admin federation providers",
    params: [],
    returns: "{Promise} a promise that resolves to an object containing an array of admin federation providers",
  },
  {
    typeName: "AdminFederation",
    methodName: "readAdminFederationProvider",
    signature: "readAdminFederationProvider(providerId: string): Promise<SocialIdpSkeleton>",
    description: "Read admin federation provider",
    params: [
      { name: "providerId", type: "string", description: "social identity provider id/name" },
    ],
    returns: "{Promise<SocialIdpSkeleton>} a promise that resolves a social admin federation object",
  },
  {
    typeName: "AdminFederation",
    methodName: "createAdminFederationProvider",
    signature: "createAdminFederationProvider( providerType: string, providerData: SocialIdpSkeleton, providerId?: string ): Promise<SocialIdpSkeleton>",
    description: "Create admin federation provider",
    params: [
      { name: "providerType", type: "string", description: "social identity provider type" },
      { name: "providerId", type: "string", description: "social identity provider id/name" },
      { name: "providerData", type: "SocialIdpSkeleton", description: "social identity provider data" },
    ],
    returns: "{Promise<SocialIdpSkeleton>} a promise that resolves a social admin federation object",
  },
  {
    typeName: "AdminFederation",
    methodName: "updateAdminFederationProvider",
    signature: "updateAdminFederationProvider( providerType: string, providerId: string, providerData: SocialIdpSkeleton ): Promise<SocialIdpSkeleton>",
    description: "Update or create admin federation provider",
    params: [
      { name: "providerType", type: "string", description: "social identity provider type" },
      { name: "providerId", type: "string", description: "social identity provider id/name" },
      { name: "providerData", type: "SocialIdpSkeleton", description: "social identity provider data" },
    ],
    returns: "{Promise<SocialIdpSkeleton>} a promise that resolves a social admin federation object",
  },
  {
    typeName: "AdminFederation",
    methodName: "deleteAdminFederationProvider",
    signature: "deleteAdminFederationProvider(providerId: string): Promise<SocialIdpSkeleton>",
    description: "Delete admin federation provider by id",
    params: [
      { name: "providerId", type: "String", description: "admin federation provider id/name" },
    ],
    returns: "{Promise} a promise that resolves to an admin federation provider object",
  },
  {
    typeName: "AdminFederation",
    methodName: "exportAdminFederationProvider",
    signature: "exportAdminFederationProvider( providerId: string ): Promise<AdminFederationExportInterface>",
    description: "Export admin federation provider by id",
    params: [
      { name: "providerId", type: "string", description: "provider id/name" },
    ],
    returns: "{Promise<AdminFederationExportInterface>} a promise that resolves to a SocialProviderExportInterface object",
  },
  {
    typeName: "AdminFederation",
    methodName: "exportAdminFederationProviders",
    signature: "exportAdminFederationProviders(): Promise<AdminFederationExportInterface>",
    description: "Export all providers",
    params: [],
    returns: "{Promise<AdminFederationExportInterface>} a promise that resolves to a SocialProviderExportInterface object",
  },
  {
    typeName: "AdminFederation",
    methodName: "importAdminFederationProvider",
    signature: "importAdminFederationProvider( providerId: string, importData: AdminFederationExportInterface ): Promise<SocialIdpSkeleton>",
    description: "Import admin federation provider by id/name",
    params: [
      { name: "providerId", type: "string", description: "provider id/name" },
      { name: "importData", type: "AdminFederationExportInterface", description: "import data" },
    ],
    returns: "",
  },
  {
    typeName: "AdminFederation",
    methodName: "importFirstAdminFederationProvider",
    signature: "importFirstAdminFederationProvider( importData: AdminFederationExportInterface ): Promise<SocialIdpSkeleton>",
    description: "Import first provider",
    params: [
      { name: "importData", type: "AdminFederationExportInterface", description: "import data" },
    ],
    returns: "",
  },
  {
    typeName: "AdminFederation",
    methodName: "importAdminFederationProviders",
    signature: "importAdminFederationProviders( importData: AdminFederationExportInterface ): Promise<SocialIdpSkeleton[]>",
    description: "Import all providers",
    params: [
      { name: "importData", type: "AdminFederationExportInterface", description: "import data" },
    ],
    returns: "",
  },
  {
    typeName: "EnvAIAgent",
    methodName: "enableAIAgentFeature",
    signature: "enableAIAgentFeature(): Promise<any>",
    description: "Enable AI agent feature",
    params: [],
    returns: "{Promise<any>} a promise that resolves to an empty result object if successful",
  },
  {
    typeName: "EnvCSR",
    methodName: "readCSR",
    signature: "readCSR(csrId: string): Promise<CSRResponse>",
    description: "Read CSR by id",
    params: [
      { name: "csrId", type: "string", description: "ID of the CSR" },
    ],
    returns: "{Promise<CSRResponse>} a promise that resolves to a CSRResponse object",
  },
  {
    typeName: "EnvCSR",
    methodName: "readCSRs",
    signature: "readCSRs(): Promise<CSRResponse[]>",
    description: "Read all CSRs",
    params: [],
    returns: "{Promise<CSRResponse[]>} a promise that resolves to an array of CSRResponse objects",
  },
  {
    typeName: "EnvCSR",
    methodName: "createCSR",
    signature: "createCSR(csr: CSR): Promise<CSRResponse>",
    description: "Create CSR",
    params: [
      { name: "csr", type: "CSR", description: "CSR object" },
    ],
    returns: "{Promise<CSRResponse>} a promise that resolves to a CSRResponse object",
  },
  {
    typeName: "EnvCSR",
    methodName: "createCSR2",
    signature: "createCSR2( algorithm: 'rsa' | 'ecdsa', businessCategory: string, city: string, commonName: string, country: string, email: string, jurisdictionCity: string, jurisdictionCountry: string, jurisdictionState: string, organization: string, organizationalUnit: string, postalCode: string, serialNumber: string, state: string, streetAddress: string, subjectAlternativeNames: string[] ): Promise<CSRResponse>",
    description: "Create CSR",
    params: [
      { name: "algorithm", type: "'rsa' | 'ecdsa'", description: "The algorithm for the private key. The encryption algorithm will either be RSA-2048 or ECDSA P-256 depending on the algorithm choice. The default is RSA-2048." },
      { name: "businessCategory", type: "string", description: "Category of business, such as \"Private Organization\", “Government Entity”, “Business Entity”, or “Non-Commercial Entity”. Relevant for EV certificates." },
      { name: "city", type: "string", description: "City" },
      { name: "commonName", type: "string", description: "Domain name that the SSL certificate is securing" },
      { name: "country", type: "string", description: "Two-letter ISO-3166 country code: string[A-Z]{2}" },
      { name: "email", type: "string", description: "Email: string^\\S+@\\S+$" },
      { name: "jurisdictionCity", type: "string", description: "This field contains only information relevant to the Jurisdiction of Incorporation or Registration. Relevant for EV certificates." },
      { name: "jurisdictionCountry", type: "string", description: "This field contains only information relevant to the Jurisdiction of Incorporation or Registration. Relevant for EV certificates." },
      { name: "jurisdictionState", type: "string", description: "This field contains only information relevant to the Jurisdiction of Incorporation or Registration. Relevant for EV certificates." },
      { name: "organization", type: "string", description: "Full name of company" },
      { name: "organizationalUnit", type: "string", description: "Company section or department" },
      { name: "postalCode", type: "string", description: "Zip code" },
      { name: "serialNumber", type: "string", description: "The Registration (or similar) Number assigned to the Subject by the Incorporating or Registration Agency in its Jurisdiction of Incorporation or Registration. Relevant for EV certificates." },
      { name: "state", type: "string", description: "State" },
      { name: "streetAddress", type: "string", description: "Address" },
      { name: "subjectAlternativeNames", type: "string[]", description: "Additional domain or domains that the SSL certificate is securing" },
    ],
    returns: "{Promise<CSRResponse>} a promise that resolves to a CSRResponse object",
  },
  {
    typeName: "EnvCSR",
    methodName: "updateCSR",
    signature: "updateCSR(csrId: string, certificate: string): Promise<CSRResponse>",
    description: "Update CSR",
    params: [
      { name: "csrId", type: "string", description: "ID of the CSR" },
      { name: "certificate", type: "string", description: "The matching signed certificate for the request. This should only be set on update requests to upload the certificate." },
    ],
    returns: "{Promise<CSRResponse>} a promise that resolves to a CSRResponse object",
  },
  {
    typeName: "EnvCSR",
    methodName: "deleteCSR",
    signature: "deleteCSR(csrId: string): Promise<CSRResponse>",
    description: "Delete CSR",
    params: [
      { name: "csrId", type: "string", description: "ID of the CSR" },
    ],
    returns: "{Promise<CSRResponse>} a promise that resolves to a CSRResponse object",
  },
  {
    typeName: "EnvCSR",
    methodName: "deleteCSRs",
    signature: "deleteCSRs(): Promise<CSRResponse[]>",
    description: "Delete all CSRs",
    params: [],
    returns: "{Promise<CSRResponse[]>} a promise that resolves to an array of CSRResponse objects",
  },
  {
    typeName: "EnvCertificate",
    methodName: "readCertificate",
    signature: "readCertificate(certificateId: string): Promise<CertificateResponse>",
    description: "Read certificate by id",
    params: [
      { name: "certificateId", type: "string", description: "certificate id" },
    ],
    returns: "{Promise<CertificateResponse>} a promise that resolves to a certificate object",
  },
  {
    typeName: "EnvCertificate",
    methodName: "readCertificates",
    signature: "readCertificates(noDecode?: boolean): Promise<CertificateResponse[]>",
    description: "Read all certificates",
    params: [
      { name: "noDecode", type: "boolean", description: "Do not decode values (default: false)" },
    ],
    returns: "{Promise<CertificateResponse[]>} a promise that resolves to an array of certificate objects",
  },
  {
    typeName: "EnvCertificate",
    methodName: "createCertificate",
    signature: "createCertificate( active: boolean, certificate: string, privateKey: string, wait?: boolean, interval?: number, retries?: number ): Promise<CertificateResponse>",
    description: "Create certificate",
    params: [
      { name: "active", type: "boolean", description: "The active status of the certificate. Set this to true for the certificate to actively be served." },
      { name: "certificate", type: "string", description: "The PEM formatted certificate." },
      { name: "privateKey", type: "string", description: "The private key for the certificate. For security reasons, only insert requests include this field." },
      { name: "wait", type: "boolean", description: "Wait until certificate is live (use interval and retries to modify default behavior)" },
      { name: "interval", type: "number", description: "Only applies when wait=true: Time (in milliseconds) to wait between retries (default: 5000)" },
      { name: "retries", type: "number", description: "Only applies when wait=true: How many times to retry (default: 24)" },
    ],
    returns: "{Promise<CertificateResponse>} a promise that resolves to a certificate object",
  },
  {
    typeName: "EnvCertificate",
    methodName: "updateCertificate",
    signature: "updateCertificate( certificateId: string, active: boolean ): Promise<CertificateResponse>",
    description: "Update certificate",
    params: [
      { name: "certificateId", type: "string", description: "ID of the certificate" },
      { name: "active", type: "boolean", description: "The active status of the certificate. Set this to true for the certificate to actively be served." },
    ],
    returns: "{Promise<CertificateResponse>} a promise that resolves to a certificate object",
  },
  {
    typeName: "EnvCertificate",
    methodName: "activateCertificate",
    signature: "activateCertificate( certificateId: string, wait?: boolean, interval?: number, retries?: number ): Promise<CertificateResponse>",
    description: "Activate certificate",
    params: [
      { name: "certificateId", type: "string", description: "ID of the certificate" },
      { name: "wait", type: "boolean", description: "Wait until certificate is live (use interval and retries to modify default behavior)" },
      { name: "interval", type: "number", description: "Only applies when wait=true: Time (in milliseconds) to wait between retries (default: 5000)" },
      { name: "retries", type: "number", description: "Only applies when wait=true: How many times to retry (default: 24)" },
    ],
    returns: "{Promise<CertificateResponse>} a promise that resolves to a certificate object",
  },
  {
    typeName: "EnvCertificate",
    methodName: "deactivateCertificate",
    signature: "deactivateCertificate( certificateId: string, wait?: boolean, interval?: number, retries?: number ): Promise<CertificateResponse>",
    description: "Deactivate certificate",
    params: [
      { name: "certificateId", type: "string", description: "ID of the certificate" },
      { name: "wait", type: "boolean", description: "Wait until certificate is live (use interval and retries to modify default behavior)" },
      { name: "interval", type: "number", description: "Only applies when wait=true: Time (in milliseconds) to wait between retries (default: 5000)" },
      { name: "retries", type: "number", description: "Only applies when wait=true: How many times to retry (default: 24)" },
    ],
    returns: "{Promise<CertificateResponse>} a promise that resolves to a certificate object",
  },
  {
    typeName: "EnvCertificate",
    methodName: "isCertificateActive",
    signature: "isCertificateActive(certificateId: string): Promise<boolean>",
    description: "Check if certificate is active",
    params: [
      { name: "certificateId", type: "string", description: "ID of the certificate" },
    ],
    returns: "{Promise<boolean>} a promise that resolves to true or false",
  },
  {
    typeName: "EnvCertificate",
    methodName: "isCertificateLive",
    signature: "isCertificateLive(certificateId: string): Promise<boolean>",
    description: "Check if certificate is live",
    params: [
      { name: "certificateId", type: "string", description: "ID of the certificate" },
    ],
    returns: "{Promise<boolean>} a promise that resolves to true or false",
  },
  {
    typeName: "EnvCertificate",
    methodName: "deleteCertificate",
    signature: "deleteCertificate( certificateId: string, force?: boolean, interval?: number, retries?: number ): Promise<CertificateResponse>",
    description: "Delete certificate",
    params: [
      { name: "certificateId", type: "string", description: "certificate id/name" },
      { name: "force", type: "boolean", description: "force deletion of active certificate by attempting to deactivate it (use interval and retries to modify default behavior)" },
      { name: "interval", type: "number", description: "Only applies when force=true: Time (in milliseconds) to wait between retries (default: 5000)" },
      { name: "retries", type: "number", description: "Only applies when force=true: How many times to retry (default: 24)" },
    ],
    returns: "{Promise<CertificateResponse>} a promise that resolves to a certificate object",
  },
  {
    typeName: "EnvCertificate",
    methodName: "deleteCertificates",
    signature: "deleteCertificates( force?: boolean, interval?: number, retries?: number ): Promise<CertificateResponse[]>",
    description: "Delete all certificates",
    params: [
      { name: "force", type: "boolean", description: "force deletion of active certificate by attempting to deactivate it (use interval and retries to modify default behavior)" },
      { name: "interval", type: "number", description: "Only applies when force=true: Time (in milliseconds) to wait between retries (default: 5000)" },
      { name: "retries", type: "number", description: "Only applies when force=true: How many times to retry (default: 24)" },
    ],
    returns: "{Promise<CertificateResponse>} a promise that resolves to a certificate object",
  },
  {
    typeName: "EnvContentSecurityPolicy",
    methodName: "readEnforcedContentSecurityPolicy",
    signature: "readEnforcedContentSecurityPolicy(): Promise<ContentSecurityPolicy>",
    description: "Read enforced content security policy",
    params: [],
    returns: "{Promise<ContentSecurityPolicy>} a promise that resolves to a ContentSecurityPolicy object",
  },
  {
    typeName: "EnvContentSecurityPolicy",
    methodName: "updateEnforcedContentSecurityPolicy",
    signature: "updateEnforcedContentSecurityPolicy( policy: ContentSecurityPolicy ): Promise<ContentSecurityPolicy>",
    description: "Update enforced content security policy",
    params: [
      { name: "policy", type: "ContentSecurityPolicy", description: "ContentSecurityPolicy object" },
    ],
    returns: "{Promise<ContentSecurityPolicy>} a promise that resolves to a ContentSecurityPolicy object.",
  },
  {
    typeName: "EnvContentSecurityPolicy",
    methodName: "readReportOnlyContentSecurityPolicy",
    signature: "readReportOnlyContentSecurityPolicy(): Promise<ContentSecurityPolicy>",
    description: "Read report-only content security policy",
    params: [],
    returns: "{Promise<ContentSecurityPolicy>} a promise that resolves to a ContentSecurityPolicy object",
  },
  {
    typeName: "EnvContentSecurityPolicy",
    methodName: "updateReportOnlyContentSecurityPolicy",
    signature: "updateReportOnlyContentSecurityPolicy( policy: ContentSecurityPolicy ): Promise<ContentSecurityPolicy>",
    description: "Update report-only content security policy",
    params: [
      { name: "policy", type: "ContentSecurityPolicy", description: "ContentSecurityPolicy object" },
    ],
    returns: "{Promise<ContentSecurityPolicy>} a promise that resolves to a ContentSecurityPolicy object.",
  },
  {
    typeName: "EnvCookieDomains",
    methodName: "readCookieDomains",
    signature: "readCookieDomains(): Promise<CookieDomains>",
    description: "Read cookie domains",
    params: [],
    returns: "{Promise<ContentSecurityPolicy>} a promise that resolves to a CookieDomains object",
  },
  {
    typeName: "EnvCookieDomains",
    methodName: "updateCookieDomains",
    signature: "updateCookieDomains(domains: CookieDomains): Promise<CookieDomains>",
    description: "Update cookie domains",
    params: [
      { name: "domains", type: "CookieDomains", description: "CookieDomains object" },
    ],
    returns: "{Promise<CookieDomains>} a promise that resolves to a CookieDomains object.",
  },
  {
    typeName: "EnvCustomDomains",
    methodName: "verifyCNAME",
    signature: "verifyCNAME(name: string): Promise<boolean>",
    description: "Verify CNAME",
    params: [
      { name: "name", type: "string", description: "CNAME to verify" },
    ],
    returns: "{Promise<boolean>} a promise that resolves to true if successul, false otherwise.",
  },
  {
    typeName: "EnvCustomDomains",
    methodName: "readCustomDomains",
    signature: "readCustomDomains(): Promise<CustomDomains>",
    description: "Read custom domains",
    params: [],
    returns: "{Promise<CustomDomains>} a promise that resolves to a CustomDomains object",
  },
  {
    typeName: "EnvCustomDomains",
    methodName: "updateCustomDomains",
    signature: "updateCustomDomains(domains: CustomDomains): Promise<CustomDomains>",
    description: "Update custom domains",
    params: [
      { name: "domains", type: "CustomDomains", description: "CustomDomains object" },
    ],
    returns: "{Promise<CustomDomains>} a promise that resolves to a CustomDomains object.",
  },
  {
    typeName: "EnvDirectConfigurationSession",
    methodName: "initDirectConfigurationSession",
    signature: "initDirectConfigurationSession(): Promise<DirectConfigurationSessionState>",
    description: "Initiate direct configuration session",
    params: [],
    returns: "{Promise<DirectConfigurationSessionState>} a promise that resolves to a DirectConfigurationSessionState object",
  },
  {
    typeName: "EnvDirectConfigurationSession",
    methodName: "applyDirectConfigurationSession",
    signature: "applyDirectConfigurationSession(): Promise<DirectConfigurationSessionState>",
    description: "Apply direct configuration session",
    params: [],
    returns: "{Promise<DirectConfigurationSessionState>} a promise that resolves to a DirectConfigurationSessionState object",
  },
  {
    typeName: "EnvDirectConfigurationSession",
    methodName: "abortDirectConfigurationSession",
    signature: "abortDirectConfigurationSession(): Promise<DirectConfigurationSessionState>",
    description: "Abort direct configuration session",
    params: [],
    returns: "{Promise<DirectConfigurationSessionState>} a promise that resolves to a DirectConfigurationSessionState object",
  },
  {
    typeName: "EnvDirectConfigurationSession",
    methodName: "readDirectConfigurationSessionState",
    signature: "readDirectConfigurationSessionState(): Promise<DirectConfigurationSessionState>",
    description: "Read direct configuration session state",
    params: [],
    returns: "{Promise<DirectConfigurationSessionState>} a promise that resolves to a DirectConfigurationSessionState object",
  },
  {
    typeName: "EnvFederationEnforcement",
    methodName: "readFederationEnforcement",
    signature: "readFederationEnforcement(): Promise<FederationEnforcement>",
    description: "Read federation enforcement configuration",
    params: [],
    returns: "{Promise<FederationEnforcement>} a promise that resolves to a FederationEnforcement object",
  },
  {
    typeName: "EnvFederationEnforcement",
    methodName: "updateFederationEnforcement",
    signature: "updateFederationEnforcement( config: FederationEnforcement ): Promise<FederationEnforcement>",
    description: "Update federation enforcement configuration",
    params: [
      { name: "config", type: "FederationEnforcement", description: "FederationEnforcement object" },
    ],
    returns: "{Promise<FederationEnforcement>} a promise that resolves to a FederationEnforcement object.",
  },
  {
    typeName: "EnvFederationEnforcement",
    methodName: "enforceFederationFor",
    signature: "enforceFederationFor(group: EnforcementGroup): Promise<FederationEnforcement>",
    description: "Enforce federation for a group of admins",
    params: [
      { name: "group", type: "EnforcementGroup", description: "Group of admins to enforce federation for" },
    ],
    returns: "{Promise<FederationEnforcement>} a promise that resolves to a FederationEnforcement object.",
  },
  {
    typeName: "EnvPromotion",
    methodName: "lockEnvironment",
    signature: "lockEnvironment(): Promise<LockResponse>",
    description: "Lock environment",
    params: [],
    returns: "{Promise<LockResponse>} a promise that resolves to a LockResponse object.",
  },
  {
    typeName: "EnvPromotion",
    methodName: "unlockEnvironment",
    signature: "unlockEnvironment(promotionId: string): Promise<LockResponse>",
    description: "Unlock environment",
    params: [
      { name: "promotionId", type: "string", description: "Promotion id." },
    ],
    returns: "{Promise<LockResponse>} a promise that resolves to a LockResponse object",
  },
  {
    typeName: "EnvPromotion",
    methodName: "readLockStatus",
    signature: "readLockStatus(): Promise<LockStatus>",
    description: "Read lock status",
    params: [],
    returns: "{Promise<LockStatus>} a promise that resolves to a LockStatus object",
  },
  {
    typeName: "EnvPromotion",
    methodName: "promoteConfiguration",
    signature: "promoteConfiguration( config: PromotionRequestConfig ): Promise<PromotionResponse>",
    description: "Promote configuration",
    params: [
      { name: "config", type: "PromotionRequestConfig", description: "Promotion request config" },
    ],
    returns: "{Promise<PromotionResponse>} a promise that resolves to a PromotionResponse object.",
  },
  {
    typeName: "EnvPromotion",
    methodName: "readPromotionStatus",
    signature: "readPromotionStatus(): Promise<PromotionStatus>",
    description: "Read promotion status",
    params: [],
    returns: "{Promise<PromotionStatus>} a promise that resolves to a PromotionStatus object",
  },
  {
    typeName: "EnvPromotion",
    methodName: "readLastPromotionReport",
    signature: "readLastPromotionReport(): Promise<PromotionReport>",
    description: "Read last promotion report",
    params: [],
    returns: "{Promise<PromotionReport>} a promise that resolves to a PromotionReport object",
  },
  {
    typeName: "EnvPromotion",
    methodName: "readPromotionReport",
    signature: "readPromotionReport(reportId: string): Promise<PromotionReport>",
    description: "Read promotion report",
    params: [
      { name: "reportId", type: "string", description: "Promotion id" },
    ],
    returns: "{Promise<PromotionReport>} a promise that resolves to a PromotionReport object",
  },
  {
    typeName: "EnvPromotion",
    methodName: "runProvisionalPromotionReport",
    signature: "runProvisionalPromotionReport(): Promise<PromotionReport>",
    description: "Run a provisional report of changes since the last time the lower environment was promoted to the upper environment. The report generated is for informational purposes only and may not reflect all the changes in a full promotion. A dry-run promotion is always recommended prior to a full promotion between environments.",
    params: [],
    returns: "{Promise<PromotionReport>} a promise that resolves to a PromotionReport object",
  },
  {
    typeName: "EnvPromotion",
    methodName: "runProvisionalRollbackReport",
    signature: "runProvisionalRollbackReport(): Promise<PromotionReport>",
    description: "Run a provisional rollback report of changes when we rollback the configuration to the previous promotion.",
    params: [],
    returns: "{Promise<PromotionReport>} a promise that resolves to a PromotionReport object",
  },
  {
    typeName: "EnvPromotion",
    methodName: "readPromotionReports",
    signature: "readPromotionReports(): Promise<PromotionReportStub[]>",
    description: "Read a list of promotion reports in date order.",
    params: [],
    returns: "{Promise<PromotionReportStub[]>} a promise that resolves to an array of PromotionReportStub objects",
  },
  {
    typeName: "EnvPromotion",
    methodName: "rollbackPromotion",
    signature: "rollbackPromotion(config: RollbackConfig): Promise<RollbackResponse>",
    description: "Rollback a promotion",
    params: [
      { name: "config", type: "RollbackConfig", description: "Rollback config" },
    ],
    returns: "{Promise<RollbackResponse>} a promise that resolves to a RollbackResponse object.",
  },
  {
    typeName: "EnvRelease",
    methodName: "readRelease",
    signature: "readRelease(): Promise<Release>",
    description: "Read release information",
    params: [],
    returns: "{Promise<Release>} a promise that resolves to a Release object",
  },
  {
    typeName: "EnvSSOCookieConfig",
    methodName: "readSSOCookieConfig",
    signature: "readSSOCookieConfig(): Promise<SSOCookieConfig>",
    description: "Read SSO cookie configuration",
    params: [],
    returns: "{Promise<SSOCookieConfig>} a promise that resolves to an SSOCookieConfig object.",
  },
  {
    typeName: "EnvSSOCookieConfig",
    methodName: "resetSSOCookieConfig",
    signature: "resetSSOCookieConfig(): Promise<SSOCookieConfig>",
    description: "Reset SSO cookie configuration",
    params: [],
    returns: "{Promise<SSOCookieConfig>} a promise that resolves to an SSOCookieConfig object.",
  },
  {
    typeName: "EnvSSOCookieConfig",
    methodName: "updateSSOCookieConfig",
    signature: "updateSSOCookieConfig(config: SSOCookieConfig): Promise<SSOCookieConfig>",
    description: "Update SSO cookie configuration",
    params: [
      { name: "config", type: "SSOCookieConfig", description: "SSOCookieConfig object" },
    ],
    returns: "{Promise<SSOCookieConfig>} a promise that resolves to an SSOCookieConfig object.",
  },
  {
    typeName: "EnvServiceAccountScopes",
    methodName: "readServiceAccountScopes",
    signature: "readServiceAccountScopes( flatten?: boolean ): Promise<ServiceAccountScope[] | string[]>",
    description: "Read available service account scopes",
    params: [],
    returns: "{Promise<SSOCookieConfig>} a promise that resolves to an array of ServiceAccountScope objects or a flattened array of scope strings",
  },
  {
    typeName: "EsvCount",
    methodName: "getEsvCount",
    signature: "getEsvCount(): Promise<EsvCountResponse>",
    description: "Get count of ESV secrets and variables in the environment.",
    params: [],
    returns: "{Promise<EsvCountResponse>} a promise that resolves to an object with counts of secrets and variables",
  },
  {
    typeName: "Feature",
    methodName: "readFeatures",
    signature: "readFeatures(): Promise<FeatureInterface[]>",
    description: "Read all features",
    params: [],
    returns: "{Promise<FeatureInterface[]>} a promise that resolves to an array of feature objects",
  },
  {
    typeName: "Feature",
    methodName: "hasFeature",
    signature: "hasFeature(featureId: string): Promise<boolean>",
    description: "Check if feature is available",
    params: [
      { name: "featureId", type: "string", description: "feature id (e.g. 'service-accounts')" },
    ],
    returns: "{Promise<boolean>} a promise that resolves to true if the feature is available and to false otherwise",
  },
  {
    typeName: "Log",
    methodName: "getDefaultNoiseFilter",
    signature: "getDefaultNoiseFilter(): string[]",
    description: "Get default noise filter",
    params: [],
    returns: "{string[]} array of default event types and loggers to be filtered out",
  },
  {
    typeName: "Log",
    methodName: "resolveLevel",
    signature: "resolveLevel(level: string | number): string[]",
    description: "Resolve log level to an array of effective log levels",
    params: [
      { name: "level", type: "", description: "string or numeric log level: 'FATAL', 'ERROR', 'WARN', 'INFO', 'DEBUG', 'TRACE', 'ALL', 0, 1, 2, 3, 4" },
    ],
    returns: "{string[]} array of effective log levels",
  },
  {
    typeName: "Log",
    methodName: "resolvePayloadLevel",
    signature: "resolvePayloadLevel(log: LogEventSkeleton): string",
    description: "Resolve a log event's level",
    params: [
      { name: "log", type: "object", description: "log event" },
    ],
    returns: "{string} log level",
  },
  {
    typeName: "Log",
    methodName: "getLogSources",
    signature: "getLogSources(): Promise<string[]>",
    description: "Get available log sources",
    params: [],
    returns: "{Promise<string[]>} promise resolving to an array of available log sources",
  },
  {
    typeName: "Log",
    methodName: "getLogApiKey",
    signature: "getLogApiKey(keyId: string): Promise<LogApiKey>",
    description: "Get log api key",
    params: [
      { name: "keyId", type: "string", description: "key id" },
    ],
    returns: "{Promise<LogApiKey>} promise resolving to a LogApiKey objects",
  },
  {
    typeName: "Log",
    methodName: "isLogApiKeyValid",
    signature: "isLogApiKeyValid(keyId: string, secret: string): Promise<boolean>",
    description: "Validate log api key and secret",
    params: [
      { name: "keyId", type: "string", description: "log api key id" },
      { name: "secret", type: "string", description: "log api secret" },
    ],
    returns: "{Promise<boolean>} a promise resolving to true if the key is valid, false otherwise",
  },
  {
    typeName: "Log",
    methodName: "getLogApiKeys",
    signature: "getLogApiKeys(): Promise<LogApiKey[]>",
    description: "Get log api keys",
    params: [],
    returns: "{Promise<LogApiKey[]>} promise resolving to an array of LogApiKey objects",
  },
  {
    typeName: "Log",
    methodName: "createLogApiKey",
    signature: "createLogApiKey(keyName: string): Promise<LogApiKey>",
    description: "Create log api key",
    params: [
      { name: "keyName", type: "string", description: "human-readable key name" },
    ],
    returns: "{Promise<LogApiKey>} a promise resolving to an object containing the log api key and secret",
  },
  {
    typeName: "Log",
    methodName: "deleteLogApiKey",
    signature: "deleteLogApiKey(keyId: string): Promise<LogApiKey>",
    description: "Delete log api key",
    params: [
      { name: "keyId", type: "string", description: "key id" },
    ],
    returns: "{Promise<LogApiKey>} a promise resolving to an object containing the log api key",
  },
  {
    typeName: "Log",
    methodName: "deleteLogApiKeys",
    signature: "deleteLogApiKeys(): Promise<LogApiKey[]>",
    description: "Delete all log api keys",
    params: [],
    returns: "{Promise<LogApiKey>} a promise resolving to an array of log api key objects",
  },
  {
    typeName: "Log",
    methodName: "tail",
    signature: "tail(source: string, cookie: string): Promise<PagedResult<LogEventSkeleton>>",
    description: "Tail logs",
    params: [
      { name: "source", type: "string", description: "log source(s) to tail" },
      { name: "cookie", type: "string", description: "paged results cookie" },
    ],
    returns: "{Promise<PagedResult<LogEventSkeleton>>} promise resolving to paged log event result",
  },
  {
    typeName: "Log",
    methodName: "fetch",
    signature: "fetch( source: string, startTs: string, endTs: string, cookie: string, txid: string, filter: string ): Promise<PagedResult<LogEventSkeleton>>",
    description: "Fetch logs",
    params: [
      { name: "source", type: "string", description: "log source(s) to tail" },
      { name: "startTs", type: "string", description: "start timestamp" },
      { name: "endTs", type: "string", description: "end timestamp" },
      { name: "cookie", type: "string", description: "paged results cookie" },
      { name: "txid", type: "string", description: "transaction id" },
      { name: "filter", type: "string", description: "query filter" },
    ],
    returns: "{Promise<PagedResult<LogEventSkeleton>>} promise resolving to paged log event result",
  },
  {
    typeName: "Secret",
    methodName: "readSecrets",
    signature: "readSecrets(): Promise<SecretSkeleton[]>",
    description: "Read all secrets",
    params: [],
    returns: "{Promise<SecretSkeleton[]>} a promise that resolves to an array of secrets",
  },
  {
    typeName: "Secret",
    methodName: "readSecret",
    signature: "readSecret(secretId: string): Promise<SecretSkeleton>",
    description: "Read secret",
    params: [
      { name: "secretId", type: "string", description: "secret id/name" },
    ],
    returns: "{Promise<SecretSkeleton>} a promise that resolves to a secret",
  },
  {
    typeName: "Secret",
    methodName: "readSecretValue",
    signature: "readSecretValue( secretId: string, target?: string, decrypt?: boolean ): Promise<any>",
    description: "Read the value of a secret",
    params: [
      { name: "secretId", type: "string", description: "secret id/name" },
      { name: "target", type: "string", description: "Host URL of target environment to encrypt secret value for" },
      { name: "decrypt", type: "boolean", description: "retrieve secret value in the clear (default: false)" },
    ],
    returns: "{Promise<string>} a promise that resolves to the value of the secret",
  },
  {
    typeName: "Secret",
    methodName: "readSecretValues",
    signature: "readSecretValues( secretIds: string[], target?: string, decrypt?: boolean ): Promise<{ [key: string]: string }>",
    description: "Read the values of an array of secrets",
    params: [
      { name: "secretIds", type: "string", description: "secret id/name" },
      { name: "target", type: "string", description: "Host URL of target environment to encrypt secret values for" },
      { name: "decrypt", type: "boolean", description: "retrieve secret values in the clear (default: false)" },
    ],
    returns: "{Promise<{ [key: string]: string } >} a promise that resolves to a map of secret ids and values",
  },
  {
    typeName: "Secret",
    methodName: "exportSecret",
    signature: "exportSecret( secretId: string, includeActiveValue?: boolean, target?: string ): Promise<SecretsExportInterface>",
    description: "Export secret. The response can be saved to file as is.",
    params: [
      { name: "secretId", type: "string", description: "secret id/name" },
      { name: "includeActiveValue", type: "boolean", description: "include active value of secret (default: false)" },
      { name: "target", type: "string", description: "Host URL of target environment to encrypt secret value for" },
    ],
    returns: "{Promise<SecretsExportInterface>} Promise resolving to a SecretsExportInterface object.",
  },
  {
    typeName: "Secret",
    methodName: "exportSecrets",
    signature: "exportSecrets( includeActiveValues?: boolean, target?: string ): Promise<SecretsExportInterface>",
    description: "Export all secrets",
    params: [
      { name: "includeActiveValues", type: "boolean", description: "include active values of secrets (default: false)" },
      { name: "target", type: "string", description: "Host URL of target environment to encrypt secret values for" },
    ],
    returns: "{Promise<SecretsExportInterface>} Promise resolving to an SecretsExportInterface object.",
  },
  {
    typeName: "Secret",
    methodName: "importSecret",
    signature: "importSecret( secretId: string, importData: SecretsExportInterface, includeActiveValue?: boolean, source?: string ): Promise<SecretSkeleton>",
    description: "Import secret by id",
    params: [
      { name: "secretId", type: "string", description: "secret id/name" },
      { name: "importData", type: "SecretsExportInterface", description: "import data" },
      { name: "includeActiveValue", type: "boolean", description: "include active value of secret (default: false)" },
      { name: "source", type: "string", description: "Host URL of source environment where the secret was exported from" },
    ],
    returns: "{Promise<SecretSkeleton>} imported secret object",
  },
  {
    typeName: "Secret",
    methodName: "importSecrets",
    signature: "importSecrets( importData: SecretsExportInterface, includeActiveValues?: boolean, source?: string ): Promise<SecretSkeleton[]>",
    description: "Import secrets",
    params: [
      { name: "importData", type: "SecretsExportInterface", description: "import data" },
      { name: "includeActiveValues", type: "boolean", description: "include active values of secrets (default: false)" },
      { name: "source", type: "string", description: "Host URL of source environment where the secrets were exported from" },
    ],
    returns: "{Promise<SecretSkeleton[]>} array of imported secret objects",
  },
  {
    typeName: "Secret",
    methodName: "createSecret",
    signature: "createSecret( secretId: string, value: string, description: string, encoding?: string, useInPlaceholders?: boolean ): Promise<SecretSkeleton>",
    description: "Create secret",
    params: [
      { name: "secretId", type: "string", description: "secret id/name" },
      { name: "value", type: "string", description: "secret value" },
      { name: "description", type: "string", description: "secret description" },
      { name: "encoding", type: "string", description: "secret encoding (only `generic` is supported)" },
      { name: "useInPlaceholders", type: "boolean", description: "flag indicating if the secret can be used in placeholders" },
    ],
    returns: "{Promise<SecretSkeleton>} a promise that resolves to a secret",
  },
  {
    typeName: "Secret",
    methodName: "updateSecretDescription",
    signature: "updateSecretDescription(secretId: string, description: string): Promise<any>",
    description: "Update secret description",
    params: [
      { name: "secretId", type: "string", description: "secret id/name" },
      { name: "description", type: "string", description: "secret description" },
    ],
    returns: "{Promise<any>} a promise that resolves to an empty string",
  },
  {
    typeName: "Secret",
    methodName: "deleteSecret",
    signature: "deleteSecret(secretId: string): Promise<SecretSkeleton>",
    description: "Delete secret",
    params: [
      { name: "secretId", type: "string", description: "secret id/name" },
    ],
    returns: "{Promise<SecretSkeleton>} a promise that resolves to a secret object",
  },
  {
    typeName: "Secret",
    methodName: "readVersionsOfSecret",
    signature: "readVersionsOfSecret(secretId: string): Promise<VersionOfSecretSkeleton[]>",
    description: "Read versions of secret",
    params: [
      { name: "secretId", type: "string", description: "secret id/name" },
    ],
    returns: "{Promise<VersionOfSecretSkeleton[]>} a promise that resolves to an array of secret versions",
  },
  {
    typeName: "Secret",
    methodName: "createVersionOfSecret",
    signature: "createVersionOfSecret( secretId: string, value: string ): Promise<VersionOfSecretSkeleton>",
    description: "Create version of secret",
    params: [
      { name: "secretId", type: "string", description: "secret id/name" },
      { name: "value", type: "string", description: "secret value" },
    ],
    returns: "{Promise<VersionOfSecretSkeleton>} a promise that resolves to a version object",
  },
  {
    typeName: "Secret",
    methodName: "readVersionOfSecret",
    signature: "readVersionOfSecret( secretId: string, version: string ): Promise<VersionOfSecretSkeleton>",
    description: "Read version of secret",
    params: [
      { name: "secretId", type: "string", description: "secret id/name" },
      { name: "version", type: "string", description: "secret version" },
    ],
    returns: "{Promise<VersionOfSecretSkeleton>} a promise that resolves to a version object",
  },
  {
    typeName: "Secret",
    methodName: "enableVersionOfSecret",
    signature: "enableVersionOfSecret( secretId: string, version: string ): Promise<VersionOfSecretSkeleton>",
    description: "Enable a version of a secret",
    params: [
      { name: "secretId", type: "string", description: "secret id/name" },
      { name: "version", type: "string", description: "secret version" },
    ],
    returns: "{Promise<VersionOfSecretSkeleton>} a promise that resolves to a status object",
  },
  {
    typeName: "Secret",
    methodName: "disableVersionOfSecret",
    signature: "disableVersionOfSecret( secretId: string, version: string ): Promise<VersionOfSecretSkeleton>",
    description: "Disable a version of a secret",
    params: [
      { name: "secretId", type: "string", description: "secret id/name" },
      { name: "version", type: "string", description: "secret version" },
    ],
    returns: "{Promise<VersionOfSecretSkeleton>} a promise that resolves to a status object",
  },
  {
    typeName: "Secret",
    methodName: "deleteVersionOfSecret",
    signature: "deleteVersionOfSecret( secretId: string, version: string ): Promise<VersionOfSecretSkeleton>",
    description: "Delete version of secret",
    params: [
      { name: "secretId", type: "string", description: "secret id/name" },
      { name: "version", type: "string", description: "secret version" },
    ],
    returns: "{Promise<VersionOfSecretSkeleton>} a promise that resolves to a version object",
  },
  {
    typeName: "ServiceAccount",
    methodName: "isServiceAccountsFeatureAvailable",
    signature: "isServiceAccountsFeatureAvailable(): Promise<boolean>",
    description: "Check if service accounts are available",
    params: [],
    returns: "{Promise<boolean>} true if service accounts are available, false otherwise",
  },
  {
    typeName: "ServiceAccount",
    methodName: "createServiceAccount",
    signature: "createServiceAccount( name: string, description: string, accountStatus: 'active' | 'inactive', scopes: string[], jwks: JwksInterface ): Promise<IdObjectSkeletonInterface>",
    description: "Create service account",
    params: [
      { name: "name", type: "string", description: "Human-readable name of service account" },
      { name: "description", type: "string", description: "Description of service account" },
      { name: "accountStatus", type: "'Active' | 'Inactive'", description: "Service account status" },
      { name: "scopes", type: "string[]", description: "Scopes." },
      { name: "jwks", type: "JwksInterface", description: "Java Web Key Set" },
    ],
    returns: "{Promise<IdObjectSkeletonInterface>} A promise resolving to a service account object",
  },
  {
    typeName: "ServiceAccount",
    methodName: "getServiceAccount",
    signature: "getServiceAccount(serviceAccountId: string): Promise<ServiceAccountType>",
    description: "Get service account",
    params: [
      { name: "serviceAccountId", type: "string", description: "service account id" },
    ],
    returns: "{Promise<ServiceAccountType>} a promise resolving to a service account object",
  },
  {
    typeName: "ServiceAccount",
    methodName: "validateServiceAccount",
    signature: "validateServiceAccount( saId?: string, saJwk?: JwkRsa ): Promise<AccessTokenMetaType | null>",
    description: "Validate service account",
    params: [
      { name: "saId", type: "string", description: "optional service account id" },
      { name: "saJwk", type: "JwkRsa", description: "optional service account JWK" },
    ],
    returns: "{Promise<AccessTokenMetaType | null>} Access token or null if validation fails",
  },
  {
    typeName: "Startup",
    methodName: "checkForUpdates",
    signature: "checkForUpdates(): Promise<Updates>",
    description: "Check for updates that need applying",
    params: [],
    returns: "{Promise<Updates>} true if there are updates that need to be applied, false otherwise",
  },
  {
    typeName: "Startup",
    methodName: "applyUpdates",
    signature: "applyUpdates(wait: boolean, timeout?: number): Promise<boolean>",
    description: "Apply updates",
    params: [
      { name: "wait", type: "boolean", description: "wait for the operation to complete or not" },
      { name: "timeout", type: "number", description: "timeout in milliseconds" },
    ],
    returns: "{Promise<boolean>} true if successful, false otherwise",
  },
  {
    typeName: "Variable",
    methodName: "readVariable",
    signature: "readVariable( variableId: string, noDecode?: boolean ): Promise<VariableSkeleton>",
    description: "Read variable by id/name",
    params: [
      { name: "variableId", type: "string", description: "variable id/name" },
      { name: "noDecode", type: "boolean", description: "Do not decode value (default: false)" },
    ],
    returns: "{Promise<VariableSkeleton>} a promise that resolves to a variable object",
  },
  {
    typeName: "Variable",
    methodName: "readVariables",
    signature: "readVariables(noDecode?: boolean): Promise<VariableSkeleton[]>",
    description: "Read all variables",
    params: [
      { name: "noDecode", type: "boolean", description: "Do not decode values (default: false)" },
    ],
    returns: "{Promise<VariableSkeleton[]>} a promise that resolves to an array of variable objects",
  },
  {
    typeName: "Variable",
    methodName: "exportVariable",
    signature: "exportVariable( variableId: string, noDecode?: boolean ): Promise<VariablesExportInterface>",
    description: "Export variable. The response can be saved to file as is.",
    params: [
      { name: "variableId", type: "string", description: "variable id/name" },
      { name: "noDecode", type: "boolean", description: "Do not decode value (default: false)" },
    ],
    returns: "{Promise<VariablesExportInterface>} Promise resolving to a VariablesExportInterface object.",
  },
  {
    typeName: "Variable",
    methodName: "exportVariables",
    signature: "exportVariables(noDecode?: boolean): Promise<VariablesExportInterface>",
    description: "Export all variables",
    params: [
      { name: "noDecode", type: "boolean", description: "Do not decode values (default: false)" },
    ],
    returns: "{Promise<VariablesExportInterface>} Promise resolving to an VariablesExportInterface object.",
  },
  {
    typeName: "Variable",
    methodName: "importVariable",
    signature: "importVariable( variableId: string, importData: VariablesExportInterface ): Promise<VariableSkeleton>",
    description: "Import variable by id",
    params: [
      { name: "variableId", type: "string", description: "variable id/name" },
      { name: "importData", type: "VariablesExportInterface", description: "import data" },
    ],
    returns: "{Promise<VariableSkeleton>} imported variable object",
  },
  {
    typeName: "Variable",
    methodName: "importVariables",
    signature: "importVariables( importData: VariablesExportInterface ): Promise<VariableSkeleton[]>",
    description: "Import variables",
    params: [
      { name: "importData", type: "VariablesExportInterface", description: "import data" },
    ],
    returns: "{Promise<VariableSkeleton[]>} array of imported variable objects",
  },
  {
    typeName: "Variable",
    methodName: "createVariable",
    signature: "createVariable( variableId: string, value: string, description: string, expressionType?: VariableExpressionType, noEncode?: boolean ): Promise<VariableSkeleton>",
    description: "Create variable",
    params: [
      { name: "variableId", type: "string", description: "variable id/name" },
      { name: "value", type: "string", description: "variable value" },
      { name: "description", type: "string", description: "variable description" },
      { name: "expressionType", type: "VariableExpressionType", description: "type of the value" },
      { name: "noEncode", type: "boolean", description: "do not encode if passing a pre-encoded (base64) value" },
    ],
    returns: "{Promise<VariableSkeleton>} a promise that resolves to a variable object",
  },
  {
    typeName: "Variable",
    methodName: "updateVariable",
    signature: "updateVariable( variableId: string, value: string, description: string, expressionType?: VariableExpressionType, noEncode?: boolean ): Promise<VariableSkeleton>",
    description: "Update or create variable",
    params: [
      { name: "variableId", type: "string", description: "variable id/name" },
      { name: "value", type: "string", description: "variable value" },
      { name: "description", type: "string", description: "variable description" },
      { name: "expressionType", type: "VariableExpressionType", description: "type of the value" },
      { name: "noEncode", type: "boolean", description: "do not encode if passing a pre-encoded (base64) value" },
    ],
    returns: "{Promise<VariableSkeleton>} a promise that resolves to a variable object",
  },
  {
    typeName: "Variable",
    methodName: "updateVariableDescription",
    signature: "updateVariableDescription( variableId: string, description: string ): Promise<VariableSkeleton>",
    description: "Update variable description",
    params: [
      { name: "variableId", type: "string", description: "variable id/name" },
      { name: "description", type: "string", description: "variable description" },
    ],
    returns: "{Promise<VariableSkeleton>} a promise that resolves to a status object",
  },
  {
    typeName: "Variable",
    methodName: "deleteVariable",
    signature: "deleteVariable(variableId: string): Promise<VariableSkeleton>",
    description: "Delete variable by id/name",
    params: [
      { name: "variableId", type: "string", description: "variable id/name" },
    ],
    returns: "{Promise<VariableSkeleton>} a promise that resolves to a variable object",
  },
  {
    typeName: "Variable",
    methodName: "resolveVariable",
    signature: "resolveVariable( input: string, variables: Record<string, VariableSkeleton> ): Promise<string>",
    description: "Attempt to resolve a string to an ESV variable in AIC deployments.",
    params: [
      { name: "input", type: "string", description: "Input string to be evaluated as a possible ESV." },
      { name: "variables", type: "Map<string, VariableSkeleton>", description: "Provide an empty or prepopulated map of ESV variables. The function adds any resolved variables to the map that don't exist." },
    ],
    returns: "{string} Returns the resolved value of the ESV or the original input string",
  },
  {
    typeName: "Variable",
    methodName: "getVariable",
    signature: "getVariable(variableId: string): Promise<VariableSkeleton>",
    description: "Get variable by id/name",
    params: [
      { name: "variableId", type: "string", description: "variable id/name" },
    ],
    returns: "{Promise<VariableSkeleton>} a promise that resolves to a variable object",
  },
  {
    typeName: "Variable",
    methodName: "getVariables",
    signature: "getVariables(): Promise<VariableSkeleton[]>",
    description: "Get all variables",
    params: [],
    returns: "{Promise<VariableSkeleton[]>} a promise that resolves to an array of variable objects",
  },
  {
    typeName: "Variable",
    methodName: "putVariable",
    signature: "putVariable( variableId: string, valueBase64: string, description: string, expressionType?: VariableExpressionType ): Promise<VariableSkeleton>",
    description: "Create variable",
    params: [
      { name: "variableId", type: "string", description: "variable id/name" },
      { name: "valueBase64", type: "string", description: "base64-encoded variable value" },
      { name: "description", type: "string", description: "variable description" },
      { name: "expressionType", type: "VariableExpressionType", description: "type of the value" },
    ],
    returns: "{Promise<VariableSkeleton>} a promise that resolves to a variable object",
  },
  {
    typeName: "Variable",
    methodName: "setVariableDescription",
    signature: "setVariableDescription(variableId: string, description: string): Promise<any>",
    description: "Set variable description",
    params: [
      { name: "variableId", type: "string", description: "variable id/name" },
      { name: "description", type: "string", description: "variable description" },
    ],
    returns: "{Promise<any>} a promise that resolves to an empty string",
  },
  {
    typeName: "WSFed",
    methodName: "readSpConnections",
    signature: "readSpConnections(): Promise<WSFedSpConnection[]>",
    description: "Read SP connections",
    params: [],
    returns: "{Promise<WSFedSpConnection[]>} a promise resolving to an array of SP connection objects",
  },
  {
    typeName: "WSFed",
    methodName: "readSpConnectionById",
    signature: "readSpConnectionById(id: string): Promise<WSFedSpConnection>",
    description: "Read SP connection by ID",
    params: [
      { name: "id", type: "string", description: "SP connection ID" },
    ],
    returns: "",
  },
  {
    typeName: "WSFed",
    methodName: "createSpConnection",
    signature: "createSpConnection( spConnection: WSFedSpConnection ): Promise<WSFedSpConnection>",
    description: "Create SP connection",
    params: [
      { name: "spConnection", type: "WSFedSpConnection", description: "SP connection object" },
    ],
    returns: "{Promise<WSFedSpConnection>} a promise resolving to the created SP connection object",
  },
  {
    typeName: "WSFed",
    methodName: "updateSpConnectionById",
    signature: "updateSpConnectionById( id: string, spConnection: WSFedSpConnection ): Promise<WSFedSpConnection>",
    description: "Update SP connection",
    params: [
      { name: "id", type: "string", description: "SP connection ID" },
      { name: "spConnection", type: "WSFedSpConnection", description: "SP connection object" },
    ],
    returns: "{Promise<WSFedSpConnection>} a promise resolving to the updated SP connection object",
  },
  {
    typeName: "WSFed",
    methodName: "readAuthenticationPolicyContractById",
    signature: "readAuthenticationPolicyContractById( id: string ): Promise<WSFedAuthenticationPolicyContract>",
    description: "Read authentication policy contract by ID",
    params: [
      { name: "id", type: "string", description: "authentication policy contract ID" },
    ],
    returns: "{Promise<WSFedAuthenticationPolicyContract>} a promise resolving to the authentication policy contract object",
  },
  {
    typeName: "WSFed",
    methodName: "createAuthenticationPolicyContract",
    signature: "createAuthenticationPolicyContract( authenticationPolicyContractRequest: WSFedAuthenticationPolicyContractRequest ): Promise<WSFedAuthenticationPolicyContract>",
    description: "Create authentication policy contract",
    params: [
      { name: "authenticationPolicyContractRequest", type: "WSFedAuthenticationPolicyContractRequest", description: "authentication policy contract object" },
    ],
    returns: "{Promise<WSFedAuthenticationPolicyContract>} a promise resolving to the created authentication policy contract object",
  },
  {
    typeName: "WSFed",
    methodName: "updateAuthenticationPolicyContractById",
    signature: "updateAuthenticationPolicyContractById( id: string, authenticationPolicyContractRequest: WSFedAuthenticationPolicyContractRequest ): Promise<WSFedAuthenticationPolicyContract>",
    description: "Update authentication policy contract",
    params: [
      { name: "id", type: "string", description: "authentication policy contract ID" },
      { name: "authenticationPolicyContractRequest", type: "WSFedAuthenticationPolicyContractRequest", description: "authentication policy contract object" },
    ],
    returns: "{Promise<WSFedAuthenticationPolicyContract>} a promise resolving to the updated authentication policy contract object",
  },
  {
    typeName: "WSFed",
    methodName: "generateSigningKeyPair",
    signature: "generateSigningKeyPair(params: WSFedSigningKeyPairRequest): Promise<string>",
    description: "Generate signing key pair add params for key type and key size to be passed to the API. Also, update the return type to be string instead of unknown to be consistent with the rest of the codebase.",
    params: [
      { name: "params", type: "WSFedSigningKeyPairRequest", description: "parameters for generating the signing key pair" },
    ],
    returns: "{Promise<string>} a promise resolving to the generated public key",
  },
  {
    typeName: "WSFed",
    methodName: "readSigningKeyPairById",
    signature: "readSigningKeyPairById(id: string): Promise<WSFedSigningKeyPair>",
    description: "Read signing key pair by id",
    params: [
      { name: "id", type: "string", description: "signing key pair ID" },
    ],
    returns: "{Promise<string>} a promise resolving to the signing key pair object",
  },
  {
    typeName: "WSFed",
    methodName: "readSigningKeyPairCertificate",
    signature: "readSigningKeyPairCertificate(keyPairId: string): Promise<string>",
    description: "Read signing key pair certificate",
    params: [
      { name: "keyPairId", type: "string", description: "signing key pair ID" },
    ],
    returns: "{Promise<string>} a promise resolving to the signing key pair certificate",
  },
  {
    typeName: "WSFed",
    methodName: "updateOrCreateSigningKeyPairCertificate",
    signature: "updateOrCreateSigningKeyPairCertificate( keyPairId: string, certificate: string ): Promise<string>",
    description: "Update or create signing key pair certificate",
    params: [
      { name: "keyPairId", type: "string", description: "signing key pair ID" },
      { name: "certificate", type: "string", description: "the certificate to update or create for the signing key pair" },
    ],
    returns: "{Promise<string>} a promise resolving to the updated or created signing key pair certificate",
  },
  {
    typeName: "WSFed",
    methodName: "deleteSigningKeyPairById",
    signature: "deleteSigningKeyPairById(id: string): Promise<void>",
    description: "Delete signing key pair by id",
    params: [
      { name: "id", type: "string", description: "signing key pair ID" },
    ],
    returns: "{Promise<void>} a promise that resolves when the signing key pair is deleted",
  },
  {
    typeName: "WSFed",
    methodName: "deleteSigningKeyPairCertificate",
    signature: "deleteSigningKeyPairCertificate(keyPairId: string): Promise<void>",
    description: "Delete signing key pair certificate",
    params: [
      { name: "keyPairId", type: "string", description: "signing key pair ID" },
    ],
    returns: "{Promise<void>} a promise that resolves when the signing key pair certificate is deleted",
  },
  {
    typeName: "WSFed",
    methodName: "readFederationInfo",
    signature: "readFederationInfo(): Promise<WSFedFederationInfo>",
    description: "Read federation info",
    params: [],
    returns: "{Promise<WSFedFederationInfo>} a promise resolving to the federation info object",
  },
  {
    typeName: "WSFed",
    methodName: "updateFederationInfo",
    signature: "updateFederationInfo( federationInfo: WSFedFederationInfo ): Promise<WSFedFederationInfo>",
    description: "Update federation info",
    params: [
      { name: "federationInfo", type: "WSFedFederationInfo", description: "federation info object" },
    ],
    returns: "{Promise<WSFedFederationInfo>} a promise resolving to the updated federation info object",
  },
  {
    typeName: "WSFed",
    methodName: "readVirtualHostNames",
    signature: "readVirtualHostNames(): Promise<string[]>",
    description: "Read virtual host names",
    params: [],
    returns: "{Promise<string[]>} a promise resolving to an array of virtual host names",
  },
  {
    typeName: "WSFed",
    methodName: "readIdpAdapters",
    signature: "readIdpAdapters(): Promise<WSFedIdpAdapter[]>",
    description: "Read IdP adapters",
    params: [],
    returns: "{Promise<WSFedIdpAdapter[]>} a promise resolving to an array of IdP adapter objects",
  },
  {
    typeName: "WSFed",
    methodName: "readIdpAdapterById",
    signature: "readIdpAdapterById(id: string): Promise<WSFedIdpAdapter>",
    description: "Read IdP adapter by ID",
    params: [
      { name: "id", type: "string", description: "IdP adapter ID" },
    ],
    returns: "{Promise<WSFedIdpAdapter>} a promise resolving to the IdP adapter object",
  },
  {
    typeName: "WSFed",
    methodName: "updateIdpAdapterById",
    signature: "updateIdpAdapterById( id: string, idpAdapter: WSFedIdpAdapter ): Promise<WSFedIdpAdapter>",
    description: "Update IdP adapter by ID",
    params: [
      { name: "id", type: "string", description: "IdP adapter ID" },
      { name: "idpAdapter", type: "WSFedIdpAdapter", description: "IdP adapter object" },
    ],
    returns: "{Promise<WSFedIdpAdapter>} a promise resolving to the updated IdP adapter object",
  },
  {
    typeName: "WSFed",
    methodName: "createIdpAdapter",
    signature: "createIdpAdapter(idpAdapter: WSFedIdpAdapter): Promise<WSFedIdpAdapter>",
    description: "Create IdP adapter",
    params: [
      { name: "idpAdapter", type: "WSFedIdpAdapter", description: "IdP adapter object" },
    ],
    returns: "{Promise<WSFedIdpAdapter>} a promise resolving to the created IdP adapter object",
  },
  {
    typeName: "WSFed",
    methodName: "deleteIdpAdapterById",
    signature: "deleteIdpAdapterById(id: string): Promise<void>",
    description: "Delete IdP adapter by ID",
    params: [
      { name: "id", type: "string", description: "IdP adapter ID" },
    ],
    returns: "{Promise<void>} a promise that resolves when the IdP adapter is deleted",
  },
  {
    typeName: "WSFed",
    methodName: "readAuthenticationPolicyById",
    signature: "readAuthenticationPolicyById(id: string): Promise<WSFedAuthenticationPolicy>",
    description: "Read authentication policy by ID",
    params: [
      { name: "id", type: "string", description: "Authentication policy ID" },
    ],
    returns: "{Promise<WSFedAuthenticationPolicy>} a promise resolving to the authentication policy object",
  },
  {
    typeName: "WSFed",
    methodName: "createAuthenticationPolicy",
    signature: "createAuthenticationPolicy( authenticationPolicyRequest: WSFedAuthenticationPolicyRequest ): Promise<WSFedAuthenticationPolicy>",
    description: "Create authentication policy",
    params: [
      { name: "authenticationPolicyRequest", type: "WSFedAuthenticationPolicyRequest", description: "authentication policy request object" },
    ],
    returns: "{Promise<WSFedAuthenticationPolicy>} a promise resolving to the created authentication policy object",
  },
  {
    typeName: "WSFed",
    methodName: "updateAuthenticationPolicyById",
    signature: "updateAuthenticationPolicyById( id: string, authenticationPolicyRequest: WSFedAuthenticationPolicyRequest ): Promise<WSFedAuthenticationPolicy>",
    description: "Update authentication policy by ID",
    params: [
      { name: "id", type: "string", description: "Authentication policy ID" },
      { name: "authenticationPolicyRequest", type: "WSFedAuthenticationPolicyRequest", description: "authentication policy request object" },
    ],
    returns: "{Promise<WSFedAuthenticationPolicy>} a promise resolving to the updated authentication policy object",
  },
  {
    typeName: "CertificationTemplate",
    methodName: "createCertificationTemplate",
    signature: "createCertificationTemplate( templateData: CertificationTemplateSkeleton ): Promise<CertificationTemplateSkeleton>",
    description: "Create certification template",
    params: [
      { name: "templateData", type: "CertificationTemplateSkeleton", description: "the certification template object" },
    ],
    returns: "{Promise<CertificationTemplateSkeleton>} a promise that resolves to a certification template object",
  },
  {
    typeName: "CertificationTemplate",
    methodName: "readCertificationTemplate",
    signature: "readCertificationTemplate( templateId: string ): Promise<CertificationTemplateSkeleton>",
    description: "Read certification template",
    params: [
      { name: "templateId", type: "string", description: "The certification template id" },
    ],
    returns: "{Promise<CertificationTemplateSkeleton>} a promise that resolves to a certification template object",
  },
  {
    typeName: "CertificationTemplate",
    methodName: "readCertificationTemplateByName",
    signature: "readCertificationTemplateByName( templateName: string ): Promise<CertificationTemplateSkeleton>",
    description: "Read certification template by its name.",
    params: [
      { name: "templateName", type: "string", description: "the certification template name" },
    ],
    returns: "{Promise<CertificationTemplateSkeleton>} a promise that resolves to a certification template object",
  },
  {
    typeName: "CertificationTemplate",
    methodName: "readCertificationTemplates",
    signature: "readCertificationTemplates(): Promise<CertificationTemplateSkeleton[]>",
    description: "Read all certification templates",
    params: [],
    returns: "{Promise<CertificationTemplateSkeleton[]>} a promise that resolves to an array of certification template objects",
  },
  {
    typeName: "CertificationTemplate",
    methodName: "exportCertificationTemplate",
    signature: "exportCertificationTemplate( templateId: string, options?: CertificationTemplateExportOptions ): Promise<CertificationTemplateExportInterface>",
    description: "Export certification template",
    params: [
      { name: "templateId", type: "string", description: "the certification template id" },
      { name: "options", type: "CertificationTemplateExportOptions", description: "export options" },
    ],
    returns: "{Promise<CertificationTemplateExportInterface>} a promise that resolves to a certification template export object",
  },
  {
    typeName: "CertificationTemplate",
    methodName: "exportCertificationTemplateByName",
    signature: "exportCertificationTemplateByName( templateName: string, options?: CertificationTemplateExportOptions ): Promise<CertificationTemplateExportInterface>",
    description: "Export certification template by its name.",
    params: [
      { name: "templateName", type: "string", description: "the certification template name" },
      { name: "options", type: "CertificationTemplateExportOptions", description: "export options" },
    ],
    returns: "{Promise<CertificationTemplateExportInterface>} a promise that resolves to a certification template export object",
  },
  {
    typeName: "CertificationTemplate",
    methodName: "exportCertificationTemplates",
    signature: "exportCertificationTemplates( options?: CertificationTemplateExportOptions, resultCallback?: ResultCallback<CertificationTemplateExportInterface> ): Promise<CertificationTemplateExportInterface>",
    description: "Export all certification templates",
    params: [
      { name: "options", type: "CertificationTemplateExportOptions", description: "export options" },
      { name: "resultCallback", type: "ResultCallback<CertificationTemplateExportInterface>", description: "Optional callback to process individual results" },
    ],
    returns: "{Promise<CertificationTemplateExportInterface>} a promise that resolves to a certification template export object",
  },
  {
    typeName: "CertificationTemplate",
    methodName: "updateCertificationTemplate",
    signature: "updateCertificationTemplate( templateId: string, templateData: CertificationTemplateSkeleton ): Promise<CertificationTemplateSkeleton>",
    description: "Update certification template",
    params: [
      { name: "templateId", type: "string", description: "the certification template id" },
      { name: "templateData", type: "CertificationTemplateSkeleton", description: "the certification template object" },
    ],
    returns: "{Promise<CertificationTemplateSkeleton>} a promise that resolves to a certification template object",
  },
  {
    typeName: "CertificationTemplate",
    methodName: "importCertificationTemplates",
    signature: "importCertificationTemplates( importData: CertificationTemplateExportInterface, templateId?: string, templateName?: string, options?: CertificationTemplateImportOptions, resultCallback?: ResultCallback<CertificationTemplateSkeleton> ): Promise<CertificationTemplateSkeleton[]>",
    description: "Import certification templates",
    params: [
      { name: "templateId", type: "string", description: "The certification template id. If supplied, only the certification template of that id is imported. Takes priority over templateName if it is provided." },
      { name: "templateName", type: "string", description: "The certification template name. If supplied, only the certification template of that name is imported." },
      { name: "importData", type: "CertificationTemplateExportInterface", description: "certification template import data" },
      { name: "options", type: "CertificationTemplateImportOptions", description: "import options" },
      { name: "resultCallback", type: "ResultCallback<CertificationTemplateSkeleton>", description: "Optional callback to process individual results" },
    ],
    returns: "{Promise<CertificationTemplateSkeleton[]>} the imported certification templates",
  },
  {
    typeName: "CertificationTemplate",
    methodName: "deleteCertificationTemplate",
    signature: "deleteCertificationTemplate( templateId: string ): Promise<CertificationTemplateDeleteSkeleton>",
    description: "Delete certification template",
    params: [
      { name: "templateId", type: "string", description: "the certification template id" },
    ],
    returns: "{Promise<CertificationTemplateDeleteSkeleton>} a promise that resolves to a certification template object",
  },
  {
    typeName: "CertificationTemplate",
    methodName: "deleteCertificationTemplateByName",
    signature: "deleteCertificationTemplateByName( templateName: string ): Promise<CertificationTemplateDeleteSkeleton>",
    description: "Delete certification template by its name.",
    params: [
      { name: "templateName", type: "string", description: "the certification template name" },
    ],
    returns: "{Promise<CertificationTemplateDeleteSkeleton>} a promise that resolves to a certification template object",
  },
  {
    typeName: "CertificationTemplate",
    methodName: "deleteCertificationTemplates",
    signature: "deleteCertificationTemplates( resultCallback?: ResultCallback<CertificationTemplateDeleteSkeleton> ): Promise<CertificationTemplateDeleteSkeleton[]>",
    description: "Delete certification templates",
    params: [
      { name: "resultCallback", type: "ResultCallback", description: "Optional callback to process individual results" },
    ],
    returns: "{Promise<CertificationTemplateDeleteSkeleton[]>} promise that resolves to an array of certification template objects",
  },
  {
    typeName: "IgaEvent",
    methodName: "createEvent",
    signature: "createEvent(eventData: EventSkeleton): Promise<EventSkeleton>",
    description: "Create event",
    params: [
      { name: "eventData", type: "EventSkeleton", description: "the event object" },
    ],
    returns: "{Promise<EventSkeleton>} a promise that resolves to an event object",
  },
  {
    typeName: "IgaEvent",
    methodName: "readEvent",
    signature: "readEvent(eventId: string): Promise<EventSkeleton>",
    description: "Read Event",
    params: [
      { name: "eventId", type: "string", description: "The event id" },
    ],
    returns: "{Promise<EventSkeleton>} A promise that resolves to a event object",
  },
  {
    typeName: "IgaEvent",
    methodName: "readEventByName",
    signature: "readEventByName(eventName: string): Promise<EventSkeleton>",
    description: "Read event by its name. Since names are NOT necessarily unique, this method will throw if it finds multiple of the same name.",
    params: [
      { name: "eventName", type: "string", description: "the event name" },
    ],
    returns: "{Promise<EventSkeleton>} a promise that resolves to a event object",
  },
  {
    typeName: "IgaEvent",
    methodName: "readEvents",
    signature: "readEvents(): Promise<EventSkeleton[]>",
    description: "Read all events",
    params: [],
    returns: "{Promise<EventSkeleton[]>} a promise that resolves to an array of event objects",
  },
  {
    typeName: "IgaEvent",
    methodName: "exportEvent",
    signature: "exportEvent( eventId: string, options?: EventExportOptions ): Promise<EventExportInterface>",
    description: "Export event",
    params: [
      { name: "eventId", type: "string", description: "The event id" },
      { name: "options", type: "EventExportOptions", description: "Export options" },
    ],
    returns: "{Promise<EventExportInterface>} A promise that resolves to a event export object",
  },
  {
    typeName: "IgaEvent",
    methodName: "exportEventByName",
    signature: "exportEventByName( eventName: string, options?: EventExportOptions ): Promise<EventExportInterface>",
    description: "Export event by its name. Since names are NOT necessarily unique, this method will throw if it finds multiple of the same name.",
    params: [
      { name: "eventName", type: "string", description: "the event name" },
      { name: "options", type: "EventExportOptions", description: "export options" },
    ],
    returns: "{Promise<EventExportInterface>} a promise that resolves to a event export object",
  },
  {
    typeName: "IgaEvent",
    methodName: "exportEvents",
    signature: "exportEvents( options?: EventExportOptions, resultCallback?: ResultCallback<EventExportInterface> ): Promise<EventExportInterface>",
    description: "Export all events",
    params: [
      { name: "options", type: "EventExportOptions", description: "Export options" },
      { name: "resultCallback", type: "ResultCallback<EventExportInterface>", description: "Optional callback to process individual results" },
    ],
    returns: "{Promise<EventExportInterface>} A promise that resolves to a event export object",
  },
  {
    typeName: "IgaEvent",
    methodName: "updateEvent",
    signature: "updateEvent( eventId: string, eventData: EventSkeleton ): Promise<EventSkeleton>",
    description: "Update event",
    params: [
      { name: "eventId", type: "string", description: "The event id" },
      { name: "eventData", type: "EventSkeleton", description: "The event object" },
    ],
    returns: "{Promise<EventSkeleton>} A promise that resolves to a event object",
  },
  {
    typeName: "IgaEvent",
    methodName: "importEvents",
    signature: "importEvents( importData: EventExportInterface, eventId?: string, eventName?: string, options?: EventImportOptions, resultCallback?: ResultCallback<EventSkeleton> ): Promise<EventSkeleton[]>",
    description: "Import events",
    params: [
      { name: "eventId", type: "string", description: "The event id. If supplied, only the event of that id is imported. Takes priority over eventName if it is provided." },
      { name: "eventName", type: "string", description: "The event name. If supplied, only the event(s) of that name is imported." },
      { name: "importData", type: "EventExportInterface", description: "Event import data" },
      { name: "options", type: "EventImportOptions", description: "Import options" },
      { name: "resultCallback", type: "ResultCallback<EventSkeleton>", description: "Optional callback to process individual results" },
    ],
    returns: "{Promise<EventSkeleton[]>} The imported events",
  },
  {
    typeName: "IgaEvent",
    methodName: "deleteEvent",
    signature: "deleteEvent(eventId: string): Promise<EventSkeleton>",
    description: "Delete event",
    params: [
      { name: "eventId", type: "string", description: "The event id" },
    ],
    returns: "{Promise<EventSkeleton>} A promise that resolves to a event object",
  },
  {
    typeName: "IgaEvent",
    methodName: "deleteEventByName",
    signature: "deleteEventByName(eventName: string): Promise<EventSkeleton>",
    description: "Delete event by its name. Since names are NOT necessarily unique, this method will throw if it finds multiple of the same name.",
    params: [
      { name: "eventName", type: "string", description: "The event name" },
    ],
    returns: "{Promise<EventSkeleton>} A promise that resolves to a event object",
  },
  {
    typeName: "IgaEvent",
    methodName: "deleteEvents",
    signature: "deleteEvents( resultCallback?: ResultCallback<EventSkeleton> ): Promise<EventSkeleton[]>",
    description: "Delete events",
    params: [
      { name: "resultCallback", type: "ResultCallback", description: "Optional callback to process individual results" },
    ],
    returns: "{Promise<EventSkeleton[]>} A promise that resolves to an array of event objects",
  },
  {
    typeName: "Glossary",
    methodName: "createGlossarySchema",
    signature: "createGlossarySchema( glossarySchemaData: GlossarySchemaItemSkeleton<any> ): Promise<GlossarySchemaItemSkeleton<any>>",
    description: "Create glossary schema",
    params: [
      { name: "glossarySchemaData", type: "GlossarySchemaItemSkeleton", description: "the glossary schema object" },
    ],
    returns: "{Promise<GlossarySchemaItemSkeleton>} a promise that resolves to a glossary schema object",
  },
  {
    typeName: "Glossary",
    methodName: "readGlossarySchema",
    signature: "readGlossarySchema( glossaryId: string ): Promise<GlossarySchemaItemSkeleton<any>>",
    description: "Read glossary schema",
    params: [
      { name: "glossaryId", type: "string", description: "the glossary schema id" },
    ],
    returns: "{Promise<GlossarySchemaItemSkeleton>} a promise that resolves to a glossary schema object",
  },
  {
    typeName: "Glossary",
    methodName: "readGlossarySchemaByNameAndObjectType",
    signature: "readGlossarySchemaByNameAndObjectType( glossaryName: string, objectType: GlossaryObjectType ): Promise<GlossarySchemaItemSkeleton<any>>",
    description: "Read glossary schema by its name and object type",
    params: [
      { name: "glossaryName", type: "string", description: "the glossary schema name" },
      { name: "objectType", type: "GlossaryObjectType", description: "the glossary schema object type" },
    ],
    returns: "{Promise<GlossarySchemaItemSkeleton>} a promise that resolves to a glossary schema object",
  },
  {
    typeName: "Glossary",
    methodName: "readGlossarySchemas",
    signature: "readGlossarySchemas(): Promise<GlossarySchemaItemSkeleton<any>[]>",
    description: "Read all glossary schemas",
    params: [],
    returns: "{Promise<GlossarySchemaItemSkeleton[]>} a promise that resolves to an array of glossary schema objects",
  },
  {
    typeName: "Glossary",
    methodName: "exportGlossarySchema",
    signature: "exportGlossarySchema( glossaryId: string ): Promise<GlossarySchemaExportInterface>",
    description: "Export glossary schema",
    params: [
      { name: "glossaryId", type: "string", description: "the glossary schema id" },
    ],
    returns: "{Promise<GlossarySchemaExportInterface>} a promise that resolves to a glossary schema export object",
  },
  {
    typeName: "Glossary",
    methodName: "exportGlossarySchemaByNameAndObjectType",
    signature: "exportGlossarySchemaByNameAndObjectType( glossaryName: string, objectType: GlossaryObjectType ): Promise<GlossarySchemaExportInterface>",
    description: "Export glossary schema by its name and object type",
    params: [
      { name: "glossaryName", type: "string", description: "the glossary schema name" },
      { name: "objectType", type: "GlossaryObjectType", description: "the glossary schema object type" },
    ],
    returns: "{Promise<GlossarySchemaExportInterface>} a promise that resolves to a glossary schema export object",
  },
  {
    typeName: "Glossary",
    methodName: "exportGlossarySchemas",
    signature: "exportGlossarySchemas( options?: GlossarySchemaExportOptions ): Promise<GlossarySchemaExportInterface>",
    description: "Export all glossary schemas",
    params: [
      { name: "options", type: "GlossarySchemaExportOptions", description: "export options" },
    ],
    returns: "{Promise<GlossarySchemaExportInterface>} a promise that resolves to a glossary schema export object",
  },
  {
    typeName: "Glossary",
    methodName: "updateGlossarySchema",
    signature: "updateGlossarySchema( glossaryId: string, glossarySchemaData: GlossarySchemaItemSkeleton<any> ): Promise<GlossarySchemaItemSkeleton<any>>",
    description: "Update glossary schema",
    params: [
      { name: "glossaryId", type: "string", description: "the glossary schema id" },
      { name: "glossarySchemaData", type: "GlossarySchemaItemSkeleton", description: "the glossary schema object" },
    ],
    returns: "{Promise<GlossarySchemaItemSkeleton>} a promise that resolves to a glossary schema object",
  },
  {
    typeName: "Glossary",
    methodName: "importGlossarySchemas",
    signature: "importGlossarySchemas( importData: GlossarySchemaExportInterface, glossaryId?: string, glossaryName?: string, objectType?: GlossaryObjectType, options?: GlossarySchemaImportOptions, resultCallback?: ResultCallback<GlossarySchemaItemSkeleton<any>> ): Promise<GlossarySchemaItemSkeleton<any>[]>",
    description: "Import glossary schemas",
    params: [
      { name: "glossaryId", type: "string", description: "The glossary schema id.  If supplied, only the glossary schema of that id is imported. Takes priority over glossaryName/objectType if they are all provided." },
      { name: "glossaryName", type: "string", description: "The glossary schema name. If supplied along with the objectType, only the glossary schema of that name/objectType is imported." },
      { name: "objectType", type: "GlossaryObjectType", description: "the glossary schema object type" },
      { name: "importData", type: "GlossarySchemaExportInterface", description: "glossary schema import data" },
      { name: "options", type: "GlossarySchemaImportOptions", description: "import options" },
      { name: "resultCallback", type: "ResultCallback<GlossarySchemaItemSkeleton>", description: "Optional callback to process individual results" },
    ],
    returns: "{Promise<GlossarySchemaItemSkeleton[]>} the imported glossary schemas",
  },
  {
    typeName: "Glossary",
    methodName: "deleteGlossarySchema",
    signature: "deleteGlossarySchema( glossaryId: string ): Promise<GlossarySchemaItemSkeleton<any>>",
    description: "Delete glossary schema",
    params: [
      { name: "glossaryId", type: "string", description: "the glossary schema id" },
    ],
    returns: "{Promise<GlossarySchemaItemSkeleton>} a promise that resolves to a glossary schema object",
  },
  {
    typeName: "Glossary",
    methodName: "deleteGlossarySchemaByNameAndObjectType",
    signature: "deleteGlossarySchemaByNameAndObjectType( glossaryName: string, objectType: GlossaryObjectType ): Promise<GlossarySchemaItemSkeleton<any>>",
    description: "Delete glossary schema by its name and object type",
    params: [
      { name: "glossaryName", type: "string", description: "the glossary schema name" },
      { name: "objectType", type: "GlossaryObjectType", description: "the glossary schema object type" },
    ],
    returns: "{Promise<GlossarySchemaItemSkeleton>} a promise that resolves to a glossary schema object",
  },
  {
    typeName: "Glossary",
    methodName: "deleteGlossarySchemas",
    signature: "deleteGlossarySchemas( resultCallback?: ResultCallback<GlossarySchemaItemSkeleton<any>> ): Promise<GlossarySchemaItemSkeleton<any>[]>",
    description: "Delete glossary schemas",
    params: [
      { name: "resultCallback", type: "ResultCallback", description: "Optional callback to process individual results" },
    ],
    returns: "{Promise<GlossarySchemaItemSkeleton[]>} promise that resolves to an array of glossary schema objects",
  },
  {
    typeName: "RequestForm",
    methodName: "readRequestForm",
    signature: "readRequestForm(formId: string): Promise<RequestFormSkeleton>",
    description: "Read request form",
    params: [
      { name: "formId", type: "string", description: "The request form id" },
    ],
    returns: "{Promise<RequestFormSkeleton>} a promise that resolves to a request form object",
  },
  {
    typeName: "RequestForm",
    methodName: "readRequestFormByName",
    signature: "readRequestFormByName(formName: string): Promise<RequestFormSkeleton>",
    description: "Read request form by its name. Since names are NOT necessarily unique, this method will throw if it finds multiple of the same name.",
    params: [
      { name: "formName", type: "string", description: "the request form name" },
    ],
    returns: "{Promise<RequestFormSkeleton>} a promise that resolves to a request form object",
  },
  {
    typeName: "RequestForm",
    methodName: "readRequestForms",
    signature: "readRequestForms(): Promise<RequestFormSkeleton[]>",
    description: "Read all request forms",
    params: [],
    returns: "{Promise<RequestFormSkeleton[]>} a promise that resolves to an array of request form objects",
  },
  {
    typeName: "RequestForm",
    methodName: "exportRequestForm",
    signature: "exportRequestForm( formId: string, options?: RequestFormExportOptions ): Promise<RequestFormExportInterface>",
    description: "Export request form",
    params: [
      { name: "formId", type: "string", description: "the request form id" },
      { name: "options", type: "RequestFormExportOptions", description: "export options" },
    ],
    returns: "{Promise<RequestFormExportInterface>} a promise that resolves to a request form export object",
  },
  {
    typeName: "RequestForm",
    methodName: "exportRequestFormByName",
    signature: "exportRequestFormByName( formName: string, options?: RequestFormExportOptions ): Promise<RequestFormExportInterface>",
    description: "Export request form by its name. Since names are NOT necessarily unique, this method will throw if it finds multiple of the same name.",
    params: [
      { name: "formName", type: "string", description: "the request form name" },
      { name: "options", type: "RequestFormExportOptions", description: "export options" },
    ],
    returns: "{Promise<RequestFormExportInterface>} a promise that resolves to a request form export object",
  },
  {
    typeName: "RequestForm",
    methodName: "exportRequestForms",
    signature: "exportRequestForms( options?: RequestFormExportOptions, resultCallback?: ResultCallback<RequestFormExportInterface> ): Promise<RequestFormExportInterface>",
    description: "Export all request forms",
    params: [
      { name: "options", type: "RequestFormExportOptions", description: "export options" },
      { name: "resultCallback", type: "ResultCallback<RequestFormExportInterface>", description: "Optional callback to process individual results" },
    ],
    returns: "{Promise<RequestFormExportInterface>} a promise that resolves to a request form export object",
  },
  {
    typeName: "RequestForm",
    methodName: "updateRequestForm",
    signature: "updateRequestForm( formId: string, formData: RequestFormSkeleton ): Promise<RequestFormSkeleton>",
    description: "Update request form",
    params: [
      { name: "formId", type: "string", description: "the request form id" },
      { name: "formData", type: "RequestFormSkeleton", description: "the request form object" },
    ],
    returns: "{Promise<RequestFormSkeleton>} a promise that resolves to a request form object",
  },
  {
    typeName: "RequestForm",
    methodName: "importRequestForms",
    signature: "importRequestForms( importData: RequestFormExportInterface, formId?: string, formName?: string, options?: RequestFormImportOptions, resultCallback?: ResultCallback<RequestFormSkeleton> ): Promise<RequestFormSkeleton[]>",
    description: "Import request forms",
    params: [
      { name: "formId", type: "string", description: "The request form id. If supplied, only the request form of that id is imported. Takes priority over formName if it is provided." },
      { name: "formName", type: "string", description: "The request form name. If supplied, only the request form(s) of that name is imported." },
      { name: "importData", type: "RequestFormExportInterface", description: "request form import data" },
      { name: "options", type: "RequestFormImportOptions", description: "import options" },
      { name: "resultCallback", type: "ResultCallback<RequestFormSkeleton>", description: "Optional callback to process individual results" },
    ],
    returns: "{Promise<RequestFormSkeleton[]>} the imported request forms",
  },
  {
    typeName: "RequestForm",
    methodName: "deleteRequestForm",
    signature: "deleteRequestForm(formId: string): Promise<RequestFormSkeleton>",
    description: "Delete request form",
    params: [
      { name: "formId", type: "string", description: "the request form id" },
    ],
    returns: "{Promise<RequestFormSkeleton>} a promise that resolves to a request form object",
  },
  {
    typeName: "RequestForm",
    methodName: "deleteRequestFormByName",
    signature: "deleteRequestFormByName(formName: string): Promise<RequestFormSkeleton>",
    description: "Delete request form by its name. Since names are NOT necessarily unique, this method will throw if it finds multiple of the same name.",
    params: [
      { name: "formName", type: "string", description: "the request form name" },
    ],
    returns: "{Promise<RequestFormSkeleton>} a promise that resolves to a request form object",
  },
  {
    typeName: "RequestForm",
    methodName: "deleteRequestForms",
    signature: "deleteRequestForms( resultCallback?: ResultCallback<RequestFormSkeleton> ): Promise<RequestFormSkeleton[]>",
    description: "Delete request forms",
    params: [
      { name: "resultCallback", type: "ResultCallback", description: "Optional callback to process individual results" },
    ],
    returns: "{Promise<RequestFormSkeleton[]>} promise that resolves to an array of request form objects",
  },
  {
    typeName: "RequestForm",
    methodName: "deleteOrphanedRequestFormAssignments",
    signature: "deleteOrphanedRequestFormAssignments( formId?: string, workflowId?: string, applicationId?: string, requestTypeId?: string, onlyWorkflow?: boolean, resultCallback?: ResultCallback<RequestFormAssignment> ): Promise<RequestFormAssignment[]>",
    description: "Delete orphaned request form assignments. If no ids are specified, it will remove all orphans",
    params: [
      { name: "formId", type: "string", description: "The optional request form id. If specified, deletes orphaned assignments for the specified form." },
      { name: "workflowId", type: "string", description: "The optional workflow id. If specified, deletes orphaned assignments for the specified workflow." },
      { name: "applicationId", type: "string", description: "The optional application id. If specified, deletes orphaned assignments for the specified application." },
      { name: "requestTypeId", type: "string", description: "The optional request type id. If specified, deletes orphaned assignments for the specified request type." },
      { name: "onlyWorkflow", type: "boolean", description: "Optional flag to return only workflow related assignments. Default: false" },
      { name: "resultCallback", type: "ResultCallback<RequestFormAssignment>", description: "Optional callback to process individual results" },
    ],
    returns: "{RequestFormAssignment[]} the deleted orphaned form assignments",
  },
  {
    typeName: "RequestType",
    methodName: "createRequestType",
    signature: "createRequestType( typeData: RequestTypeSkeleton ): Promise<RequestTypeSkeleton>",
    description: "Create request type",
    params: [
      { name: "typeData", type: "RequestTypeSkeleton", description: "the request type object" },
    ],
    returns: "{Promise<RequestTypeSkeleton>} a promise that resolves to a request type object",
  },
  {
    typeName: "RequestType",
    methodName: "readRequestType",
    signature: "readRequestType(typeId: string): Promise<RequestTypeSkeleton>",
    description: "Read request type",
    params: [
      { name: "typeId", type: "string", description: "the request type id" },
    ],
    returns: "{Promise<RequestTypeSkeleton>} a promise that resolves to a request type object",
  },
  {
    typeName: "RequestType",
    methodName: "readRequestTypeByName",
    signature: "readRequestTypeByName(typeName: string): Promise<RequestTypeSkeleton>",
    description: "Read request type by its display name",
    params: [
      { name: "typeName", type: "string", description: "the request type display name" },
    ],
    returns: "{Promise<RequestTypeSkeleton>} a promise that resolves to a request type object",
  },
  {
    typeName: "RequestType",
    methodName: "readRequestTypes",
    signature: "readRequestTypes(): Promise<RequestTypeSkeleton[]>",
    description: "Read all request types",
    params: [],
    returns: "{Promise<RequestTypeSkeleton[]>} a promise that resolves to an array of request type objects",
  },
  {
    typeName: "RequestType",
    methodName: "exportRequestType",
    signature: "exportRequestType( typeId: string, options?: RequestTypeExportOptions ): Promise<RequestTypeExportInterface>",
    description: "Export request type",
    params: [
      { name: "typeId", type: "string", description: "the request type id" },
      { name: "options", type: "RequestTypeExportOptions", description: "export options" },
    ],
    returns: "{Promise<RequestTypeExportInterface>} a promise that resolves to a request type export object",
  },
  {
    typeName: "RequestType",
    methodName: "exportRequestTypeByName",
    signature: "exportRequestTypeByName( typeName: string, options?: RequestTypeExportOptions ): Promise<RequestTypeExportInterface>",
    description: "Export request type by its display name",
    params: [
      { name: "typeName", type: "string", description: "the request type display name" },
      { name: "options", type: "RequestTypeExportOptions", description: "export options" },
    ],
    returns: "{Promise<RequestTypeExportInterface>} a promise that resolves to a request type export object",
  },
  {
    typeName: "RequestType",
    methodName: "exportRequestTypes",
    signature: "exportRequestTypes( options?: RequestTypeExportOptions ): Promise<RequestTypeExportInterface>",
    description: "Export all request types",
    params: [
      { name: "options", type: "RequestTypeExportOptions", description: "export options" },
    ],
    returns: "{Promise<RequestTypeExportInterface>} a promise that resolves to a request type export object",
  },
  {
    typeName: "RequestType",
    methodName: "updateRequestType",
    signature: "updateRequestType( typeId: string, typeData: RequestTypeSkeleton ): Promise<RequestTypeSkeleton>",
    description: "Update request type",
    params: [
      { name: "typeId", type: "string", description: "the request type id" },
      { name: "typeData", type: "RequestTypeSkeleton", description: "the request type object" },
    ],
    returns: "{Promise<RequestTypeSkeleton>} a promise that resolves to a request type object",
  },
  {
    typeName: "RequestType",
    methodName: "importRequestTypes",
    signature: "importRequestTypes( importData: RequestTypeExportInterface, typeId?: string, typeName?: string, options?: RequestTypeImportOptions, resultCallback?: ResultCallback<RequestTypeSkeleton> ): Promise<RequestTypeSkeleton[]>",
    description: "Import request types",
    params: [
      { name: "typeId", type: "string", description: "The request type id. If supplied, only the request type of that id is imported. Takes priority over typeName if they are all provided." },
      { name: "typeName", type: "string", description: "The request type display name. If supplied, only the request type of that display name is imported." },
      { name: "importData", type: "RequestTypeExportInterface", description: "request type import data" },
      { name: "options", type: "RequestTypeImportOptions", description: "import options" },
      { name: "resultCallback", type: "ResultCallback<RequestTypeSkeleton>", description: "Optional callback to process individual results" },
    ],
    returns: "{Promise<RequestTypeSkeleton[]>} the imported request types",
  },
  {
    typeName: "RequestType",
    methodName: "deleteRequestType",
    signature: "deleteRequestType(typeId: string): Promise<RequestTypeSkeleton>",
    description: "Delete request type",
    params: [
      { name: "typeId", type: "string", description: "the request type id" },
    ],
    returns: "{Promise<RequestTypeSkeleton>} a promise that resolves to a request type object",
  },
  {
    typeName: "RequestType",
    methodName: "deleteRequestTypeByName",
    signature: "deleteRequestTypeByName(typeName: string): Promise<RequestTypeSkeleton>",
    description: "Delete request type by its display name",
    params: [
      { name: "typeName", type: "string", description: "the request type display name" },
    ],
    returns: "{Promise<RequestTypeSkeleton>} a promise that resolves to a request type object",
  },
  {
    typeName: "RequestType",
    methodName: "deleteRequestTypes",
    signature: "deleteRequestTypes( resultCallback?: ResultCallback<RequestTypeSkeleton> ): Promise<RequestTypeSkeleton[]>",
    description: "Delete request types",
    params: [
      { name: "resultCallback", type: "ResultCallback", description: "Optional callback to process individual results" },
    ],
    returns: "{Promise<RequestTypeSkeleton[]>} promise that resolves to an array of request type objects",
  },
  {
    typeName: "Workflow",
    methodName: "publishWorkflow",
    signature: "publishWorkflow(workflowId: string): Promise<WorkflowSkeleton>",
    description: "Publish an existing draft workflow",
    params: [
      { name: "workflowId", type: "string", description: "the workflow id" },
    ],
    returns: "{Promise<WorkflowSkeleton>} a promise that resolves to the published workflow object",
  },
  {
    typeName: "Workflow",
    methodName: "readDraftWorkflow",
    signature: "readDraftWorkflow(workflowId: string): Promise<WorkflowSkeleton>",
    description: "Read draft workflow",
    params: [
      { name: "workflowId", type: "string", description: "the workflow id" },
    ],
    returns: "{Promise<WorkflowSkeleton>} a promise that resolves to a workflow object",
  },
  {
    typeName: "Workflow",
    methodName: "readPublishedWorkflow",
    signature: "readPublishedWorkflow(workflowId: string): Promise<WorkflowSkeleton>",
    description: "Read published workflow",
    params: [
      { name: "workflowId", type: "string", description: "the workflow id" },
    ],
    returns: "{Promise<WorkflowSkeleton>} a promise that resolves to a workflow object",
  },
  {
    typeName: "Workflow",
    methodName: "readWorkflowGroup",
    signature: "readWorkflowGroup(workflowId: string): Promise<WorkflowGroup>",
    description: "Read workflow group",
    params: [
      { name: "workflowId", type: "string", description: "the workflow id" },
    ],
    returns: "{Promise<WorkflowGroup>} a promise that resolves to a grouped workflow object (contains both draft and published versions)",
  },
  {
    typeName: "Workflow",
    methodName: "readWorkflows",
    signature: "readWorkflows(): Promise<WorkflowSkeleton[]>",
    description: "Read all workflows",
    params: [],
    returns: "{Promise<WorkflowSkeleton[]>} a promise that resolves to an array of workflow objects",
  },
  {
    typeName: "Workflow",
    methodName: "readWorkflowGroups",
    signature: "readWorkflowGroups(): Promise<WorkflowGroup[]>",
    description: "Read all workflow groups",
    params: [],
    returns: "{Promise<WorkflowGroup[]>} a promise that resolves to an array of grouped workflow objects (contain both draft and published versions)",
  },
  {
    typeName: "Workflow",
    methodName: "exportWorkflow",
    signature: "exportWorkflow( workflowId: string, options?: WorkflowExportOptions, resultCallback?: ResultCallback<WorkflowExportInterface> ): Promise<WorkflowExportInterface>",
    description: "Export workflow",
    params: [
      { name: "workflowId", type: "string", description: "the workflow id" },
      { name: "options", type: "WorkflowExportOptions", description: "workflow export options" },
      { name: "resultCallback", type: "ResultCallback", description: "Optional callback to process individual results" },
    ],
    returns: "{Promise<WorkflowExportInterface>} a promise that resolves to a workflow export object",
  },
  {
    typeName: "Workflow",
    methodName: "exportWorkflows",
    signature: "exportWorkflows( options?: WorkflowExportOptions, resultCallback?: ResultCallback<WorkflowExportInterface> ): Promise<WorkflowExportInterface>",
    description: "Export all workflows",
    params: [
      { name: "options", type: "WorkflowExportOptions", description: "workflow export options" },
      { name: "resultCallback", type: "ResultCallback", description: "Optional callback to process individual results" },
    ],
    returns: "{Promise<WorkflowExportInterface>} a promise that resolves to a workflow export object",
  },
  {
    typeName: "Workflow",
    methodName: "updateWorkflow",
    signature: "updateWorkflow( workflowId: string, workflowData: WorkflowSkeleton ): Promise<WorkflowSkeleton>",
    description: "Update workflow",
    params: [
      { name: "workflowId", type: "string", description: "the workflow id" },
      { name: "workflowData", type: "WorkflowSkeleton", description: "the workflow object" },
    ],
    returns: "{Promise<WorkflowSkeleton>} a promise that resolves to a workflow object",
  },
  {
    typeName: "Workflow",
    methodName: "importWorkflows",
    signature: "importWorkflows( workflowId: string, importData: WorkflowExportInterface, options?: WorkflowImportOptions, resultCallback?: ResultCallback<WorkflowSkeleton> ): Promise<WorkflowSkeleton[]>",
    description: "Import workflows",
    params: [
      { name: "workflowId", type: "string", description: "The workflow id. If supplied, only the workflow of that id is imported." },
      { name: "importData", type: "WorkflowExportInterface", description: "workflow import data" },
      { name: "options", type: "WorkflowImportOptions", description: "workflow import options" },
      { name: "resultCallback", type: "ResultCallback<WorkflowSkeleton>", description: "Optional callback to process individual results" },
    ],
    returns: "{Promise<WorkflowSkeleton[]>} the imported workflows",
  },
  {
    typeName: "Workflow",
    methodName: "deleteDraftWorkflow",
    signature: "deleteDraftWorkflow(workflowId: string): Promise<WorkflowSkeleton>",
    description: "Delete draft workflow",
    params: [
      { name: "workflowId", type: "string", description: "the workflow id" },
    ],
    returns: "{Promise<WorkflowSkeleton>} a promise that resolves to a workflow object",
  },
  {
    typeName: "Workflow",
    methodName: "deletePublishedWorkflow",
    signature: "deletePublishedWorkflow(workflowId: string): Promise<WorkflowSkeleton>",
    description: "Delete published workflow",
    params: [
      { name: "workflowId", type: "string", description: "the workflow id" },
    ],
    returns: "{Promise<WorkflowSkeleton>} a promise that resolves to a workflow object",
  },
  {
    typeName: "Workflow",
    methodName: "deleteWorkflows",
    signature: "deleteWorkflows( resultCallback?: ResultCallback<WorkflowSkeleton> ): Promise<WorkflowSkeleton[]>",
    description: "Delete workflows",
    params: [
      { name: "resultCallback", type: "ResultCallback", description: "Optional callback to process individual results" },
    ],
    returns: "{Promise<WorkflowSkeleton[]>} promise that resolves to an array of workflow objects",
  },
];
